import pageText from './es-ES/pageText';
import live from './live/es-ES';
import timezone from './es-ES/timezone';
import analysis from './es-ES/analysis';
import activity from './es-ES/activity';
import leaderboardActivity from './es-ES/leaderboardActivity';
import vip from './es-ES/vip';
import commonSelect from './es-ES/commonSelect';
import game from './es-ES/game';
import agent from './es-ES/agent';
import luckySpin from './es-ES/luckySpin';
import webConfig from './es-ES/webConfig';
import adsAgent from './es-ES/adsAgent';
import adsMccAccount from './es-ES/adsMccAccount';
import adsAccount from './es-ES/adsAccount';
import adsReport from './es-ES/adsReport';
import adsUserPushRecord from './es-ES/adsUserPushRecord';
import autoPushRecord from './es-ES/autoPushRecord';
import autoPushConfig from './es-ES/autoPushConfig';
import autoPushStats from './es-ES/autoPushStats';
import manualPushRecord from './es-ES/manualPushRecord';
import smsReport from './es-ES/smsReport';
import smsChannels from './es-ES/smsChannels';
import smsTemplates from './es-ES/smsTemplates';
import smsLogs from './es-ES/smsLogs';
import smsTasks from './es-ES/smsTasks';
import inbox from './es-ES/inbox';
import riskControl from './es-ES/riskControl';
import news from './es-ES/news';
import riskDimension from './es-ES/riskDimension';
import manualTag from './es-ES/manualTag';
import autoTag from './es-ES/autoTag';
import auditReport from './es-ES/auditReport';
import seoPlatform from './es-ES/seoPlatform';
import aiModelConfig from './es-ES/aiModelConfig';

export default {
  ...pageText,
  // Country configuration
  countries: {
    PH: 'PH - Filipinas',
    VN: 'VN - Vietnam',
    TH: 'TH - Tailandia',
    CN: 'CN - China'
  },

  smsChannels,
  smsTemplates,
  smsLogs,
  smsTasks,
  inbox,
  riskControl,
  news,
  ...riskDimension,
  ...manualTag,
  autoTag,
  ...auditReport,
  ...live,
  ...analysis,
  ...activity,
  ...leaderboardActivity,
  ...vip,
  ...commonSelect,
  ...agent,
  ...webConfig,
  ...adsAgent,
  ...adsMccAccount,
  ...adsAccount,
  ...adsReport,
  ...adsUserPushRecord,
  autoPushRecord,
  ...smsReport,
  autoPushConfig,
  autoPushStats,
  manualPushRecord,
  game,
  ...luckySpin,
  seoPlatform,
  aiModelConfig,
  timezone,
    'common.requestFailed': 'Solicitud fallida',
    'common.required': 'Requerido',

  // Login Page
  'login.language': 'Idioma',
  'login.account': 'Cuenta',
  'login.accountRequired': 'La cuenta no puede estar vacía',
  'login.accountPlaceholder': 'Ingrese la cuenta',
  'login.password': 'Contraseña',
  'login.passwordRequired': '¡La contraseña no puede estar vacía!',
  'login.passwordPlaceholder': 'Ingrese la contraseña',
  'login.googleAuthCode': 'Código de autenticación de Google',
  'login.googleAuthPlaceholder': 'Ingrese el código de verificación de Google',
  'login.loginButton': 'Iniciar sesión',
  'login.bindGoogleAuth': 'Por favor vincule el autenticador de Google y luego haga clic en iniciar sesión nuevamente',
  'login.googleAuthMessage': 'Por favor vincule el autenticador de Google antes de iniciar sesión',
  'login.close': 'Cerrar',
  'login.loading': 'Cargando...',

  // IP Whitelist Error
  'ipWhitelist.error.title': '404',
  'ipWhitelist.error.subTitle': 'Su dirección IP no está en la lista blanca, póngase en contacto con el administrador',

  // Left Menu Management
  'indexLtMenu.tab.top': 'Menú Superior',
  'indexLtMenu.tab.middle': 'Menú Intermedio',
  'indexLtMenu.tab.bottom': 'Menú Inferior',
  'indexLtMenu.tab.member': 'Menú de Miembro',
  'indexLtMenu.tab.preferential': 'Menú de Descuentos',
  'indexLtMenu.menuName': 'Nombre del Menú',
  'indexLtMenu.menuIcon': 'Icono',
  'indexLtMenu.ltMenuArea': 'Tipo de Menú',
  'indexLtMenu.menuOrder': 'Orden',
  'indexLtMenu.language': 'Idioma',
  'indexLtMenu.menuLink': 'Enlace/Código',
  'indexLtMenu.ltMenuStatus': 'Estado',
  'indexLtMenu.menuNote': 'Nota',
  'indexLtMenu.menuSection': 'Sección de Menú',
  'indexLtMenu.languageSettings': 'Configuración de Idioma',

  // Bottom Menu Management
  'indexBotMenu.menuName': 'Nombre de navegación',
  'indexBotMenu.menuIcon': 'Icono de Menú',
  'indexBotMenu.menuHighlightIcon': 'Icono de Menú Resaltado',
  'indexBotMenu.menuCode': 'Código de Menú',
  'indexBotMenu.menuOrder': 'Orden',
  'indexBotMenu.language': 'Idioma',
  'indexBotMenu.menuLink': 'Enlace de Página',
  'indexBotMenu.isEnable': 'Estado',
  'indexBotMenu.h5Icon': 'Icono H5',
  'indexBotMenu.pcIcon': 'Icono PC',
  'indexBotMenu.appIcon': 'Icono APP',

  'mlm.promote.userInviteInfoReport': 'Reporte de logro de invitación.xls',
  'mlm.promote.rebate.level': 'Nivel de rakeback',
  'mlm.promote.gameType_1': 'Rakeback de electrónica',
  'mlm.promote.gameType_2': 'Rakeback en vivo',
  'mlm.promote.gameType_3': 'Rakeback de apuestas deportivas',
  'mlm.promote.gameType_4': 'Rakeback de lotería',
  'mlm.promote.gameType_5': 'Rakeback de pesca',
  'mlm.promote.gameType_6': 'Rakeback de ajedrez',
  'mlm.promote.gameType_9': 'Rakeback de apuestas mejoradas',
  'mlm.promote.gameType_10': 'Rakeback de deportes electrónicos',
  'mlm.promote.edit': 'Editar',
  'mlm.promote.edit_cancel': 'Cancelar',
  'mlm.promote.save': 'Guardar',
  'mlm.promote.operation': 'Operación',
  'mlm.promote.inviteNotOpen': 'El logro de invitación no está abierto',
  'mlm.promote.isRebateOpen': '¿Habilitar rakeback de apuestas?',
  'mlm.promote.rebateRatioLimit': 'La relación de rakeback no puede exceder {rebateRatioLimit}',
  'mlm.promote.digital': 'Un número con hasta dos decimales',
  'mlm.promote.start': 'Desde la fecha de inicio',
  'mlm.promote.end': 'Iniciar estadísticas',

  'mlm.promote.invited.isOpen': '¿Habilitar recompensas de invitados?',
  'mlm.promote.invited.amount': 'La cantidad de bonificación que cada invitado puede recibir',
  'mlm.promote.invited.betflow': 'Múltiplo de flujo de apuestas',
  'mlm.promote.invited.domain': 'Nombre de dominio invitado',
  'mlm.promote.invited.domainMsg': 'El formato es nombres de dominio separados por comas',
  'mlm.promote.bonus.invite': 'Recompensas de invitación para todos, {date}',
  'mlm.promote.bonus.rebate': 'Recompensas de rakeback para todos, {date}',
  'mlm.promote.bonus.domain': 'Recompensas de invitación para nombres de dominio designados para todos, {date}',
  'mlm.promote.bonus.point': 'Puntos de recompensa por invitación de todos, {0}',
  'mlm.promote.rebateReprot.title1': 'Número de serie',
  'mlm.promote.rebateReprot.title2': 'Nombre de usuario',
  'mlm.promote.rebateReprot.title3': 'Nivel de Agente',
  'mlm.promote.rebateReprot.title4': 'Fecha de emisión',
  'mlm.promote.rebateReprot.title5': 'Rakeback total',
  'mlm.promote.rebateReprot.view': 'Ver detalles',
  'mlm.promote.rebateReprot.inviteUserAccount': 'Nombre de usuario del invitador',
  'mlm.promote.rebateReprot.Excel': 'Reporte de rakeback de amigos.xls',
  'mlm.promote.rebateReprot.totalSum': 'Recompensas de invitado emitidas: {count} piezas, {sum} yuan',

  'mlm.promote.rebateReprotDetail.title1': 'Número de serie',
  'mlm.promote.rebateReprotDetail.title2': 'Nombre de usuario del invitado',
  'mlm.promote.rebateReprotDetail.title3': 'Nivel de Agente',
  'mlm.promote.rebateReprotDetail.title4': 'Agente Superior',
  'mlm.promote.rebateReprotDetail.title5': 'Nivel de rakeback',
  'mlm.promote.rebateReprotDetail.title6': 'Fecha estadística',
  'mlm.promote.rebateReprotDetail.title7': 'Rakeback total',
  'mlm.promote.rebateReprotDetail.suffix': 'Reflujo/Reporte',

  'mlm.promote.inviteeReprot.title1': 'Número de serie',
  'mlm.promote.inviteeReprot.title2': 'Nombre de usuario del invitado',
  'mlm.promote.inviteeReprot.title3': 'Cantidad de recompensa del invitado',
  'mlm.promote.inviteeReprot.title4': 'Múltiplo de volumen',
  'mlm.promote.inviteeReprot.title5': 'Estado de distribución',
  'mlm.promote.inviteeReprot.title6': 'Nombre de dominio de invitación',
  'mlm.promote.inviteeReprot.title7': 'Nombre de usuario del invitador',
  'mlm.promote.inviteeReprot.Excel': 'Reporte de Recompensa de Invitación.xls',

  'mlm.promote.inviteeReprotDetail.title1': 'Nombre de usuario del invitado',
  'mlm.promote.inviteeReprotDetail.title2': 'Hora de registro',
  'mlm.promote.inviteeReprotDetail.title3': 'Depósitos acumulados',
  'mlm.promote.inviteeReprotDetail.title4': 'Estado',
  'mlm.promote.inviteeReprotDetail.title5': 'Volumen efectivo acumulado',
  'mlm.promote.inviteeReprotDetail.title6': '¿Convertirse en miembro válido?',
  'mlm.promote.inviteeReprotDetail.title7': '¿Es igual a la IP del dispositivo?',
  'mlm.promote.inviteeReprotDetail.title8': 'Hora de finalización',
  'mlm.report.finishDomainStatus51': 'En progreso',
  'mlm.report.finishDomainStatus52': 'Completado',

  'mlm.report.title1': 'Reporte de distribución de descuentos',
  'mlm.report.title2': 'Reporte de Logro de Invitación',
  'mlm.report.title3': 'Reporte de fraude de amigos',
  'mlm.report.title4': 'Reporte de recompensa de invitados',

  'mlm.report.agent': 'Agente MLM',
  'mlm.report.agentLevel1': 'Agente de Nivel 1',
  'mlm.report.agentLevel2': 'Agente de Nivel 2',
  'mlm.report.agentLevel3': 'Agente de Nivel 3',
  'mlm.report.agentLevel4': 'Agente de Nivel 4',
  'mlm.report.agentLevel5': 'Agente de Nivel 5',
  'mlm.report.agentLevel6': 'Agente de Nivel 6',
  'mlm.report.finishDepositStatus21': 'En progreso',
  'mlm.report.finishDepositStatus22': 'Completado',
  'mlm.promote.title1': 'Configuración de logro de invitación',
  'mlm.promote.title2': 'Configuración de rakeback de apuestas',
  'mlm.promote.title3': 'Otras configuraciones',

  'menu.live': 'Gestión de Sala en Vivo',
  'menu.room': 'Lista de Sala en Vivo',
  'menu.audit': 'Auditoría de Sala en Vivo',
  'menu.gift': 'Gestión de Regalos',
  'menu.giftItem': 'Lista de Regalos',
  'menu.instruction': 'Lista de Anuncios de Sala en Vivo',
  'menu.livePlatform': 'Gestión de Plataforma en Vivo',
  'menu.region': 'Gestión de Región en Vivo',
  'menu.filterWord': 'Gestión de Palabras Filtradas',
  'menu.hotWeight': 'Gestión de Peso Caliente',

  'avatar.changePassword': 'Cambiar Contraseña',
  'avatar.oldPassword': 'Contraseña Anterior',
  'avatar.oldPasswordPlaceholder': 'Contraseña Anterior',
  'avatar.newPassword': 'Nueva Contraseña',
  'avatar.newPasswordPlaceholder': 'Nueva Contraseña',
  'avatar.confirmPassword': 'Confirmar Nueva Contraseña',
  'avatar.confirmPasswordPlaceholder': 'Confirmar Contraseña Nuevamente',
  'avatar.passwordMismatch': 'La contraseña nueva y la contraseña de confirmación no coinciden',
  'avatar.changePasswordSuccess': '¡Éxito! ¡Por favor inicie sesión nuevamente!',
  'avatar.oldPasswordRequired': 'Por favor ingrese la contraseña anterior',
  'avatar.newPasswordRequired': 'Por favor ingrese la nueva contraseña',
  'avatar.confirmPasswordRequired': 'Por favor ingrese la contraseña de confirmación',

  'sys.copySuccess': 'Copia exitosa',
  'sys.game': 'Pequeño juego',
  'sys.eventName': 'Nombre de actividad',
  'sys.enterEventName': 'Por favor ingrese el nombre de la actividad',
  'sys.date.type': 'Tipo de tiempo',
  'sys.permanent': 'Validez permanente',
  'sys.validit.period': 'Período de validez',
  'sys.added.prize': 'Premio añadido',
  'sys.noAdded.prize1': 'Aún no se han añadido premios',
  'sys.added.prize2': 'Añadir premios',
  'sys.open': 'Activado',
  'sys.close': 'Desactivado',
  'sys.cashReward': 'Recompensa en efectivo',
  'sys.pointReward': 'Recompensa de puntos',
  'sys.physicalReward': 'Recompensa material',
  'sys.select.prize': 'Recompensas opcionales',
  'sys.select.prizeType': 'Por favor seleccione el tipo de premio',
  'sys.noAdded.prize': 'Aún no se ha añadido premio',
  'sys.activities': 'Contenido de actividad',
  'sys.fillActivities': 'Contenido de actividad',
  'sys.copyImageLink': 'Copiar enlace de imagen',
  'sys.imageLink': 'Enlace de imágenes',
  'sys.addOffer': 'Añadir ofertas',
  'sys.offer': 'Contenido preferencial',
  'sys.enterOffer': 'Por favor complete la oferta',
  'sys.prizeName': 'Nombre del premio',
  'sys.enterPrizeName': 'Por favor ingrese el nombre del premio',
  'sys.prizeType': 'Tipos de premios',
  'sys.prizeType.desc': 'Tipo de premio: ficha de efectivo | cantidad: {prizeAmount} | múltiplo de flujo: {betMultiple}',
  'sys.prizeType.desc1': 'Tipo de premio: otro',
  'sys.prizeType.desc2': '|Probabilidad de premio: {probability}%',
  'sys.prizeType.desc3': '|Orden del premio: {sort}',
  'sys.prizeType.desc4': '|Detalles del premio: {prizeDetail}',
  'sys.prizeType.desc5': 'Nombre del Premio: {prizeName}',
  'sys.ropeType.descInfo': 'Tipo de bonificación: {configRopeType} |cantidad: {configPrizeAmount} |múltiplo de flujo: {betMultiple} |Apuesta acumulada: {accumulationBetAmount} |Tipo de bonificación sintética: {syntheticRopeType} |Número de bonificación sintética: {syntheticQuantity} |Orden de premios: {sort} |Detalles del premio: {configDetail}',
  'sys.prizeList': 'Lista de premios',
  'sys.prizeAmount': 'Cantidad de premio',
  'sys.probability': 'Probabilidad',
  'sys.confirmCancel': 'Confirmar cancelación',
  'sys.content': '¿Desea descalificar al miembro {userAccount} de esta lotería {activityGameType}?',
  'sys.activity.type': 'Tipo de actividad',
  'sys.prize': 'Premio',
  'sys.unspecifiedPrize': 'Sin premio especificado',
  'sys.notIssued': 'No emitido',
  'sys.obsolete': 'A nulificar',
  'sys.upload': 'Cargar',
  'sys.upload.fail1': 'La carga de archivo falló, por favor elimine y cargue nuevamente',
  'sys.upload.picture1': 'Cargar imágenes',
  'sys.upload.imageMaterial': 'Carga de material de imagen',
  'sys.upload.activityPicture': 'Cargar imagen de actividad',
  'sys.pc.activityPicture': 'Imagen de actividad de PC',
  'sys.h5.activityPicture': 'Imagen de actividad móvil',
  'sys.uploadPC.activityPicture': 'Por favor cargue la imagen de actividad de PC',
  'sys.uploadH5.activityPicture': 'Por favor cargue la imagen de actividad móvil',
  'sys.lengthLimit1': 'Ingrese hasta 300 caracteres',
  'sys.lengthLimit2': 'Ingrese hasta 250 caracteres',
  'sys.giftCash2': 'Efectivo gratis',
  'sys.giftCash1': 'Efectivo gratis (%)',
  'sys.maxBonusAmount': 'Bonificación máxima',
  'sys.enterPrizeType': 'Por favor ingrese el tipo de premio',
  'sys.discountCash': 'Efectivo preferencial',
  'sys.giftCash': 'Efectivo gratis (yuan)',
  'sys.giftCashVN': 'Efectivo gratis (VND)',
  'sys.enterAmountPrize': 'Por favor ingrese la cantidad del premio',
  'sys.flowMultiple': 'Múltiplo de flujo',
  'sys.flowMultiple2': 'Múltiplo de flujo',
  'sys.enterFlowMultiple': 'Por favor ingrese el múltiplo de flujo',
  'sys.typeData': 'Por favor ingrese un número de 0-100',
  'sys.enterSort': 'Por favor ingrese la clasificación',
  'sys.winningProbability': 'Probabilidad de ganancia',
  'sys.enterNumber': 'Por favor ingrese un número',
  'sys.prizeDetails': 'Detalles del premio',
  'sys.enterPrizeDetails': 'Por favor ingrese los detalles del premio',
  'sys.rules.number': 'Ingrese hasta 100 caracteres',
  'sys.prizePicture': 'Imágenes de premios',
  'sys.upload.prizePicture': 'Por favor cargue la imagen del premio',
  'sys.pc.prizePicture': 'Imagen de premio de terminal móvil',
  'sys.editOffer': 'Modificar contenido de oferta',
  'sys.addPrize.submit': '¡Por favor añada premios antes de enviar!',
  'sys.add.success': '¡Añadido exitosamente!',
  'common.requestfail': '¡La solicitud falló, por favor intente nuevamente!',
  'sys.drawTime': 'Hora de sorteo afortunado',
  'sys.setPrizes': 'Configurando premios',
  'sys.disqualification': 'Descalificación',
  'sys.addLottery': 'Añadir veces de lotería',
  'sys.allType': 'Todos los tipos',
  'sys.allState': 'Todos los Estados',
  'sys.addNumberDrawsWrong': '¡Error al añadir veces de lotería, por favor intente más tarde!',
  'sys.smallGameType': 'Tipo de pequeño juego',
  'sys.selectSmallGameType': 'Por favor seleccione un tipo de pequeño juego',
  'sys.frequency': 'Frecuencia',
  'sys.enterNumberDraws': 'Por favor ingrese la cantidad de veces de sorteo',
  'sys.failedLoadPrizes': '¡Error al cargar el premio, por favor intente más tarde!',
  'sys.selectPrize': 'Por favor elija un premio',
  'sys.title.deleteBeforeDisable1': '¡Para evitar errores, por favor deshabilite los juegos primero y luego elimínelos!',
  'sys.title.deleteGame': 'Juegos a eliminar: {activityName} después de la eliminación, la cantidad de veces que no se ha realizado lotería por todos los usuarios sobre el juego también se eliminará. Por favor confirme',
  'common.title.createAdmin1': 'Creado por / en',
  'common.title.createAdmin2': 'Creado por / en',
  'sys.expireDate': 'Fecha de vencimiento',
  'sys.viewPrize': 'Ver premios',
  'constants.activityType_11': '1. Rueda de la suerte',
  'constants.activityType_22': '2. Agitar.',
  'sys.addSmallGame': 'Nuevos juegos',
  'bet.select.gameType1': 'Elegir tipo de juego',
  'sys.cancel': 'Cancelar',
  'sys.submit': 'Enviar',
  'sys.totalNumberTime': 'Número total',
  'user.memberAccount': 'Cuenta de membresía',
  'user.memberAccount1': 'Número de cuenta de miembro:',
  'user.checkinTime': 'Hora de registro',
  'sys.time': 'Hora de pago',
  'sys.receivePoints': 'Recibir puntos',
  'sys.receiveState': 'Estado de recepción',
  'sys.receivePrize': 'Recibir premios',
  'sys.rewardType': 'Tipo de recompensa',
  'sys.reward': 'Recompensa',
  'sys.processing': 'En mano',
  'sys.whetherAdditionalRewards': 'Recompensa adicional o no',
  'sys.confirmor': 'Persona que confirma',
  'sys.other': 'Otro',
  'sys.integral': 'Integral',
  'sys.no': 'No',
  'sys.yes': 'Sí',
  'sys.chooseCheckInTime': 'Seleccionar hora de registro',
  'sys.confirmAward': 'Confirmar distribución de premio',
  'sys.confirmWhetherRewardIssued': 'Por favor confirme si la recompensa se emite',
  'finance.title.remark2': 'Observación',
  'sys.pickUpTime': 'Hora de recopilación',
  'sys.choosePickUpTime': 'Seleccionar hora de recopilación',
  'sys.receiveAward': 'Recibir premios',
  'sys.usePoints': 'Usando integral',
  'sys.grade': 'Grado',
  'sys.enterGrade': 'Por favor ingrese nivel',
  'sys.cumulativeBetAmount': 'Apuestas acumuladas',
  'sys.cumulativeBetAmount1': 'Bonificación de actualización acumulada',
  'sys.cumulativeBetAmount2': 'Salario semanal acumulado y bonificación',
  'sys.cumulativeBetAmount3': 'Salario mensual acumulado y bonificación',
  'sys.cumulativeBetAmount4': 'Salario acumulado y bonificación',
  'sys.cumulativeBetAmount5': 'Bonificación de salario semanal',
  'sys.cumulativeBetAmount6': 'Salario mensual y bonificación',
  'sys.cumulativeBetAmount7': 'Bonificación de salario',
  'sys.updateTime': 'Hora de actualización',
  'sys.upgradeUser.name': 'Lista de registros de miembro de actualización.xls',
  'sys.offerName': 'Nombre preferencial',
  'sys.enterOfferName': 'Por favor ingrese el nombre de la oferta',
  'sys.offerName1': 'Nombre de la Oferta:',
  'sys.offerName2': 'Nombre de oferta, nombre de usuario',
  'sys.offerName3': 'Nombre de oferta / nombre de usuario',
  'sys.default.sort': 'Clasificación predeterminada',
  'sys.rank.ascending': 'Clasificación en orden ascendente',
  'sys.rank.descending': 'Clasificación en orden descendente',
  'sys.all.offers': 'Descuento completo',
  'sys.title.delete': 'A punto de eliminar: {bonusName}',
  'sys.mutuallyExclusiveOffer': 'Ofertas exclusivas',
  'sys.addMutuallyExclusiveOffer': 'Añadir oferta exclusiva',
  'sys.addMutuallyExclusiveOfferGroup': 'Añadir grupo de oferta exclusiva',
  'sys.alreadyCollectionRule': 'La regla de reclamo ya existe',
  'sys.rule.name': 'Nombre de regla:',
  'sys.rule.name1': 'Nombre de regla',
  'sys.enterRule.name': 'Por favor ingrese un nombre de regla',
  'sys.collectionRule.description': 'Descripción de la regla de reclamo',
  'sys.addCollectionRule': 'Añadir regla de reclamo',
  'sys.deleteRule': 'A punto de eliminar la regla de recopilación: {groupCode}',
  'sys.confirmDisabled': 'Confirmar deshabilitado',
  'sys.confirmDisabled1': 'A punto de deshabilitar: {groupName}',
  'sys.confirmEnable': 'Confirmar habilitado',
  'sys.confirmEnable1': 'A punto de habilitar: {groupName}',
  'sys.changeSetting': 'Modificar configuración',
  'sys.management': 'Administración',
  'sys.next': 'Próximo paso',
  'sys.addSpecialOffer': 'Nuevas ofertas',
  'sys.addSpecial': 'Nueva oferta',
  'sys.enterNameOfferArticle': 'Por favor ingrese el nombre del artículo de oferta',
  'sys.nameOfferArticle': 'Nombre del artículo',
  'sys.addOfferArticle': 'Nuevos artículos',
  'sys.category': 'Clasificación',
  'sys.selectCategory': 'Por favor seleccione la categoría',
  'sys.displayOrder': 'Orden de visualización',
  'sys.enterDisplayOrder': 'Por favor ingrese el orden de visualización',
  'sys.selectPlatformType': 'Seleccionar tipo de plataforma',
  'sys.platformType': 'Tipo de plataforma',
  'sys.enterPlatformType': 'Por favor ingrese el tipo de plataforma',
  'sys.selectPlatformType1': 'Por favor seleccione la plataforma aplicable',
  'sys.selectApplicationConditions': 'Por favor complete las condiciones de solicitud',
  'sys.computerSideAdvertisingImage': 'Imagen de publicidad de computadora',
  'sys.uploadComputerImage': 'Por favor cargue las imágenes de computadora',
  'sys.mobileImage': 'Imagen de publicidad móvil',
  'sys.uploadMobileImage': 'Por favor cargue imágenes móviles',
  'sys.associatedActivity': 'Actividades relacionadas',
  'sys.selectOfferWantLink': 'Por favor seleccione la oferta que desea asociar',
  'sys.addFail': 'Error de adición',
  'sys.addError': 'Error de adición',
  'sys.newClassification': 'Nueva clasificación',
  'sys.categoryName': 'Nombre de clasificación',
  'sys.fillCategoryName': 'Por favor complete el nombre de clasificación',
  'sys.deleteOffer': 'Ofertas a eliminar: {bonusName}',
  'sys.confirmCopy': 'Confirmar replicación',
  'sys.confirmCopy1': '¿Está seguro de copiar esta oferta?',
  'sys.promptMessage': 'Información de mensaje',
  'sys.disableDelete': 'Por favor deshabilite antes de eliminar.',
  'sys.confirmDelete': '¿Está seguro de eliminar esta oferta?',
  'sys.confirm1': '¿Está seguro de que desea cancelar esta oferta?',
  'sys.effectiveTime': 'Hora efectiva',
  'sys.startTime': 'Hora de inicio:',
  'sys.startTime1': 'Hora de inicio',
  'sys.endTime': 'Hora de finalización:',
  'sys.endTime1': 'Hora de finalización',
  'sys.associationSettings': 'Configuración relacional',
  'sys.cancelRecommend': 'Cancelar recomendación',
  'sys.copy': 'Copiar',
  'sys.modifySort': 'Modificar clasificación',
  'sys.editCopy': 'Edición de copia',
  'sys.platform': 'Plataforma',
  'sys.computer': 'Computadora',
  'sys.mobile': 'Móvil',
  'sys.editCategory': 'Edición de clasificación',
  'sys.name': 'Nombre:',
  'pay.title.sort1': 'Clasificación:',
  'sys.recommendSignature': 'Etiqueta recomendada:',
  'sys.recommendedDisplayImageUpload': 'Carga de imagen de visualización recomendada',
  'sys.recommendedDisplayImage': 'Imágenes de visualización recomendadas',
  'sys.uploadImage': 'Por favor cargue la imagen',
  'sys.collectionMethod': 'Forma de recepción',
  'sys.seletCollectionMethod': 'Por favor seleccione el método de recopilación',
  'sys.automaticDistribution': 'Envío automático',
  'sys.manually': 'Recopilación manual',
  'sys.flowMultipleCalculationAmount': 'Cantidad de cálculo múltiple diario',
  'sys.selectFlowMultipleCalculationAmount': 'Por favor seleccione el múltiplo diario para calcular el monto',
  'sys.returnAmount': 'Cantidad de retorno de agua',
  'sys.withdrawalRestrictions': 'Restricción de retiro',
  'sys.enterWithdrawalRestrictions': 'Por favor ingrese el límite de retiro',
  'sys.doubleWaterWithdrawDiscount': 'El flujo doble puede retirar el descuento',
  'sys.platformPointSettings': 'Configuración de plataforma y puntos',
  'sys.chooseGamePlatform': 'Elegir una plataforma de juego',
  'sys.returnPoint': 'Puntos de retorno de agua',
  'sys.lowest': 'Mínimo',
  'sys.highest': 'Mínimo',
  'sys.yuan': 'Elemento',
  'sys.yuanVN': 'VND',
  'sys.yuanPHP': 'PHP',
  'sys.yuan1': 'Yuan,',
  'sys.validBetReached': 'Apuesta válida alcanzada',
  'sys.storageReach': 'Alcance de almacenamiento',
  'sys.howManyGetDraw': 'Cuántos pueden obtener una oportunidad de sorteo',
  'sys.onThatDay': 'En ese día',
  'sys.twoDays': 'Dos días',
  'sys.activityPeriod': 'Período de actividad',
  'sys.runningWaterAmount': 'Cantidad de agua corriente',
  'sys.platformConditionSettings': 'Configuración de plataforma y condición',
  'sys.selectGamePlatform': 'Seleccionar plataforma de juego por tipo',
  'sys.addedOffers': 'Ofertas añadidas',
  'sys.NoSpecialOffersYet': 'Aún no se han añadido ofertas',
  'sys.selectGiftType': 'Por favor seleccione un tipo de regalo',
  'sys.betAmount': 'Cantidad de apuesta (incluida)',
  'sys.betAmount1': 'Apuesta máxima (excl.)',
  'sys.betAmount2': 'Por favor ingrese la cantidad máxima de apuesta',
  'sys.betAmount3': 'Cantidad de apuesta',
  'sys.enterMinimumAmount': 'Por favor ingrese la cantidad mínima',
  'sys.cashGiftForm': 'Forma de regalo en efectivo',
  'sys.selectCashGiftForm': 'Por favor elija la forma de regalo en efectivo',
  'sys.giveCashFixedAmount': 'Efectivo como cantidad fija',
  'sys.giveCashFixedAmount1': 'Efectivo en proporción fija',
  'sys.numberGifts': 'Frecuencia de presentación',
  'sys.enterNumberGifts': 'Por favor ingrese la cantidad de regalos',
  'sys.enterAmountCashGiven': 'Por favor ingrese la cantidad de efectivo presentado',
  'sys.enterAmountCashGiven1': 'Por favor ingrese la cantidad máxima de efectivo gratuito',
  'sys.enterProportionCashGiven': 'Por favor ingrese la proporción de efectivo gratuito',
  'sys.enterProportionmaxBonusAmount': 'Por favor ingrese la proporción de cantidad máxima',
  'sys.noMoreThan': 'Hasta (yuan)',
  'sys.noMoreThanVN': 'Hasta (VND)',
  'sys.noMoreThan1': 'No más de (puntos)',
  'sys.basicInformationOffer': 'Información básica de la oferta',
  'sys.relatedArticles': 'Artículos relacionados',
  'sys.selectOfferArticleWantLink': 'Por favor seleccione el artículo con el que desea asociarse',
  'sys.pc.sideOfferPicture': 'Imagen de descuento del lado de PC',
  'sys.uploadPc.sideOfferPicture': 'Por favor cargue la imagen de PC',
  'sys.mobile.sideOfferPicture': 'Imagen de beneficios móviles',
  'sys.mobile.accountAuthentication': 'Autenticación de cuenta',
  'sys.mobile.phoneAuthentication': 'Autenticación de teléfono móvil',
  'sys.mobile.emailAuthentication': 'Autenticación de buzón',
  'sys.bindingBankCard': 'Vincular tarjeta bancaria',
  'sys.setPreferentialConditions': 'Establecer términos preferenciales',
  'sys.selectLogType_platform': 'Por favor seleccione una plataforma de juego',
  'sys.noteType': 'Tipo de nota',
  'sys.noteNumber': 'Número de nota',
  'sys.selectDuplicateRequestLimit': 'Por favor seleccione un límite de solicitud repetida',
  'sys.duplicateRequestLimit': 'Restricciones en solicitudes repetidas',
  'sys.payoutAmount': 'Cantidad de lotería',
  'sys.profitAmount': 'Cantidad de ganancia',
  'sys.onlyOnce': 'Solo una vez',
  'sys.everyDay': 'Diariamente',
  'sys.weekly': 'Semanalmente',
  'sys.perMonth': 'Mensualmente',
  'sys.perYear': 'Anualmente',
  'sys.maximumNumberApplications': 'Número máximo de solicitudes',
  'sys.enterMaximumNumberOffers': 'Por favor ingrese el número máximo de veces para aplicar el descuento',
  'sys.expirationTimeType': 'Tipo de tiempo de vencimiento',
  'sys.enterExpirationTimeType': 'Por favor seleccione el tipo de tiempo de vencimiento',
  'sys.day': 'Día',
  'sys.noteExpirationTime': 'Hora de vencimiento de la nota',
  'sys.enterBillingExpirationTime': 'Por favor ingrese la hora de vencimiento de la nota',
  'sys.withdrawalConditions': 'Condiciones de retiro',
  'sys.selectWithdrawalCondition': 'Por favor seleccione las condiciones de retiro',
  'sys.directWithdrawal': 'Retiros directos',
  'sys.flowRequirement': 'Requisitos de flujo',
  'sys.enterFlowRequirement': 'Por favor ingrese el múltiplo actual de retiro preferencial',
  'sys.setBetRequirements': 'Establecer requisitos de nota',
  'sys.addWinningConditions': 'Añadir condiciones de ganancia',
  'sys.winningConditions': 'Condiciones de ganancia (incluidas)',
  'sys.enterWinningCondition': 'Condiciones de ganancia (incluidas)',
  'sys.offerMethod': 'Forma preferencial',
  'sys.noteBetAmountMultiple': 'Múltiplo de cantidad de nota',
  'sys.noteBetAmountMultiple1': 'Múltiplo de cantidad de lotería única',
  'sys.noteBetAmountMultiple2': 'Múltiplo de cantidad de ganancia única de nota',
  'sys.giftPoints': 'Puntos de bonificación (puntos)',
  'sys.giftPoints1': 'Puntos de bonificación (%)',
  'sys.giftPoints2': 'Puntos de presentación',
  'sys.giftPoints3': '|Puntos de bonificación: {giftPoint} puntos',
  'sys.giftPoints4': '|Puntos de bonificación: {pointPercent}% (no más de {maxPoint})',
  'sys.enterGiftPoints2': 'Por favor ingrese puntos',
  'sys.enterNumberBonusPoints': 'Por favor ingrese la cantidad de puntos de bonificación',
  'sys.preferentialAmountBenchmarkRate': 'Tasa de referencia de cantidad preferencial',
  'sys.enterPreferentialAmountBenchmarkRate': 'Por favor ingrese la tasa de referencia de cantidad preferencial',
  'sys.enterPreferentialAmountBenchmarkRate1': 'Por favor ingrese la cantidad de descuento',
  'sys.maximumDiscountAmountLimit': 'Límite de cantidad preferencial máximo',
  'sys.enterMaximumDiscountAmountLimit': 'Por favor ingrese el límite de cantidad preferencial máximo',
  'sys.integralBenchmarkMagnification': 'Múltiplo de referencia integral',
  'sys.integralBenchmarkMagnification1': 'Múltiplo de referencia integral',
  'sys.maximumPointLimit': 'Límite de puntos máximo',
  'sys.enterMaximumPointLimit': 'Por favor ingrese el límite máximo de puntos',
  'sys.memberInformationBindingOffer': 'Oferta de vinculación de información de miembro',
  'sys.binding': 'Información de vinculación',
  'sys.binding1': 'Tipo de vinculación',
  'sys.binding2': 'Por favor seleccione tipo de vinculación',
  'sys.phoneNumber': 'Número de teléfono celular',
  'sys.pequiredDepositAmount': 'Cantidad de depósito requerida',
  'sys.pequiredDepositAmount1': 'Por favor ingrese la cantidad de depósito requerida',
  'sys.giftAmount': 'Cantidad de donación',
  'sys.giftAmount1': 'Por favor ingrese la cantidad de regalo',
  'sys.maximumAmountAvailable': 'Cantidad máxima retirable',
  'sys.maximumAmountAvailable1': 'Por favor aumente la cantidad máxima',
  'sys.continuousDeposit': 'Configuración preferencial para depósito continuo y apuesta (emitida automáticamente de 4:00-4:30 am al día siguiente)',
  'sys.newContinuousDeposit': 'Configuración preferencial para depósito continuo y apuesta',
  'sys.depositRequestAmount': 'Cantidad de depósito requerida',
  'sys.depositRequestAmount1': 'Cantidad actual',
  'sys.consecutiveDays': 'Días consecutivos',
  'sys.cumulativeDays': 'Días acumulados',
  'sys.selectType': 'Por favor seleccione el tipo',
  'sys.continuous': 'Continuidad',
  'sys.cumulative': 'Acumulativo',
  'sys.enterNumberDays': 'Por favor ingrese la cantidad de días',
  'sys.enterCumulativeDays': 'Por favor ingrese los días acumulados',
  'sys.enterAmount': 'Por favor ingrese la cantidad',
  'sys.userEffectiveFlowRequirements': 'Requisitos de flujo efectivo del usuario',
  'sys.enterFlowRequirement1': 'Por favor ingrese requisitos de flujo',
  'sys.continuousDepositBonusSetting': 'Configuración de recompensa de depósito continuo',
  'sys.cumulativeDepositBettingBonusSettings': 'Configuración de bonificación de apuesta de depósito acumulado',
  'sys.di': 'El primero',
  'sys.song': 'Dar',
  'sys.bei': 'Veces',
  'sys.wu': 'Nada',
  'sys.you': 'Sí',
  'sys.extraBonus': '¿Hay recompensa extra?',
  'sys.extraDelivery': 'Entrega extra',
  'sys.addedOffer': 'Oferta añadida',
  'sys.msg1': 'No es necesario solicitar envío automático a las 04:00 am al día siguiente',
  'sys.applicationConditions': 'Condiciones de solicitud',
  'sys.selectCategory1': 'Por favor seleccione la categoría',
  'sys.category1': 'Categoría de propiedad',
  'sys.selectDepositChannel': 'Por favor seleccione un canal de depósito',
  'sys.depositChannel': 'Canal de depósito',
  'sys.msg2': 'La cantidad de depósito máximo debe ser mayor que la cantidad de depósito mínimo',
  'sys.msg3': 'Depósito mínimo (incluido)',
  'sys.msg4': 'Por favor ingrese la cantidad mínima de depósito',
  'sys.msg5': 'Depósito máximo (excluyendo)',
  'sys.msg6': 'Por favor ingrese la cantidad máxima de depósito',
  'sys.msg7': 'Efectivo presentado en rango de depósito fijo',
  'sys.pre-purchaseOffer': 'Pre oferta - condiciones de retiro',
  'sys.pre-purchaseOffer1': 'Pre descuento',
  'sys.postOffer': 'Post oferta - condiciones de reclamo',
  'sys.postOffer1': 'Post concesión',
  'sys.minusDiscount': 'Restar concesiones',
  'sys.accountType': 'Tipo de cuenta',
  'sys.accountType1': 'Por favor seleccione el tipo de cuenta',
  'sys.masterAccount': 'Cuenta principal',
  'sys.gameAccount': 'Cuentas de juego',
  'sys.gameAccountType': 'Tipo de cuenta de juego',
  'sys.majorClass': 'Clase grande',
  'sys.account': 'Cuenta',
  'sys.enterAccount1': 'Por favor seleccione una cuenta de depósito',
  'sys.depositOrder': 'Orden de depósitos',
  'sys.enterDepositOrder': 'Por favor seleccione el orden de depósito',
  'sys.nthDeposit': 'Enésimo depósito',
  'sys.nthDeposit1': 'No primeros n depósitos',
  'sys.nthDeposit2': 'Todos los depósitos',
  'sys.nthDeposit3': 'Complete el valor de n',
  'sys.nthDeposits': 'Enésimo depósito',
  'sys.greaterNthDeposit': 'Mayor que el enésimo depósito',
  'sys.enterNumberDepositLimits': 'Por favor ingrese la cantidad de restricciones de depósito',
  'sys.flowType': 'Tipo de flujo',
  'sys.selectypeFlow': 'Tipo de flujo',
  'sys.msg8': 'Establecer múltiples tuberías globalmente',
  'sys.msg9': 'Establecer múltiple de flujo para contenido preferencial único',
  'sys.msg10': 'La oferta ha sido añadida (cambiar el tipo de flujo cancelará todas las ofertas. Si ha sido editada, debe editarse nuevamente. )',
  'sys.receivingValidityPeriod': 'Período de validez',
  'sys.enterExpirationDate': 'Ingrese el período de validez',
  'sys.pointGiftForm': 'Forma de bono',
  'sys.selectPointGiftForm': 'Seleccione la forma de bono',
  'sys.givePointsFixedAmount': 'Puntos de bono en cantidad fija',
  'sys.givePointsFixedAmount1': 'Puntos de bono en proporción fija',
  'sys.enterProportionBonusPoints': 'Ingrese la proporción de puntos de bono',
  'sys.enterMaximumCreditLimit': 'Ingrese la proporción de puntos de bono',
  'sys.msg11': 'Tiempo real: depósito junto con el pago',
  'sys.uploadH5Image': 'Cargue la imagen H5',
  'sys.msg12': 'Tamaño móvil: 718 * 158px',
  'sys.check-inPointSetting': 'Configuración de puntos de registro',
  'sys.check-inDaysSetting': 'Configuración de días de registro',
  'sys.check-in': 'Registro',
  'sys.check-in1': 'Registro',
  'sys.msg13': 'Configuración de bono extra de días fijos',
  'sys.doubleWater': 'Flujo doble puede ser levantado',
  'sys.pointRedemptionSettings': 'Configuración de canje de puntos',
  'sys.exchange': 'canje',
  'sys.msg14': 'Requisitos de persona recomendada',
  'sys.msg15': 'Dentro de días',
  'sys.rewarderSelection': 'Selección de parte de recompensa',
  'sys.invitees': 'Persona invitada',
  'sys.invitees1': 'Invitador',
  'sys.inviterReward': 'Recompensa de invitados',
  'sys.inviterReward1': 'Ingrese la recompensa del invitado',
  'sys.inviterReward2': 'Recompensa de invitados',
  'sys.inviterReward3': 'Ingrese la recompensa del invitado',
  'sys.unlimited': '¿Es ilimitado?',
  'sys.discountPoints': 'Puntos preferenciales',
  'sys.preferential': 'Preferencial',
  'sys.doubleWater1': 'Flujo doble',
  'sys.maxWithdrawal': 'Retiro máximo',
  'sys.enterMaxWithdrawalAmount': 'Ingrese el monto de retiro máximo',
  'sys.msg16': 'Configuración de plataforma y condición (entrega regular a las 04:00 diariamente)',
  'sys.msg17': 'El múltiple de pago máximo debe ser mayor que el monto de pago mínimo',
  'sys.msg18': 'El pago es mayor que el múltiple efectivo (incluyendo)',
  'sys.msg19': 'Ingrese el pago mínimo mayor que el múltiple efectivo',
  'sys.msg20': 'El pago más alto es mayor que el múltiple efectivo (excluyendo)',
  'sys.msg21': 'Ingrese el pago máximo mayor que el múltiple efectivo',
  'sys.msg22': 'Múltiple de apuesta gratuita',
  'sys.msg23': 'Ingrese las veces de apuesta gratuita',
  'sys.msg25': 'Límite de retiro, n veces del retirable actual',
  'sys.msg300': 'Recogidas diarias',
  'sys.enterDailyPickupCount': 'Ingrese el número de recogidas diarias',
  'sys.selectLeastOne': 'Seleccione al menos uno',
  'sys.addUpgradeConditions': 'Agregar condición de actualización',
  'sys.msg26': 'Apuesta requerida',
  'sys.msg27': 'Ingrese el monto requerido',
  'sys.msg32': 'Condiciones de actualización, (El salario semanal se distribuirá el miércoles y el salario mensual el 3 de cada mes)',
  'sys.msg33': 'Aún no se han añadido condiciones de actualización',
  'sys.upgradeGift': 'Regalos de actualización',
  'sys.enterUpgradeGift': 'Ingrese el regalo de actualización',
  'sys.platformLevelSettings': 'Configuración de plataforma y nivel',
  'sys.msg34': 'Efectivo gratuito: {giftMoney} yuan',
  'sys.msg34VN': 'Efectivo gratuito: {giftMoney} VND',
  'sys.msg35': 'Efectivo gratuito: {giftMoney}% (no más de {maxMoney})',
  'sys.msg35VN': 'Efectivo gratuito: {giftMoney}% (no más de {maxMoney} VND)',
  'sys.msg36': '|Requisitos de flujo: {betMultiple} veces',
  'sys.msg37': 'Apuesta acumulada: {minBetAmount} ~ {maxBetAmount}',
  'sys.msg38': '|Veces de regalo: {giftCount} veces',
  'sys.selectLeastOneGamePlatform': '¡Seleccione al menos una plataforma de juego!',
  'sys.setLeastOneObtainingMethod': 'Establezca al menos un método de obtención',
  'sys.editLeastOneOffer': 'Edite al menos una oferta',
  'sys.vip1': '¡La proporción de devolución de agua de VIP {vipLevel} debe ser mayor o igual a 0!',
  'sys.vip2': '¡El monto máximo de VIP {vipLevel} debe ser superior al monto mínimo!',
  'sys.vip3': 'Rellene la proporción de devolución de agua de VIP {vipLevel}',
  'sys.vip4': 'Rellene el monto de devolución de agua mínimo de VIP {vipLevel}',
  'sys.vip5': 'Rellene el monto de devolución de agua máximo de VIP {vipLevel}',
  'sys.addBetConditionBeforeSubmitting': 'Agregue condiciones de nota antes de enviar',
  'sys.noteTailNumber': 'Número final de nota única: {conditionValue1}',
  'sys.noteTailNumber1': 'Monto de apuesta de nota de nota: {conditionValue1}',
  'sys.noteTailNumber2': 'Nota: monto de lotería única: {conditionValue1}',
  'sys.noteTailNumber3': 'Monto de ganancia única de nota: {conditionValue1}',
  'sys.msg39': 'Método fijo: monto preferencial: {giftMoney} yuan, puntos: {giftPoint}',
  'sys.msg39VN': 'Método fijo: monto preferencial: {giftMoney} VND, puntos: {giftPoint}',
  'sys.msg40': 'Método de monto de apuesta: tasa de múltiple de monto: {moneyPercent}, máximo no más de: {maxMoney} yuan|',
  'sys.msg40VN': 'Método de monto de apuesta: tasa de múltiple de monto: {moneyPercent}, máximo no más de: {maxMoney} VND|',
  'sys.msg43': 'Método de pago: tasa múltiple integral: {pointPercent}, máximo no más de: {maxPoint}',
  'sys.msg44': 'Método de monto de ganancia: relación múltiple de monto: {moneyPercent}, el máximo no es más de: {maxMoney} yuan',
  'sys.msg44VN': 'Método de monto de ganancia: relación múltiple de monto: {moneyPercent}, el máximo no es más de: {maxMoney} VND',
  'sys.msg45': 'Método de monto de ganancia: tasa múltiple integral: {pointPercent}, máximo no más de: {maxPoint}',
  'sys.msg46': 'Yuan para lograr',
  'sys.msg46VN': 'VND para lograr',
  'sys.msg47': 'El elemento {money}, el flujo {betflowMulti} veces puede ser extraído',
  'sys.msg47VN': 'El {money} VND, el flujo {betflowMulti} veces puede ser extraído',

  'sys.msg48': '{point} integral',
  'sys.msg49': 'La probabilidad de ganar es {probability}%. Hay {totalNumber} en total, y {dailyTotalNumber} cada día',
  'sys.msg50': '¡Agregue la oferta antes de enviar!',
  'sys.msg51': 'El efectivo de {giftMoney} yuan se pone en la cuenta principal, y {betMultiple} veces de la cuenta actual pueden ser retirados.',
  'sys.msg52': 'Se agregan {giftPoint} puntos a la cuenta principal.',
  'sys.msg53': 'Recompensas personalizadas de {prizeName}.',
  'sys.msg54': 'Continúe',
  'sys.msg55': 'Objeto físico personalizado',
  'sys.msg56': 'Haga esfuerzos persistentes',
  'sys.msg57': '¡Agregue recompensas continuas antes de enviar!',
  'sys.msg58': '¡Los días continuos deben ser mayores que 0!',
  'sys.msg59': '"| requisitos de flujo:',
  'sys.msg60': '+Monto preferencial',
  'sys.msg62': '|{betMultiple} veces flujo',
  'sys.app': 'APP',
  'sys.mobileVersion': 'Versión móvil',
  'sys.webVersion': 'Versión web',
  'sys.continuousCheck-inForFixedRewards': 'Registro continuo de recompensa fija',
  'sys.singleSign-inRaffleReward': 'Recompensa de rifa de registro único',
  'sys.loginSide': 'Terminal de inicio de sesión',
  'sys.selectLoginSide': 'Seleccione inicio de sesión',
  'sys.prizeSetting': 'Configuración de premio',
  'sys.selectPrizeSetting': 'Seleccione configuración de premio',
  'sys.continuousCheck-in': 'Registro continuo',
  'sys.continuousCheck-in1': 'Ingrese días de registro consecutivo',
  'sys.amountObtained': 'Monto obtenido',
  'sys.earnPoints': 'Obtener integral',
  'sys.enterEarnPoints': 'Ingrese los puntos que puede obtener',
  'sys.addedSweepstakesBonus': 'Premios de rifa añadidos',
  'sys.no1': 'Sin tiempo',
  'sys.addReward': 'Agregar recompensas',
  'sys.rewardAmount': 'Monto de recompensa',
  'sys.enterRewardAmount': 'Ingrese el monto de recompensa',
  'sys.cashFlowRequirement': 'Requisitos de flujo de retiro',
  'sys.enterCashFlowRequirement': 'Ingrese los requisitos de flujo de retiro',
  'sys.rewardPoints': 'Puntos de bono',
  'sys.enterRewardPoints': 'Ingrese los puntos de bono',
  'sys.physicalName': 'Nombre físico',
  'sys.enterPhysicalName': 'Ingrese el nombre físico',
  'sys.clickSelectImage': 'Haga clic para seleccionar una imagen',
  'sys.enterProbabilityWinning': 'Ingrese la probabilidad de ganar',
  'sys.totalNumberCopies': 'Número total',
  'sys.enterTotalNumberCopies': 'Ingrese el número total de copias',
  'sys.distributeMostDaily': 'Distribución máxima diaria',
  'sys.enterDistributeMostDaily': 'Ingrese el número máximo de envíos por día',
  'sys.lotteryConditions': 'Condiciones de sorteo',
  'sys.daysDeposit': 'Días de depósito',
  'sys.enterDaysDeposit': 'Ingrese días de depósito continuo',
  'sys.dailyDepositAmount': 'Monto de depósito diario',
  'sys.addLotteryPrizes': 'Agregar premio de sorteo',
  'sys.ruleSetting': 'Configuración de regla',
  'sys.balance': 'saldo',
  'sys.msg63': 'Monto de depósito: {minDeposit} ~ {maxDeposit}',
  'sys.msg64': 'Efectivo gratuito: {giftPercent}%, máx efectivo: {maxBonusAmount}',
  'sys.msg65': '|Múltiple de tubería: {betMultiple}',
  'sys.successfulOperation': '¡Operación exitosa!',
  'sys.discountInformation': 'Información preferencial',
  'sys.displayInformation': 'Información de visualización',
  'sys.previous': 'Paso anterior',
  'sys.offerEditedSuccessfully': 'Oferta editada exitosamente.',
  'sys.returnListPage': 'Volver a la página de lista',
  'sys.msg68': 'Múltiple de apuesta gratuita: {giftMultiple}',
  'sys.msg69': '|Requisitos de flujo: {betMultiple} veces | el monto máximo de regalo no puede exceder: {maxGiftMoney}',
  'sys.msg70': 'El pago es mayor que el múltiple de apuesta efectivo: {minMultiple} ~ {maxMultiple}',
  'sys.msg71': '¡Seleccione al menos una oferta!',
  'sys.msg72': 'Grado: {level}, acumulado {betflow} yuan de apuesta efectiva',
  'sys.msg73': 'Disfrutar: {upAmount} regalo de actualización, {weekAmount} regalo de salario semanal, {monthAmount} regalo de salario mensual. Todo el regalo en efectivo {betMultiple} veces disponible para retiro',
  'sys.importTime': 'Hora de importación',
  'sys.importCount': 'Número de entradas de importación',
  'sys.importSuccessCount': 'Número de importaciones exitosas',
  'sys.importFailCount': 'Número de fallos',
  'sys.seeDetails': 'Ver detalles',
  'sys.batchImport': 'Importación por lotes',
  'sys.formatDescription': 'Especificación de formato',
  'sys.formatDescription1': '1. Nombre de dividendo',
  'sys.formatDescription2': '2. Nombre de usuario',
  'sys.formatDescription3': '3. Monto preferencial',
  'sys.formatDescription4': '4. Monto de flujo requerido',
  'sys.busyServer': 'El servidor está ocupado. Intente más tarde.',
  'sys.batchImportSucceeded': 'Importación por lotes exitosa',
  'sys.importSucceeded': 'Importación exitosa',
  'sys.importFail': 'Error en importación',
  'sys.msg74': 'Total de importaciones {importCount}, importaciones exitosas {importSuccessCount}, importaciones fallidas {importFailCount}.',
  'sys.msg75': 'Se pueden establecer hasta 6 elementos para recomendación en la página de inicio',
  'sys.uploadError': 'Error de carga. Intente más tarde.',
  'sys.batchImportOffers': 'Importación masiva de ofertas',
  'sys.batchImportOffersDetails': 'Detalles de importación masiva de ofertas',
  'sys.determine': 'Aceptar',
  'sys.import': 'Importar',
  'sys.whetherSucceed': 'Éxito',
  'sys.importStatus': 'Estado de importación',
  'sys.content1': 'contenido',
  'sys.enterContent1': 'Ingrese contenido',
  'sys.error.loadRoles': 'Error al cargar datos de roles',
  'agent.title.confirmOffer2': '¿Confirme si desea emitir?',
  'sys.confirmRejectionThisOffer': '¿Está seguro de que desea rechazar esta oferta?',
  'sys.confirmCancelThisOffer': '¿Está seguro de que desea cancelar esta oferta?',
  'sys.winningNumber': 'Número de nota ganadora',
  'sys.preferentialVariety': 'Variedad preferencial',
  'sys.allVarieties': 'Todas las variedades',
  'sys.preferentialPrincipal': 'Principal preferencial',
  'sys.targetFlow': 'Flujo objetivo',
  'sys.effectiveFlow': 'Flujo efectivo',
  'sys.flowCalculationState': 'Estado de cálculo de flujo:',
  'sys.completionCalculation': 'Cálculo completado',
  'sys.hasFailed': 'Fallido',
  'sys.offerCurrentStatus': 'Estado actual de oferta:',
  'sys.offerCurrentStatus1': 'Estado actual de oferta',
  'sys.offerArrivalTime': 'Hora de llegada preferencial',
  'sys.runningWaterCalculationCompletionTime': 'Tiempo de finalización del cálculo de flujo',
  'sys.userWinsLoses': 'Ganancias o pérdidas de usuarios',
  'sys.platformProfitLoss': 'Ganancia y pérdida de plataforma',
  'sys.examinationPassed': 'Auditoría aprobada',
  'sys.setEffectiveFlow': 'Establecer flujo efectivo',
  'sys.winningNumber1': 'Número ganador',
  'sys.totalDiscount': 'Monto preferencial total',
  'sys.totalDiscount1': 'Número total de ofertas',
  'sys.totalDiscount2': 'Barras de oro de rescate total',
  'sys.totalDiscount3': 'Número total de premios de actualización',
  'sys.totalDiscount4': 'Número total de premios de cigarra',
  'sys.totalDiscount5': 'Número total de ofertas añadidas manualmente',
  'sys.totalDiscount6': 'Número total de elementos de descuento',
  'sys.totalDiscount7': 'Preferencia de depósito total',
  'sys.totalDiscount8': 'Número total de ofertas',
  'sys.totalDiscount9': 'Número total de otras ofertas',
  'sys.totalDiscount10': 'Número total de nuevas ofertas',
  'sys.xls': 'Informe de registro de recopilación preferencial.xls',
  'sys.keyword': 'Palabra clave',
  'sys.releaseStartTime': 'Hora de inicio de la versión',
  'sys.chooseStartTime': 'Seleccione hora de inicio',
  'sys.chooseEndTime': 'Seleccione hora de finalización',
  'sys.releaseEndTime': 'Hora de finalización de la versión',
  'sys.enterValidWater': 'Ingrese flujo válido',
  'sys.recommendedOfferTips': 'Consejos sobre ofertas recomendadas',
  'sys.setRecommendedBonusInformation': 'Establecer información de bono recomendada',
  'sys.offerTitle': 'Título preferencial',
  'sys.offerTitleName': 'Nombre de tipo de oferta',
  'sys.offerTitle1': 'Subtítulo de oferta',
  'sys.enterOfferTitle1': 'Ingrese el subtítulo de la oferta',
  'sys.msg76': 'Tamaño de PC: 1000 * 150px',
  'sys.msg77': 'Imagen de recomendación de terminal móvil',
  'sys.msg78': 'Tamaño de extremo móvil: 360 * 180px',
  'sys.msg79': 'Se recomienda que retire el artículo antes de cerrar esta oferta.',
  'sys.msg80': '¿Está seguro de cancelar la oferta de la página de inicio?',
  'sys.offerType': 'Tipo preferencial',
  'sys.scopeApplication': 'Alcance de aplicación',
  'sys.editor': 'Editor',
  'sys.editTime': 'Hora de actualización',
  'sys.self-serviceArea': 'área de autoservicio ',
  'sys.image': 'imagen',
  'sys.whetherDisplayListBySort': 'Mostrar lista por orden o no',
  'sys.selectOfferType': 'Seleccione tipo de oferta',
  'sys.msg81': 'Está claro acerca de la información preferencial relacionada',
  'sys.msg82': '¿Verifica cuidadosamente para confirmar?',
  'sys.offerList': 'Lista de descuentos',
  'sys.unlink': 'Cancelar asociación',
  'sys.firstDepositOffer': 'Oferta de primer depósito',
  'sys.OtherOffers': 'Otras preferencias',
  'sys.clientType': 'Tipo de cliente',
  'sys.offerMap': 'Mapa de preferencia',
  'sys.sharingPhoto': 'Imágenes promocionales',
  'sys.amount': 'Monto de pago',
  'sys.profitLoss': 'Ganancia y pérdida preferencial',
  'sys.numberRecipients': 'Número de beneficiarios',
  'sys.numberIssues': 'Frecuencia de emisión',
  'sys.offerStatus': 'Estado preferencial',
  'sys.msg83': 'A punto de eliminar anuncio con título {name}',
  'sys.msg84': '¿Está seguro de que desea deshabilitar este anuncio?',
  'sys.msg85': '¿Está seguro de habilitar este anuncio?',
  'sys.msg86': 'A punto de eliminar artículo con título {title}',
  'sys.msg88': 'A punto de eliminar el icono de navegación de juego llamado {pcName}',
  'sys.confirmationOperation': 'Confirmar operación',
  'sys.pushTitle': 'Título de notificación',
  'sys.usableNot': 'Disponibilidad',
  'sys.usable': 'disponible',
  'sys.usable1': 'No disponible',
  'sys.modifyAnnouncementMessage': 'Modificar mensaje de anuncio',
  'sys.addAnnouncement': 'Agregar anuncio',
  'sys.addAnnouncementMessage': 'Agregar mensaje de anuncio',
  'sys.announcementTitle': 'Título del aviso',
  'sys.loseAnnouncementTitle': 'Ingrese el título del anuncio',
  'sys.enterTitleAnnouncement': 'Ingrese el título del anuncio',
  'sys.announcementType': 'Tipo de anuncio',
  'sys.selectAnnouncementType': 'Seleccione tipo de anuncio',
  'sys.announcementContent': 'Contenido del anuncio',
  'sys.enterAnnouncementContent': 'Ingrese contenido del anuncio',
  'sys.startEndTime': 'Hora de inicio y parada',
  'sys.selectStartEndTime': 'Seleccione hora de inicio y finalización',
  'sys.articleTitle': 'Título del artículo',
  'sys.enterArticleTitle': 'Ingrese el título del artículo',
  'sys.articleType': 'Tipo de artículo',
  'sys.enterArticleType': 'Ingrese tipo de artículo',
  'sys.pcPlatform': 'Plataforma PC',
  'sys.h5Platform': 'Plataforma H5',
  'sys.modifyArticles': 'Revisar artículo',
  'sys.addArticle': 'Agregar artículo',
  'sys.articleContent': 'Contenido del artículo',
  'sys.enterArticleContent': 'Complete el artículo',
  'sys.addArticleType': 'Agregar tipo de artículo',
  'sys.enterArticleTypeTitle': 'Ingrese el título del tipo de artículo',
  'sys.smallIcon': 'iconos pequeños',
  'sys.bigIcon': 'Icono grande',
  'sys.addGameNavigation': 'Agregar navegación de juego',
  'sys.addGameName': 'Nombre de navegación de juego',
  'sys.msg89': 'El icono de tamaño PC debe pasar uno',
  'sys.msg90': 'El icono de tamaño móvil debe pasar uno',
  'sys.msg91': 'PC - cargar logotipo del juego',
  'sys.msg92': 'PC - cargar logotipo del juego',
  'sys.msg96': 'URI de evento de ruta de imagen: si este campo existe, al hacer clic en la imagen, será transferido a la página de ruta de clic. Si este campo no tiene valor, no se realizará ninguna operación al hacer clic en la imagen',
  'sys.msg97': 'Nota: el formato del URI de evento de ruta de imagen es; por ejemplo, www.baidu.com / # / game / all, si esta página es la ruta completa de la página a transferir, entonces el URI del parámetro requerido aquí es # / game / all',
  'sys.msg98': 'Esta función se utiliza para que los comerciantes carguen imágenes para agregar / reemplazar imágenes frontales',
  'sys.msg99': 'Secuencia: puede ordenar la secuencia de imágenes usted mismo',
  'sys.msg100': 'A punto de eliminar imagen con nombre: {imgName}',
  'sys.msg101': 'URI de evento de ruta de imagen',
  'sys.gameNavigationName': 'Nombre de navegación de juego',
  'sys.enterGameNavigationName': 'Ingrese el nombre de navegación del juego',
  'sys.page': 'página',
  'sys.fillRoleInformation': 'Rellenar información de rol',
  'sys.enterName': 'Ingrese un nombre',
  'sys.enterType': 'Ingrese tipo',
  'sys.enterStatus': 'Ingrese estado',
  'sys.contentConfiguration': 'Configuración de contenido',
  'sys.contentConfiguration1': 'Configuración de página',
  'sys.keywordSearch': 'Búsqueda por palabras clave',
  'sys.imageName': 'Nombre de imagen',
  'sys.enterImageName': 'Ingrese un nombre de imagen',
  'sys.imageName1': 'Nombre / descripción de imagen',
  'sys.imageGroup': 'Grupo de imágenes',
  'sys.addPictures': 'Agregar imágenes',
  'sys.imageDescription': 'Descripción de imagen',
  'sys.msg102': 'Enlaces al hacer clic en imágenes',
  'sys.msg103': 'Número máximo de imágenes que se pueden transferir: es para limitar el número máximo de imágenes que se pueden tener en este grupo de códigos',
  'sys.msg104': 'Descripción: descripción general del papel de imágenes / grupos de imágenes',
  'sys.msg106': 'A punto de habilitar grupo de imágenes con nombre: {imgName}',
  'sys.numberUploadedImages': 'Número de imágenes cargadas',
  'sys.sendPushMessage': 'Enviar notificación push',
  'sys.pushPlatform': 'Plataforma de notificaciones',
  'sys.pushPlatform1': 'Seleccione una plataforma de notificación',
  'sys.android': 'Android',
  'sys.ios': 'iOS',
  'sys.title': 'Título',
  'sys.fillPushTitle': 'Rellene el título de la notificación',
  'sys.fillPushContent': 'Rellene el contenido de la notificación',
  'sys.pushContent': 'Contenido de notificación',
  'sys.msg107': 'Remitente / hora',
  'sys.msg108': 'Seleccione si desea establecer el registro como leído',
  'sys.msg109': 'Seleccione si desea establecer el registro como no leído',
  'sys.pushDate': 'Fecha de notificación',
  'sys.messageType': 'Tipo de mensaje',
  'sys.theme': 'tema',
  'sys.enterTheme': 'Ingrese un tema',
  'sys.time1': 'tiempo',
  'sys.haveRead': 'Ya leído',
  'sys.unread': 'No leído',
  'sys.reply': 'Responder',
  'sys.hasBeenBack': 'Ya devuelto',
  'sys.userNotSelected': 'Sin usuario seleccionado',
  'sys.markRead': 'Marcar como leído',
  'sys.markRead1': 'Marcar como no leído',
  'sys.msg110': 'Eliminar registro seleccionado',
  'sys.recipient': 'Destinatario',
  'sys.selectRecipient': 'Seleccione el destinatario',
  'sys.sender': 'Remitente',
  'sys.systemSend': 'Envío del sistema',
  'sys.operationalTransmission': 'Despacho de operación',
  'sys.operator': 'Operador',
  'sys.sender1': 'Remitente',
  'sys.send': 'Enviar',
  'sys.sendHand': 'Transmisión manual',
  'sys.sendSiteMsg': 'Enviar mensaje en sitio',
  'sys.agentMustSelected': 'Agente debe ser seleccionado',
  'sys.memberMustFilledOut': 'Miembro requerido',
  'sys.mustFillVipLevel': 'Debe llenar el nivel de vip',
  'sys.mustFillTimePeriod': 'Período de tiempo debe ser completado',
  'sys.parameterNotComplete': 'Parámetros no completamente llenos',
  'sys.msg111': 'Recordatorio cálido: si la cuenta de miembro está vinculada al correo electrónico, puede recibir el correo electrónico que ingresó',
  'sys.msg112': 'Ingrese miembros separados por (,) comas',
  'common.agent1': 'Agente:',
  'sys.selectAgent': 'Seleccione un agente',
  'sys.allMembers': 'Todos los miembros',
  'sys.actingMembers': 'Miembro actuante',
  'sys.contentEmail': 'Contenido de correo',
  'sys.fillLetter': 'Rellene la carta de estación',
  'sys.stationLetterContent': 'Contenido de carta en estación',
  'sys.operation.upgrade': 'Modo de actualización',
  'sys.msg113': 'Condiciones de actualización, (El salario semanal se distribuirá el miércoles y el salario mensual el 3)',
  'sys.timeArrival': 'Fecha de pago',
  'sys.totalNumberArticles': 'Número total',
  'sys.add': 'Recién añadido',
  'sys.smg114': 'Confirmar voluntad',
  'sys.smg115': 'Subordinado',
  'sys.smg116': 'Configuración de privilegios',
  'sys.smg117': 'Privilegios a eliminar: {title}',
  'sys.smg118': 'Nivel {vipLevel}',
  'sys.smg119': 'Ingrese un título principal de privilegio inferior a 20 caracteres',
  'sys.smg120': 'Ingrese el nombre de la imagen de promoción',
  'sys.smg121': 'Ingrese un subtítulo de privilegio de menos de 20 palabras',
  'sys.smg122': 'Confirme que la información completada es correcta y la lógica correspondiente es correcta.',
  'sys.confirmModificationStatus': 'Confirmar estado de modificación',
  'sys.vip7': 'VIP de privilegio',
  'sys.vip8': 'Título principal de privilegio',
  'sys.vip9': 'Subtítulo de privilegio',
  'sys.vip10': 'Agregar privilegios',
  'sys.ipAll': 'Todas las IP',
  'sys.ipAddr': 'Dirección IP',
  'sys.ipRemark': 'IP/ observaciones',
  'sys.abnormalOperation': 'La operación es anormal. Intente más tarde.',
  'sys.vip11': 'Agregar información de privilegio',
  'sys.vip12': 'Ingrese el título principal del privilegio',
  'sys.vip13': 'Ingrese el subtítulo de privilegio',
  'sys.vip14': 'Configuración de nivel de VIP',
  'sys.vip15': 'Nombre de VIP',
  'sys.vip16': 'Ingrese el nombre de VIP',
  'sys.vip17': 'Nivel VIP',
  'sys.vip18': 'Ver privilegios',
  'sys.oldPromotionPicture': 'Imágenes de promoción antiguas',
  'sys.uploadFile': 'Cargue el archivo',
  'sys.privilegeOrder': 'Orden de privilegio',
  'sys.enterPrivilegeOrder': 'Ingrese el orden de privilegios',
  'sys.confirmSubmissionChanges': 'Confirmar envío de modificación',
  'sys.memberExpirationDate': 'Validez del miembro',
  'sys.memberExpirationDate1': 'Seleccione el período de validez',
  'sys.promotionRequirements': 'Requisitos de promoción',
  'sys.requiredPoints': 'Integral requerida',
  'sys.requiredDeposit': 'Depósitos requeridos',
  'sys.requiredFlow': 'Flujo requerido',
  'sys.requiredPoints2': 'Puntos de degradación',
  'sys.requiredDeposit2': 'Depósito de protección',
  'sys.requiredFlow2': 'Flujo de degradación',
  'sys.relegationPeriod': 'Período de relegación',
  'sys.coupletRequest': 'Requisito de reelección',
  'sys.runningWater': 'Flujo = =',
  'sys.runningWater1': 'Agua corriente',
  'sys.msg123': '% ganancias negativas.',
  'sys.msg124': 'Panadero',
  'sys.issueOnce': 'Lanzamiento único',
  'sys.issueOnce1': 'Pago diario',
  'sys.issueOnce2': 'Pago semanal',
  'sys.issueOnce3': 'Pago mensual',
  'sys.issueOnce4': 'Pago anual',
  'sys.msg125': '¿Configuración de nivel de miembro de nivel VIP {vipLevel} ({vipName})?',
  'sys.showName': 'Mostrar nombre',
  'sys.view': 'Ver',
  'sys.msg126': '¿Confirme si desea desbloquear?',
  'sys.msg127': '¿Confirme si se aprueba?',
  'sys.lockedAmount': 'Monto bloqueado',
  'sys.flowCompletionProgress': 'Progreso de finalización del flujo',
  'sys.completedFlow': 'Flujo completado:',
  'sys.offerTime': 'Hora de recopilación preferencial',
  'sys.offerLockList': 'Lista de bloqueo de oferta',
  'sys.monthlySettlementCommission': 'Comisión de liquidación mensual',
  'sys.confirmationReview': 'Auditoría de confirmación',
  'sys.proxyName': 'Nombre del agente',
  'sys.selectDate': 'Seleccione una fecha',
  'sys.completeSchedule': 'Horario de finalización',
  'sys.rechargeTime': 'Tiempo de recarga',
  'sys.depositLockList': 'Lista de bloqueo de depósito',
  'sys.transferAmount': 'Monto de transferencia',
  'sys.transferStatus': 'Estado de transferencia',
  'sys.transferType': 'Tipo de transferencia',
  'sys.gameOut': 'Salida del juego',
  'sys.abnormal': 'anormal',
  'sys.msg128': '¿Establecer como exitoso?',
  'sys.msg129': 'Establecido como exitoso. Si el tipo de transferencia es salida de transferencia de juego, el monto se agregará a los activos del jugador',
  'sys.msg130': '¿Establecer como fallido?',
  'sys.msg131': 'Establecido como fallido. Si el tipo de transferencia es transferencia en el juego, el monto se agregará a los activos del jugador',
  'sys.msg132': 'Número de orden, nombre de usuario, plataforma de juego',
  'sys.setSuccess': 'Establecerlo como un éxito',
  'sys.setFail': 'Establecer fallo',
  'sys.totalWithdrawal': 'Retiros totales',
  'sys.offerComposition': 'Composición preferencial',
  'sys.gameWater': 'Flujo de juego',
  'sys.bankRelated': 'Banco relacionado',
  'sys.bankCode': 'código de banco:',
  'sys.bankName': 'Nombre del banco:',
  'sys.branchName': 'Nombre de rama:',
  'sys.branchAddr': 'Dirección de rama:',
  'sys.accountRelated': 'Cuenta relacionada',
  'sys.msg133': 'Nombre de cuenta:',
  'sys.msg134': 'cuenta bancaria:',
  'sys.msg135': 'Monto final',
  'sys.msg136': 'Registros de flujo en los últimos siete días',
  'sys.msg137': 'Ubicación de IP',
  'sys.msg138': 'Ver usuarios conectados por esta IP',
  'sys.msg139': 'Estadísticas de direcciones IP',
  'sys.normal': 'normal',
  'sys.bankInformation': 'Información bancaria',
  'sys.attributionType': 'Tipo de atribución',
  'sys.offerRecord': 'Registro preferencial',
  'sys.userDeviceID': 'ID de dispositivo del usuario',
  'sys.deviceInformation': 'Información del dispositivo',
  'sys.operatingSystemVersion': 'Versión del sistema operativo',
  'sys.longitude': 'longitud',
  'sys.latitude': 'latitud',
  'sys.loginTimes': 'Tiempos de inicio de sesión',
  'sys.loginTimes1': 'Número de inicios de sesión:',
  'sys.registrationTime': 'Hora de registro',
  'sys.cellphoneNumber': 'Número de teléfono',
  'sys.cellphoneNumber2': 'número de teléfono:',
  'sys.cellphoneNumber3': 'Es el móvil certificado',
  'sys.msg140': 'Otros usuarios conectados por esta IP',
  'sys.msg141': 'Hora del último inicio de sesión',
  'sys.msg142': 'Hora de envío de solicitud',
  'sys.windControlManagement': 'Gestión de control de riesgo',
  'sys.loginLog': 'Registro de inicio de sesión',
  'sys.deviceID': 'ID de dispositivo',
  'sys.browser': 'Navegador',
  'sys.transactionRecord': 'Registro de transacción',
  'sys.transactionType': 'Tipo de transacción',
  'sys.transferDetails': 'Detalles de transferencia',
  'sys.amountAfterSettlement': 'Monto después de liquidación',
  'sys.fundChange': 'Cambio de capital',
  'sys.increase': 'aumentar',
  'sys.cutBack': 'reducir',
  'sys.winLossAmount': 'Monto de ganancia o pérdida',
  'sys.chronologically': 'Orden cronológico:',
  'sys.agentWithdraw': 'Solicitud de retiro',
  'sys.selectRiskLevel': 'Seleccione nivel de riesgo',
  'sys.selectRiskLevel1': 'Seleccione nivel de control de riesgo',
  'sys.windControlLevel': 'Nivel de control de riesgo',
  'sys.confirmConsent': 'Confirmar consentimiento',
  'sys.confirmConsent1': '¿Está de acuerdo con esta operación?',
  'sys.confirmConsent2': '¿Desea rechazar esta operación?',
  'sys.cardholder': 'Titular de tarjeta',
  'sys.viewUserDetails': 'Ver detalles del usuario',
  'sys.by': 'adoptar',
  'sys.notApproved': 'No examinado y aprobado',
  'sys.passed': 'Han pasado',
  'sys.paid': 'Fuera de pago',
  'sys.successfulPayment': 'Pago exitoso',
  'sys.smg143': 'Usuarios a ser aprobados',
  'sys.smg144': 'Usuarios con preferencia limitada',
  'sys.smg145': 'Usuarios de retiro restringido',
  'sys.smg146': 'Usuarios de inicio de sesión restringido',
  'sys.smg147': 'Dirección IP conectada',
  'sys.smg148': 'Información del mismo dispositivo y la misma IP',
  'sys.smg149': 'Curva de ganancias del usuario',
  'sys.smg150': 'Es el correo electrónico certificado',
  'sys.smg151': 'Lista de atributos de control de riesgo del usuario',
  'sys.flowRecord': 'Registro de flujo',
  'sys.userInfo': 'Información del usuario',
  'sys.attribution': 'Lugar de propiedad',
  'sys.registerationName': 'Nombre de dominio registrado:',
  'sys.details': 'Detalles:',
  'sys.searchUser': 'Nombre de usuario:',
  'sys.numberDeposits': 'Número de depósitos:',
  'sys.numberWithdrawals': 'Tiempos de retiro:',
  'sys.allGrades': 'Todos los grados',
  'sys.riskValueScore': 'Puntuación de Var',
  'sys.managementPlatformGame': 'Administrar juegos de plataforma',
  'sys.receivingTime': 'Hora de recepción:',
  'sys.completeTime': 'Hora de finalización:',
  'sys.processResult': 'Resultado del procesamiento',
  'sys.addWorkOrder': 'Hoja de trabajo',
  'sys.smg155': 'Contenido / observaciones / enviado por',
  'sys.fillWorkOrder': 'Rellenar orden de trabajo',
  'sys.enterTitle': 'Ingrese un título',
  'sys.smg156': 'Ingrese contenido de orden de trabajo, sugerencia u opinión',
  'sys.enterProcessingResult': 'Ingrese el resultado del procesamiento',
  'sys.realUnlockAmount': 'Monto de desbloqueo de persona real',
  'sys.enterParameterAmount': 'Ingrese el monto del parámetro',
  'sys.realState': 'Estado humano',
  'sys.videoGameUnlockAmount': 'Monto de desbloqueo de videojuego',
  'sys.videoGameStatus': 'Estado de videojuego',
  'sys.sportsUnlockAmount': 'Monto de desbloqueo de deportes',
  'sys.sportsStatus': 'Estado deportivo',
  'sys.chessCardUnlockingAmount': 'Monto de desbloqueo de ajedrez y cartas',
  'sys.chessState': 'Estado de ajedrez',
  'sys.fishingUnlockAmount': 'Monto de desbloqueo de pesca',
  'sys.fishingStatus': 'Estado de pesca',
  'sys.lotteryUnlockAmount': 'Monto de desbloqueo de lotería',
  'sys.lotteryStatus': 'Estado de lotería',
  'sys.universalUnlockAmount': 'Monto de desbloqueo general',
  'sys.defaultState': 'Estado predeterminado',
  'sys.smg157': 'Nota: la configuración del número de monto de desbloqueo afectará los fondos bloqueados por miembros.',
  'sys.smg158': 'Monto de bloqueo de descuento menos monto de pérdida de descuento es inferior al monto desbloqueado.',
  'sys.smg159': 'El monto de depósito bloqueado menos el dinero perdido es inferior al monto desbloqueado.',
  'sys.smg160': 'El sistema desbloqueará automáticamente la oferta o depósito y establecerá el estado como fallido.',
  'sys.smg161': 'Los parámetros de desbloqueo del tipo de juego correspondiente se utilizarán para las concesiones del tipo de juego especificado, y se utilizarán los parámetros de desbloqueo predeterminados para las concesiones y bloqueo de depósito del tipo de juego no especificado.',
  'sys.confirmUpload': 'Confirmar carga',
  'sys.smg162': 'Esta carga afectará la descarga de la aplicación del usuario. Tenga cuidado, ¿cargar o no?',
  'sys.smg163': 'Paquete y cargue la versión de la aplicación',
  'sys.AppType': 'Tipo de aplicación',
  'sys.selectAppTypr': 'Seleccione tipo de aplicación',
  'sys.version': 'Número de versión',
  'sys.enterVersion': 'Ingrese el número de versión',
  'sys.smg164': 'Ingrese hasta 10 caracteres',
  'sys.pleaseUpload': 'Cargue',
  'sys.pleaseUploadApp': 'Cargue el paquete de la aplicación',
  'sys.pleaseNote': 'Tenga en cuenta que',
  'sys.smg165': 'Seleccione el archivo de aplicación para confirmar y luego envíelo para cargar automáticamente!!!',
  'sys.AppUploadUpdateSucceeded': 'Carga y actualización de aplicación exitosa',
  'sys.returnRefreshHome': 'Volver a actualizar la página de inicio',
  'sys.configurationItem': 'Elemento de descripción de configuración',
  'sys.enterConfigurationItem': 'Ingrese la descripción de configuración',
  'sys.withdrawalOrderSplit': 'División de orden de retiro',
  'sys.smg166': '¿Desea {msg} dividir orden de retiro?',
  'sys.addPaymentChannel': 'Agregar canal de pago',
  'sys.orderSplitConfiguration': 'Configuración de división de orden',
  'sys.maxAmount': 'Suma máxima',
  'sys.minAmount': 'Monto mínimo',
  'sys.nameCode': 'Nombre / código',
  'sys.fillPaymentChannelInformation': 'Rellenar información del canal de pago',
  'sys.paymentRate': 'Tasa de prima',
  'sys.enterPaymentRate': 'Ingrese la tasa de pago',
  'sys.controllerPath': 'Ruta del controlador',
  'sys.fillPaymentSplitConfiguration': 'Rellenar configuración de división de pago delegada',
  'sys.splitMinimumAmount': 'Monto mínimo de división',
  'sys.splitMaximumAmount': 'Monto máximo de división',
  'sys.whetherOpen': 'Si abrir',
  'sys.isSubmit': 'Si enviar',
  'sys.confirmSubmit': 'Compruebe que la información es correcta y envíe cuidadosamente',
  'sys.diffPass': 'La contraseña es inconsistente, confirme',
  'sys.formatError': 'Solo puede comenzar con una letra minúscula, solo contiene letras minúsculas y números',
  'sys.Pass': 'Contraseña',
  'sys.cleanValidator': '¿Está seguro de que desea borrar el verificador vinculado a esta cuenta de fondo?',
  'sys.deleteAccount': 'Cuenta a eliminar: {username}',
  'sys.forceOffline': 'Forzar desconexión',
  'sys.resetValidator': 'Restablecer verificador',
  'sys.fillDeviceInfo': 'Rellenar información del equipo',
  'sys.deviceNo': 'Número de equipo',
  'sys.deviceNo1': 'Ingrese el número de equipo',
  'sys.deviceNo2': 'Ingrese el comentario del número de equipo',
  'sys.deviceNo3': 'Número de dispositivo a eliminar: {deviceNum}',
  'sys.confirmRefreshBlackList': '¿Está seguro de que desea actualizar la lista negra del dispositivo?',
  'sys.refreshBlackList': 'Actualizar lista negra de dispositivos',
  'sys.addDeviceNo': 'Agregar número de dispositivo',
  'sys.fillIPInfo': 'Rellenar información de IP',
  'sys.startIP': 'Inicio IP',
  'sys.startIP1': 'Ingrese IP inicial',
  'sys.endIP': 'IP de finalización',
  'sys.endIP1': 'Ingrese la IP de finalización',
  'sys.endIP2': 'Ingrese comentario de IP',
  'sys.deleteIP': 'IP a eliminar: {ipMinRange}',
  'sys.beginIP': 'Inicio de dirección IP',
  'sys.overIP': 'Fin de dirección IP',
  'sys.confirmRefreshIPBlackList': '¿Está seguro de que desea actualizar la lista negra de IP?',
  'sys.addIP': 'Agregar IP',
  'sys.refreshIpBlackList': 'Actualizar lista negra de IP',
  'sys.changeTime': 'Hora de modificación',
  'sys.inputIPAddress': 'Ingrese dirección IP',
  'sys.inputIPAddress1': 'IP múltiple use, división de números',
  'sys.editPlayMethodDesc': 'Editar instrucciones de juego',
  'sys.playMethodDesc': 'Instrucciones de juego',
  'sys.playMethodDesc1': 'Ingrese una descripción de cómo jugar',
  'sys.winningExample': 'Ejemplos de ganancia',
  'sys.winningExample1': 'Ingrese el ejemplo ganador',
  'sys.confirmEnablePlayMethod': '¿Está seguro de que desea habilitar esta forma de jugar?',
  'sys.confirmDisablePlayMethod': '¿Está seguro de que desea deshabilitar este juego?',
  'sys.people': 'personal',
  'sys.editDesc': 'Nota del editor',
  'sys.attributeName': 'Nombre del atributo',
  'sys.confirmChangeLiuHeOdds': '¿Está seguro de que desea modificar las cuotas de [{firstName} - {secondName}]?',
  'sys.save': 'Guardar',
  'sys.odds': 'Las cuotas son:',
  'sys.cleanWhiteListCache': 'Limpiar caché de lista blanca',
  'sys.inputIPAddress3': 'Ingrese la dirección IP y use coma para separar múltiples direcciones IP',
  'sys.accountUnlockParam': 'Parámetros de desbloqueo de cuenta',
  'sys.lowOrderCount': 'Número mínimo de órdenes',
  'sys.lowOrderCount1': 'Ingrese el número mínimo de órdenes',
  'sys.lowOrderCount2': 'Ingrese el número correcto',
  'sys.percentageWarning': 'Porcentaje de alerta',
  'sys.percentageWarning1': 'Ingrese el porcentaje de alerta',
  'sys.disablePercentage': 'Porcentaje deshabilitado',
  'sys.disablePercentage1': 'Ingrese el porcentaje deshabilitado',
  'sys.lowOrderCount3': 'Número mínimo de órdenes: si el número total de órdenes del método de pago es mayor que este valor, se evalúa si se envía un mensaje de alerta y se deshabilita automáticamente.',
  'sys.percentageWarning2': 'Porcentaje de alerta: si la tasa de éxito del método de pago es menor que este porcentaje, se envía un mensaje de alerta que se mostrará en la esquina superior derecha de la página.',
  'sys.disablePercentage2': 'Porcentaje deshabilitado: si la tasa de éxito del método de pago es menor que este porcentaje, el método de pago se deshabilitará automáticamente y se enviará un mensaje de deshabilitación que se mostrará en la esquina superior derecha de la página.',
  'sys.disablePercentage3': 'Los métodos de pago deshabilitados no enviarán mensajes repetidamente.',
  'sys.gamePlatformInfo': 'Información de la plataforma de juegos',
  'sys.chineseName': 'Nombre en chino',
  'sys.chineseName1': 'Ingrese el nombre en chino',
  'sys.gameSort': 'Clasificación de juegos',
  'sys.gameSort1': 'Ingrese el orden del juego, de menor a mayor',
  'sys.pc': 'Admite PC',
  'sys.pc1': 'Seleccione si se admite PC',
  'sys.pc2': 'Admite PC',
  'sys.notSupport': 'No compatible',
  'sys.h52': 'Admite H5',
  'sys.hotGame': 'Juego popular',
  'sys.notHotGame': 'No popular',
  'sys.newestGame': 'Juego más reciente',
  'sys.notNewGame': 'No actualizado',
  'sys.gameNo': 'Número de juego',
  'sys.pcPicH5Pic': 'Imágenes PC/H5',
  'sys.notSupportPc': 'PC no es compatible',
  'sys.notSupportH5': 'Móvil no es compatible',
  'sys.newGame': 'Nuevo juego',
  'sys.tryPlay': 'Admite prueba',
  'sys.hot': 'popular',
  'sys.new': 'nuevo',
  'sys.try': 'prueba',
  'sys.addMaintenanceInfoSuccess': '¡Información de mantenimiento agregada exitosamente!',
  'sys.addMaintenanceInfoFail': 'Error al agregar información de mantenimiento',
  'sys.addMaintenanceInfoError': 'Error al agregar información de mantenimiento',
  'sys.maintenanceInfo1': 'Complete la información de mantenimiento',
  'sys.maintenanceInfo': 'Información de mantenimiento',
  'sys.fillGamePlatFormInfo': 'Complete la información de la plataforma de juegos',
  'sys.platFormNo': 'Ingrese el número de plataforma',
  'sys.platFormGameNo': 'Número de juego de la plataforma',
  'sys.platFormGameNo1': 'Ingrese el número de juego de la plataforma',
  'sys.platFormFullName': 'Nombre completo de la plataforma',
  'sys.gameNameAndGameType': 'Nombre de plataforma + tipo de juego',
  'sys.platformRate': 'Tasa de plataforma',
  'sys.platformRate1': 'Ingrese la tasa de plataforma',
  'sys.platformDesc': 'Descripción de la plataforma',
  'sys.platformDesc1': 'Ingrese la descripción de la plataforma',
  'sys.platformDesc2': 'Ingrese máximo 255 caracteres',
  'sys.platformSort1': 'Ingrese el orden de la plataforma',
  'sys.platformSort2': 'De mayor a menor en orden natural',
  'sys.platformSort': 'Orden de la plataforma',
  'sys.allPlatform': 'Todas las plataformas',
  'sys.fullName': 'nombre completo',
  'sys.gameRate': 'Tasa de juego',
  'sys.confirmDeleteGamePlatForm': 'Plataforma de juegos {fullName} para ser eliminada',
  'sys.isHot': '¿Es popular?',
  'sys.hotSort': 'Orden popular',
  'sys.addPlatFomr': 'Agregar plataforma',
  'sys.isMaintenance': 'Mantenimiento',
  'sys.changeHotSort': 'Modificar el orden popular de {value}',
  'sys.hotSort1': 'Ingrese un orden popular',
  'sys.mailInfo1': 'Complete la información de correo electrónico',
  'sys.mailInfo2': 'Ingrese el nombre de usuario de correo electrónico',
  'sys.mailInfo3': 'Ingrese un nombre de usuario de correo electrónico con menos de 80 caracteres',
  'sys.mailPass': 'Contraseña de correo electrónico',
  'sys.mailPass1': 'Ingrese la contraseña de correo electrónico',
  'sys.mailPass2': 'Ingrese una contraseña de correo electrónico con menos de 80 caracteres',
  'sys.mailSMTP1': 'Ingrese la dirección SMTP',
  'sys.mailSMTP2': 'Ingrese una dirección SMTP con menos de 200 caracteres',
  'sys.encryptionType': 'Tipo de encriptación',
  'sys.encryptionType1': 'Seleccione el tipo de encriptación',
  'sys.encryptionType2': 'Sin encriptación (la mayoría de puertos son 25)',
  'sys.ssl': 'SSL (la mayoría de puertos son 465)',
  'sys.tls': 'TLS (la mayoría de puertos son 587)',
  'sys.port': 'Número de puerto',
  'sys.port1': 'Ingrese el número de puerto',
  'sys.deleteMail': 'Correo electrónico para ser eliminado: {username}',
  'sys.addMail': 'Agregar correo electrónico',
  'sys.addMailTemplate': 'Complete la información de la plantilla de mensaje',
  'sys.templateName': 'Nombre de plantilla',
  'sys.templateName1': 'Ingrese un nombre de plantilla',
  'sys.mailTitle': 'Título del correo electrónico',
  'sys.mailTitle1': 'Ingrese un título de mensaje',
  'sys.mailContent1': 'Ingrese el contenido del mensaje',
  'sys.mailRemark': 'Notas de correo electrónico',
  'sys.mailRemark1': 'Ingrese notas de correo electrónico',
  'sys.deleteMailTemplate': 'Plantilla de mensaje para ser eliminada: {name}',
  'sys.addTemplate': 'agregar plantilla',
  'sys.allTemplate': 'Todas las plantillas',
  'sys.buttonPermissionMgt': 'Gestión de autorización de botones',
  'sys.noticeDataPermissionMgt': 'Gestión de autorización de datos de notificación',
  'sys.noticePermission': 'Autorización de notificación',
  'sys.pageDataPermissionMgt': 'Gestión de permisos de datos de página',
  'sys.console': 'Consola',
  'sys.deleteRole': 'Rol para ser eliminado: {roleName}',
  'sys.roleName': 'Nombre del rol',
  'sys.roleSort': 'Secuencia de rol',
  'sys.dataPermission': 'Permisos de datos',
  'sys.disableRole': '¿Desea deshabilitar este rol?',
  'sys.enableRole': '¿Desea habilitar este rol?',
  'sys.addRole': 'Agregar roles',
  'sys.inputRoleName': 'Ingrese el nombre del rol',
  'sys.inputRoleSort': 'Ingrese el orden del rol',
  'sys.payLine': 'línea de pago',
  'sys.cumulativePrizePool': 'Bote acumulativo',
  'sys.classGame': 'Juego clásico',
  'sys.eliminateMusic': 'Xiao Xiao le',
  'sys.electricHorn': 'Cuerno eléctrico',
  'sys.gameId': 'ID de juego',
  'sys.intoGameParam': 'Ingrese los parámetros del juego y complete con cuidado',
  'sys.isTryGame': 'Seleccione si desea admitir prueba',
  'sys.payLine1': 'Ingrese la línea de compensación',
  'sys.uploadPcPic': 'Subir imagen de PC',
  'sys.oldPcPic': 'Imágenes antiguas de PC:',
  'sys.oldH5Pic': 'Imágenes antiguas de H5:',
  'sys.uploadH5Pic': 'Subir imagen H5',
  'sys.platformName': 'Nombre de la plataforma',
  'common.productName': 'Piedra de juego',
  'common.changeLang': 'cambiar idioma',
  'common.page.showtotal': 'El total actual es {total} registros',
  'common.page.pageInfo': 'Página {currentPage} de {totalPages}',
  'common.page.showSelectTotal': 'Hay actualmente {total} elementos y {select} elementos han sido seleccionados',
  'common.404': 'Cuatrocientos cuatro',
  'common.unkonwException': 'Anomalía desconocida',
  'common.unkonwError': 'Anomalía desconocida',
  'common.requestException': 'Excepción de solicitud',
  'common.requestException1': 'La solicitud es anómala. Intente más tarde.',
  'common.requestError1': '¡Error en la solicitud, intente de nuevo!',
  'common.requestError': '{err}, intente más tarde.',
  'common.operateFail': 'operación fallida',
  'common.action': 'Acción',
  'common.delete': 'Eliminar',
  'common.operateSuccess': 'Operación exitosa',
  'common.operateSuccess1': 'Agregación exitosa',
  'common.operateFail1': 'Operación fallida, intente más tarde',
  'common.operateFail2': 'Operación fallida, {message}',
  'common.export.loading': 'Cálculo de exportación',
  'common.export.success': '¡Exportación exitosa!',
  'common.export.error': 'Error de exportación, los datos de exportación son demasiado grandes, exporte en lotes',
  'common.export.excel': 'exportar reporte',
  'common.export.noneExport': 'El usuario actual no tiene datos para exportar',
  'common.export': 'Exportar',
  'common.exportFailed': 'Error de exportación',
  'common.export.type': 'Tipo de exportación',
  'common.export.type0': 'Exportación de miembro regular',
  'common.export.type3': 'Exportación de agente total',
  'common.export.notice': 'Seleccione el contenido de la tabla EXCEL para generar',
  'common.Button.details': 'detalles',
  'common.Button.expandDetails': 'Detalles de expansión',
  'common.Button.collapseDetails': 'Recopilar detalles',
  'common.button.update': 'modificar',
  'common.button.update.role': 'Modificar rol',
  'common.button.delete': 'Eliminar',
  'common.button.add': 'Agregar',
  'common.queryFrm.search': 'Buscar',
  'common.queryFrm.reset': 'Restablecer',
  'common.refresh': 'Actualizar',
  'common.queryFrm.searchMore': 'Búsqueda más avanzada',
  'common.queryFrm.searchClean': 'Limpiar criterios de búsqueda',
  'common.queryFrm.searchHide': 'Las búsquedas más avanzadas están ocultas. Si no borró los criterios de búsqueda, haga clic en el botón para limpiar los criterios de búsqueda',
  'common.queryFrm.keyWord': 'Palabra clave',
  'common.queryFrm.nickName': 'Nombre apodo',
  'common.queryFrm.cleanAndClose': 'Limpiar y cerrar',
  'common.queryFrm.searchUserAccountPhoneMail': 'Nombre de usuario / teléfono móvil / correo electrónico',
  'common.queryFrm.searchUserAccountBetflowNumber': 'Nombre de usuario / número de serie',
  'common.queryFrm.searchUserAccountRemark': 'Nombre de usuario / comentario',
  'common.radio.minute': 'Minuto',
  'common.radio.hour': 'hora',
  'common.radio.day': 'día',
  'common.radio.week': 'semana',
  'common.radio.month': 'mes',
  'common.radio.permanent': 'permanente',
  'common.radio.today': 'Hoy',
  'common.radio.yesterday': 'Ayer',
  'common.radio.beforeYesterday': 'Anteayer',
  'common.radio.last7Day': 'Últimos 7 días',
  'common.radio.last15Day': 'Últimos 15 días',
  'common.radio.last30Day': 'Últimos 30 días',
  'common.radio.thisWeek': 'Esta semana',
  'common.radio.lastWeek': 'Semana pasada',
  'common.radio.thisMonth': 'Este mes',
  'common.radio.lastMonth': 'Mes pasado',
  'common.radio.disable': 'Prohibir',
  'common.radio.enable': 'Habilitar',
  'common.radio.enableDisable': 'Seleccione si desea habilitar',
  'common.radio.enableDisable1': '¿Está habilitado?',
  'common.radio.block': 'ocultar',
  'common.radio.display': 'mostrar',
  'common.radio.blockDisplay': '¿Está habilitado?',
  'common.radio.recommend': 'Recomendar',
  'common.radio.notRecommend': 'No recomendado',
  'common.radio.recommendAndNotRecommend': 'Recomendación',
  'common.radio.pc': 'Terminal de computadora',
  'common.radio.mobile': 'Terminal móvil',
  'common.radio.pcAndMobile': 'Plataforma de visualización',
  'common.radio.level1': 'Clase A',
  'common.radio.level2': 'segundo nivel',
  'common.title.dataSummary': 'Agregación de datos',
  'common.title.operate': 'operación',
  'common.title.serialNumber': 'Número de serie',
  'common.title.userName': 'Nombre de usuario',
  'common.title.completeUserName': 'Ingrese su número de cuenta de miembro completo',
  'common.title.createAdmin': 'Fundador',
  'common.title.createTime': 'Hora de creación',
  'common.title.updateAdmin': 'Operador',
  'common.title.settlement': 'Liquidación',
  'common.title.noData': 'Sin datos',
  'common.records': 'registros',
  'common.queryFailed': 'Consulta fallida',
  'common.search': 'Buscar',
  'common.reset': 'Restablecer',
  'common.title.updateTime': 'Hora de operación',
  'common.select.selectPlatform': 'Seleccione una plataforma',
  'common.select.allPlatform': 'Todas las plataformas',
  'common.select.selectType1': 'Tipo de selección',
  'common.select.selectType': 'Seleccione el tipo',
  'common.select.allType': 'Todos los tipos',
  'common.select.allWay': 'Todas las formas',
  'common.select.allStatus': 'Todos los estados',
  'common.select.allDevice': 'Todos los equipos',
  'common.select.allLevel': 'Todos los niveles',
  'common.select.selectChannel': 'Seleccione un canal',
  'common.select.init': 'Por favor seleccione',
  'common.select.allChannel': 'Todos los canales',
  'common.select.init1': 'entero',
  'common.select.init2': 'Configuración completa',
  'common.select.selectStatus': 'Seleccione el estado',
  'common.checkBox.selectAll': 'Elección de todos',
  'common.checkBox.selectAll2': 'Seleccionar todo',
  'login.install.verify': 'Instale primero el verificador',
  'login.input.username': 'ingresar un nombre de usuario',
  'login.input.password': 'Ingrese una contraseña',
  'login.submit': 'Iniciar sesión',
  'login.success': 'Inicio de sesión exitoso',
  'login.please': 'Por favor inicie sesión',
  'menu.index': 'página de inicio',
  'menu.export': 'Exportación de datos',
  'menu.console': 'Consola',
  'menu.queryMember': 'Lista de membresía',
  'menu.queryNewMember': 'Usuarios nuevos',
  'menu.queryDepositMember': 'Usuario depositante',
  'menu.queryActiveUser': 'Usuarios activos',
  'menu.queryProfitAndLossAccount': 'Usuarios perdidos y devueltos',
  'menu.querySilentUser': 'Usuario silencioso',
  'menu.retainedUser': 'Análisis de retención',
  'menu.userAnalysis': 'Análisis de usuario',
  'menu.memberContact': 'Información de membresía',
  'menu.memberWithdrawalInformation': 'Información de retiro de miembro',
  'menu.member': 'Gestión de membresía',
  'menu.bonusSetting': 'Configuración de preferencias',
  'menu.bonusUpperLimit': 'límite superior de bonificación',
  'menu.bonusActivities': 'Actividades',
  'menu.operation.bonus.bonusArticle': 'Gestión de artículos',
  'menu.bonusImport': 'Distribución en lote',
  'menu.operation.bonus.bonusApplyRole': 'Configuración de exclusión mutua',
  'menu.bonusReport': 'Registros de cobro',
  'menu.bonusWinOrLoseReport': 'Estadísticas de ganancias y pérdidas',
  'menu.bonus': 'Sistema preferencial',
  'menu.setting': 'Configuración de nivel VIP',
  'menu.vip': 'Gestión de nivel de membresía',
  'menu.announcement': 'Gestión de anuncios',
  'menu.operation.frontContent.articleMgmt': 'Gestión de artículos',
  'menu.operation.frontContent.articleTypeMgmt': 'Gestión de tipo de artículo',
  'menu.gamePlatformLogo': 'Gestión de icono de plataforma de juegos',
  'menu.operation.frontContent.pageMgmt': 'Gestión de página',
  'menu.frontContent': 'Gestión de contenido frontal',
  'menu.activitySetting': 'Configuración de minicuegos',
  'menu.activitySyntheticLog': 'Registro de recogida de juegos sintetizados',
  'menu.activityCashTurnLog': 'Registros de rueda de efectivo',
  'menu.activityLog': 'Registro de lotería de minicuegos',
  'menu.activityUserCount': 'Registro de cuota de minicuegos',
  'menu.operation.activity.checkin': 'Registro de recompensa de check-in',
  'menu.operation.activity.integralExchange': 'Registro de intercambio de puntos',
  'menu.activity': 'Gestión de minicuegos',
  'menu.operation.upgrade.upgradeSetting': 'Configuración de nivel',
  'menu.operation.upgrade.upgradeUser': 'Lista de jugadores',
  'menu.operation.upgrade.upgradeReport': 'Registro de problemas',
  'menu.operation.upgrade': 'Modo de actualización',
  'menu.sendSiteMsg': 'Enviar mensaje dentro del sitio',
  'menu.inbox': 'Bandeja de entrada',
  'menu.siteMsg': 'correo',
  'menu.sendMail': 'Entrega de correo',
  'menu.operation.queryPushMessageList': 'Gestión de inserción',
  'menu.operation': 'Centro de operaciones',
  'menu.information.sixLottery.queryGroupList': 'galería',
  'menu.information.sixLottery.queryTopicList': 'Gestión de publicación',
  'menu.information.sixLottery.queryReplyList': 'Gestión de respuesta',
  'menu.information.sixLottery.queryPushMessageList': 'Gestión de inserción',
  'menu.information.sixLottery.queryComplaintList': 'Gestión de quejas',
  'menu.information.sixLottery': 'Mark Six ',
  'menu.information.lotteryUserTrace.lotteryUserLevel': 'Nivel de membresía',
  'menu.information.lotteryUserTrace.lotteryUserAttention': 'Miembros preocupados',
  'menu.information.lotteryUserTrace.lotteryUserApprove': 'Miembros elogian',
  'menu.configPictureGroup': 'Configuración del grupo de imágenes',
  'menu.agentWithdraw': 'Solicitud de retiro',
  'menu.settingGamePlatform': 'Configuración de plataforma de juegos',
  'menu.pixel': 'Gestión de píxeles',
  'menu.statistics': 'Estadísticas de inserción',
  'menu.push': 'Registro de inserción',
  'menu.name': 'Gestión de nombres',
  'menu.userPush': 'Registro de inserción de usuario',

  'menu.yyg': 'Gestión de YYG',
  'menu.yygOrder': 'Gestión de pedidos',
  'menu.yygConfig': 'Configuración del sistema',
  'menu.yygCommodity': 'Gestión de mercancías',
  'menu.yygSummaryMain': 'Estadística de datos',
  'menu.yygData': 'Gestión de datos',
  'menu.yygSummaryDetail': 'Detalle de datos',
  'menu.yygMutiple': 'Configuración de idioma de plataforma múltiple',
  'menu.yygPlatform': 'Plataforma múltiple',
  'menu.yygList': 'Lista de mercancías',
  'menu.yygCategory': 'Categoría de mercancías',
  'menu.yygPlan': 'Plan de mercancías',

  'constants.riskLevelType_20': 'Aumentar método de depósito',
  'constants.riskLevelType_10': 'Depósitos suave',
  'constants.riskLevelType_0': 'ordinario',
  'constants.riskLevelType_-9': 'Limitar el retorno de agua de vez en cuando',
  'constants.riskLevelType_-20': 'Retiros restringidos',
  'constants.riskLevelType_-30': 'Inicio de sesión restringido',
  'constants.gameType_1': 'videojuego',
  'constants.gameType_2': 'Juego en vivo',
  'constants.gameType_3': 'Deportes',
  'constants.gameType_4': 'lotería',
  'constants.gameType_5': 'pesca',
  'constants.gameType_6': 'Ajedrez',
  'constants.transferType_1': 'Aumento o disminución de fondo',
  'constants.transferType_2': 'depósito',
  'constants.transferType_3': 'Retiro de efectivo',
  'constants.transferType_4': 'Cambiar a juego',
  'constants.transferType_5': 'Fuera del juego',
  'constants.transferType_8': 'Preferencia / rescate, etc',
  'constants.transferType_9': 'Depósito manual',
  'constants.transferType_10': 'Extracción manual',
  'constants.transferType_14': 'Recompensa de invitación del nombre de dominio especificado',
  'constants.transferType_15': 'Recompensas para todos',
  'constants.transferType_17': 'Recompensas de invitación para todos',
  'constants.regSourceType_0': 'Auto registro',
  'constants.regSourceType_1': 'agente',
  'constants.regSourceType_2': 'Publicidad',
  'constants.regSourceType_3': 'Marketing telemarketing',
  'constants.gameSlot_NEWBBIN': 'Nueva tragamonedas BBIN',
  'constants.gameSlot_BBIN': 'BBIN',
  'constants.gameSlot_NEWPT': 'Nueva tragamonedas Pt',
  'constants.gameSlot_NEWSA': 'Nueva tragamonedas SA',
  'constants.gameSlot_PT': 'PT',
  'constants.gameSlot_MG': 'MG',
  'constants.gameSlot_HB': 'HB',
  'constants.gameSlot_JDB': 'JDB',
  'constants.gameSlot_DT': 'DT',
  'constants.gameSlot_VT': 'VT',
  'constants.gameSlot_PNG': 'PNG',
  'constants.gameSlot_AMEBA': 'AMEBA',
  'constants.gameSlot_SKYWIND': 'Skywind',
  'constants.gameSlot_CQ9': 'CQ9',
  'constants.gameSlot_GNS': 'GNS',
  'constants.gameSlot_GSS': 'GSS',
  'constants.gameSlot_AB': 'AB',
  'constants.gameSlot_REDTIGER': 'Tigre rojo',
  'constants.gameSlot_SA': 'SA',
  'constants.gameSlot_NETENT': 'NetEnt',
  'constants.gameSlot_BETSOFT': 'BetSoft',
  'constants.gameSlot_PLAYSTAR': 'PlayStar',
  'constants.gameSlot_SG': 'SG',
  'constants.gameSlot_RTG': 'RTG',
  'constants.gameSlot_QT': 'QT',
  'constants.gameSlot_PGSOFT': 'Pgsoft',
  'constants.gameSlot1_PG': 'Pgsoft',
  'constants.gameSlot_LG': 'LG',
  'constants.gameSlot_ISOFTBET': 'Isoftbet',
  'constants.gameSlot_KingMaker': 'Tragamonedas KM',
  'constants.gameSlot_CG': 'Tragamonedas CG',
  'constants.gameSlot_CRG': 'Tragamonedas CRG',
  'constants.gameSlot_PP': 'Tragamonedas PP',
  'constants.gameSlot_SEA': 'Tragamonedas SEA',
  'constants.gameSlot_FC': 'FC',
  'constants.gameSlot_YESBINGO': 'YESBINGO',
  'constants.gameSlot_SPRIBE': 'SPRIBE',
  'constants.gameSlot_BNG': 'BNG',
  'constants.gameSlot_MW': 'MW',
  'constants.gameSlot_WG': 'WG',
  'constants.gameSlot_PCLASSICG': 'PCLASSICG',
  'constants.gameSlot1_MW': 'MW',
  'constants.gameSlot_FUNKY': 'Tragamonedas FUNKY',
  'constants.gameSlot1_JILISLOT': 'JILI',
  'constants.gameSlot1_JILI': 'JILI',
  'constants.gameSlot1_PHJILISLOT': 'PHJILI',
  'constants.gameSlot1_TTG': 'Tragamonedas TTG',
  'constants.gameSlot1_PGO': 'Tragamonedas Play\'n GO',
  'constants.gameSlot1_RT': 'Tragamonedas Red Tiger',
  'constants.gameSlot1_PRAP': 'Tragamonedas PRAGMATIC PLAY',
  'constants.gameSlot1_PST': 'Tragamonedas PLAYSTAR',
  'constants.gameSlot1_RICH': 'Tragamonedas Rich88',
  'constants.gameSlot1_FUNKY': 'Tragamonedas FUNKY',
  'constants.gameSlot1_YESBINGO': 'YESBINGO',
  'constants.gameSlot1_SPRIBE': 'SPRIBE',
  'constants.gameSlot1_BNG': 'BNG',
  'constants.gameSlot1_NEWAG': 'NEWAG',
  'constants.gameSlot1_AG': 'AG',
  'constants.gameSlot1_WG': 'WG',

  'constants.gameSlot1_SPB': 'Arcade Spribe',
  'constants.gameSlot1_OBDZ': 'Tragamonedas OBDZ',
  'constants.gameSlot1_PHPREDTIGER': 'Tragamonedas RedTiger',
  'constants.gameSlot1_FC': 'FC',
  'constants.gameSlot1_PHPSG': 'SG',
  'constants.gameSlot1_RICH88': 'RICH 88',
  'constants.gameSlot1_FCSLOT': 'Tragamonedas FC',
  'constants.gameSlot1_SEA': 'SEA',

  'constants.vipValidType_0': 'permanente',
  'constants.vipValidType_1': 'Efectivo inmediato, 30 días',
  'constants.vipValidType_3': 'Efectivo inmediato, 365 días',
  'constants.vipValidType_5': 'Efectivo inmediato, 60 días',
  'constants.vipValidType_6': 'Efectivo inmediato, 90 días',
  'constants.status_0': 'Deshabilitado',
  'constants.status_1': 'Habilitado',
  'constants.bonusType_17': 'Oferta de actualización de apuesta',
  'constants.newBonusType_1': 'Tratamiento preferencial del agua',
  'constants.newBonusType_2': 'Descuento de depósito',
  'constants.newBonusType_3': 'Invitación a descuento',
  'constants.newBonusType_5': 'Oferta de revisión manual',
  'constants.newBonusType_7': 'Preferencias de registro',
  'constants.newBonusType_8': 'Canales de depósito preferencial',
  'constants.newBonusType_9': 'Preferencia de nota',
  'constants.newBonusType_10': 'Preferencia de apuesta',
  'constants.newBonusType_11': 'Descuento de retorno de agua',
  'constants.newBonusType_12': 'Oferta de depósito en tiempo real',
  'constants.newBonusType_13': 'Oferta de vinculación de información',
  'constants.newBonusType_14': 'Descuento de lotería',
  'constants.newBonusType_15': 'Bonificación de inicio de sesión',
  'constants.newBonusType_16': 'Preferencia de depósito continuo e inversión',
  'constants.newBonusType_19': 'Descuento de tarea diaria',
  'constants.newBonusType_24': 'Invitación a descuento (Nuevo)',// 新邀请优惠
  'constants.newBonusType_26': 'Sobre rojo codificado',
  'constants.newBonusType_30': 'Oferta Big Spin',
  'constants.newBonusType_31': 'Concesiones de depósito acumulativo e inversión',
  'constants.newBonusType_32': 'Guardado de pluma de juego',
  'constants.newBonusType_33': 'Canales de retiro preferencial',
  'constants.newBonusType_34': 'Oferta de depósito de siete días',
  'constants.newBonusType_38': 'Descuento de página de recarga',
  'constants.bonusMainType_A': 'Fondo de rescate',
  'constants.bonusMainType_B': 'Bonificación de actualización',
  'constants.bonusMainType_C': 'Bonificación continua',
  'constants.bonusMainType_D': 'Requisito de depósito',
  'constants.bonusMainType_0': 'Agregar ofertas en segundo plano',
  'constants.bonusMainType_1': 'Tratamiento preferencial del agua',
  'constants.bonusMainType_2': 'Descuento de depósito',
  'constants.bonusMainType_3': 'Invitación a descuento',
  'constants.bonusMainType_4': 'Preferencia de inicio de sesión',
  'constants.bonusMainType_5': 'Oferta de revisión manual',
  'constants.bonusMainType_6': 'Preferencia de depósito continuo',
  'constants.bonusMainType_7': 'Preferencias de registro',
  'constants.bonusMainType_8': 'Canales de depósito preferencial',
  'constants.bonusMainType_9': 'Preferencia de nota',
  'constants.bonusMainType_10': 'Preferencia de apuesta',
  'constants.bonusMainType_11': 'Descuento de retorno de agua',
  'constants.bonusMainType_12': 'Oferta de depósito en tiempo real',
  'constants.bonusMainType_13': 'Oferta de vinculación de información',
  'constants.bonusMainType_14': 'Descuento de lotería',
  'constants.bonusMainType_15': 'Bonificación de inicio de sesión',
  'constants.bonusMainType_16': 'Preferencia de depósito continuo e inversión',
  'constants.bonusMainType_18': 'Lotería de minicuegos',
  'constants.bonusMainType_19': 'Descuento de tarea diaria',
  'constants.bonusMainType_24': 'Invitación a descuento', // 新邀请优惠
  'constants.bonusMainType_26': 'Sobre rojo codificado',
  'constants.bonusMainType_30': 'Oferta Big Spin',
  'constants.bonusMainType_31': 'Concesiones de depósito acumulativo e inversión',
  'constants.bonusMainType_32': 'Guardado de pluma de juego',
  'constants.bonusMainType_33': 'Canales de retiro preferencial',
  'constants.bonusMainType_34': 'Oferta de depósito de siete días',
  'constants.bonusMainType_38': 'Descuento de página de recarga',
  'constants.newBonusMainType_A': 'Fondo de rescate',
  'constants.newBonusMainType_B': 'Bonificación de actualización',
  'constants.newBonusMainType_C': 'Bonificación continua',
  'constants.newBonusMainType_0': 'Agregar bonificación manualmente',
  'constants.newBonusMainType_1': 'Tratamiento preferencial del agua',
  'constants.newBonusMainType_2': 'Descuento de depósito',
  'constants.newBonusMainType_3': 'Invitación a descuento',
  'constants.newBonusMainType_5': 'Oferta de revisión manual',
  'constants.newBonusMainType_7': 'Preferencias de registro',
  'constants.newBonusMainType_8': 'Canales de depósito preferencial',
  'constants.newBonusMainType_9': 'Preferencia de nota',
  'constants.newBonusMainType_10': 'Preferencia de apuesta',
  'constants.newBonusMainType_11': 'Descuento de retorno de agua',
  'constants.newBonusMainType_12': 'Oferta de depósito en tiempo real',
  'constants.newBonusMainType_13': 'Oferta de vinculación de información',
  'constants.newBonusMainType_14': 'Descuento de lotería',
  'constants.newBonusMainType_15': 'Bonificación de inicio de sesión',
  'constants.newBonusMainType_16': 'Preferencia de depósito continuo e inversión',
  'constants.newBonusMainType_17': 'Oferta de actualización de apuesta',
  'constants.newBonusMainType_18': 'Lotería de minicuegos',
  'constants.newBonusMainType_19': 'Descuento de tarea diaria',
  'constants.newBonusMainType_24': 'Nueva invitación a descuento',
  'constants.newBonusMainType_26': 'Sobre rojo codificado',
  'constants.newBonusMainType_21': 'Nueva oferta de puntos de inicio de sesión',
  'constants.newBonusMainType_28': 'Oferta de primer retiro',
  'constants.newBonusMainType_29': 'Oferta de resurrección',
  'constants.newBonusMainType_30': 'Oferta Big Spin',
  'constants.newBonusMainType_31': 'Concesiones de depósito acumulativo e inversión',
  'constants.newBonusMainType_32': 'Guardado de pluma de juego',
  'constants.newBonusMainType_33': 'Canales de retiro preferencial',
  'constants.newBonusMainType_34': 'Oferta de depósito de siete días',
  'constants.newBonusMainType_38': 'Descuento de página de recarga',

  'constants.bonusStatus_0': 'Solicitud',
  'constants.bonusStatus_1': 'En cálculo',
  'constants.bonusStatus_2': 'Completado',
  'constants.bonusStatus_3': 'rechazar',
  'constants.bonusStatus_4': 'fallar',
  'constants.bonusStatus_5': 'No cobrado',
  'constants.bonusStatus_6': 'No extraído',
  'constants.ticketStatus_0': 'Presentado',
  'constants.ticketStatus_1': 'En proceso',
  'constants.ticketStatus_2': 'Procesamiento completado',
  'constants.bonusConfigStatus_0': 'Editor',
  'constants.gameMaintain_0': 'No mantenido',
  'constants.gameMaintain_1': 'Mantenimiento',
  'constants.payLevel_0': 'Disponible solo para miembros de primer nivel',
  'constants.payLevel_1': 'Todos los miembros',
  'constants.payLevel_2': 'Miembros de segundo nivel y superior',
  'constants.payLevel_3': 'Miembros de nivel 3 y superior',
  'constants.payLevel_4': 'Miembros de nivel 4 y superior',
  'constants.payLevel_5': 'Miembros de nivel 5 y superior',
  'constants.payLevel_6': 'Miembros de nivel 6 y superior',
  'constants.payLevel_7': 'Miembros de nivel 7 y superior',
  'constants.payLevel_8': 'Miembros de nivel 8 y superior',
  'constants.payLevel_9': 'Nivel 9 y superior',
  'constants.payLevel_10': 'Miembro de clase diez',
  'constants.logType_ad': 'Publicidad',
  'constants.logType_admin': 'Cuenta de fondo',
  'constants.logType_agent': 'agente',
  'constants.logType_bonus': 'Descuento',
  'constants.logType_button': 'Botón',
  'constants.logType_config': 'Parámetros de configuración del sistema',
  'constants.logType_custom': 'Información de hoja de trabajo',
  'constants.logType_domain': 'nombre de dominio',
  'constants.logType_platform': 'Plataforma de juegos',
  'constants.logType_ip': 'IP',
  'constants.logType_market': 'Marketing telemarketing',
  'constants.logType_menu': 'menú',
  'constants.logType_notify': 'aviso',
  'constants.logType_pay': 'pago',
  'constants.logType_risk': 'Gestión de riesgos',
  'constants.logType_role': 'rol',
  'constants.logType_withdraw': 'Retiro de efectivo',
  'constants.logType_user': 'usuario',
  'constants.logType_picture': 'Configuración de imagen',
  'constants.logType_announcement': 'Aviso',
  'constants.logType_login': 'Inicio de sesión de fondo',
  'constants.logType_logout': 'Salida de fondo',
  'constants.agentOtherType_0': 'reembolso',
  'constants.agentOtherType_1': 'Costo de marketing',
  'constants.sysAdminType_-1': 'Administrador supremo',
  'constants.sysAdminType_-2': 'Administradores',
  'constants.activityType_1': 'rueda de la fortuna ',
  'constants.activityType_2': 'Agitar',
  'constants.activityType_3': 'Juegos de síntesis',
  'constants.activityType_4': 'Sorteo de caja ciega',
  'constants.activityType_5': 'Juegos de mesa giratoria de efectivo',
  'constants.activityChannelType_0': 'Aumento del sistema',
  'constants.activityChannelType_1': 'Aumento manual',
  'constants.activityChannelType_2': 'Declinación del sorteo',
  'constants.activityChannelType_3': 'Eliminación manual',
  'constants.prizeType_0': 'efectivo',
  'constants.prizeType_1': 'Otro',
  'constants.prizeType_2': 'Sin premio',
  'constants.prizeType_3': 'Puntos',
  'constants.announcementType_6': 'Aviso',
  'constants.announcementType_7': 'Recomendar',
  'constants.frontType_0': 'Terminal de computadora',
  'constants.frontType_1': 'Terminal móvil',
  'constants.frontType_3': 'Plataforma completa',
  'constants.siteMsgType_0': 'Problemas de depósito y retiro',
  'constants.siteMsgType_1': 'Actividades preferenciales',
  'constants.siteMsgType_2': 'Problema de juego',
  'constants.siteMsgType_3': 'Otras preguntas',
  'constants.siteMsgType_4': 'propuesta',
  'constants.siteMsgType_5': 'Queja',
  'constants.manualType_1': 'Ajuste manual de cuentas',
  'constants.manualType_9': 'Depósito manual',
  'constants.manualType_10': 'Extracción manual',
  'constants.gameSlot1_BBIN': 'BBIN',
  'constants.gameSlot1_NEWBBIN': 'Nueva tragamonedas BBIN',
  'constants.gameSlot1_PT': 'PT',
  'constants.gameSlot1_NEWPT': 'Nueva tragamonedas Pt',
  'constants.gameSlot1_MG': 'MG',
  'constants.gameSlot1_HB': 'HB',
  'constants.gameSlot1_JDB': 'JDB',
  'constants.gameSlot1_JDB2': 'JDB2',
  'constants.gameSlot1_DT': 'DT',
  'constants.gameSlot1_VT': 'VT',
  'constants.gameSlot1_PNG': 'PNG',
  'constants.gameSlot1_AMEBA': 'AMEBA',
  'constants.gameSlot1_TP': 'TP',
  'constants.gameSlot1_FKJILI': 'FKJILI',
  'constants.gameSlot1_FKJILI1': 'FKJILI1',
  'constants.gameSlot1_FKPG': 'FKPG',
  'constants.gameSlot1_FKPG1': 'FKPG1',
  'constants.gameSlot1_OMGPG': 'OMGPG',
  'constants.gameSlot1_OMGJILI': 'OMGJILI',
  'constants.gameSlot1_OMGPP': 'OMGPP',
  'constants.gameSlot1_JS2PG': 'JS2PG',
  'constants.gameSlot1_GB': 'GB',
  'constants.gameSlot1_YL': 'YL',
  'constants.gameSlot1_PCLASSICG': 'PCLASSICG',
  'constants.gameSlot1_WMDZ': 'WMDZ',
  'constants.gameSlot1_NS': 'NEXTSPIN',
  'constants.gameSlot1_WM': 'WM',
  'constants.gameSlot1_KA': 'KA',
  'constants.gameSlot1_CRG': 'CRG',
  'constants.gameSlot1_FTG': 'FTG',
  'constants.gameSlot1_VA': 'VA',
  'constants.gameSlot1_ASKME': 'ASKME',
  'constants.gameSlot1_OMG': 'OMG',
  'constants.gameSlot1_VNRICH88': 'VNRICH88',
  'constants.gameSlot1_VNRTG': 'VNRTG',
  'constants.gameSlot1_JL': 'JL',
  'constants.gameSlot1_PP': 'PP',
  'constants.gameSlot1_SKYWIND': 'Skywind',
  'constants.gameSlot1_CQ9': 'CQ9',
  'constants.gameSlot1_GNS': 'GNS',
  'constants.gameSlot1_GSS': 'GSS',
  'constants.gameSlot1_AB': 'AB',
  'constants.gameSlot1_REDTIGER': 'Tigre rojo',
  'constants.gameSlot1_SA': 'SA',
  'constants.gameSlot1_SA2': 'Nuevo SA',
  'constants.gameSlot1_MG2': 'MG2',
  'constants.gameSlot1_MG3': 'MG3',
  'constants.gameSlot1_NETENT': 'NetEnt',
  'constants.gameSlot1_BETSOFT': 'BetSoft',
  'constants.gameSlot1_PLAYSTAR': 'Playstar',
  'constants.gameSlot1_SG': 'SG',
  'constants.gameSlot1_RTG': 'RTG',
  'constants.gameSlot1_QT': 'QT',
  'constants.gameSlot1_PGSOFT': 'Pgsoft',
  'constants.gameSlot1_LG': 'LG',
  'constants.gameSlot1_ISOFTBET': 'Isoftbet',
  'constants.gameSlot1_TOTALEGAME': 'Totalegame',
  'constants.gameLive2_AG': 'AG',
  'constants.gameLive2_NEWAG': 'New AG',
  'constants.gameLive2_EBET': 'EBET',
  'constants.gameLive2_OG': 'OG',
  'constants.gameLive2_OG1': 'OG1',
  'constants.gameLive2_BG': 'BG',
  'constants.gameLive2_BG2': 'New BG',
  'constants.gameLive2_GD': 'GD',
  'constants.gameLive2_EG': 'EG real person',
  'constants.gameLive2_SB': 'SB Live',
  'constants.gameLive2_TS': 'TS Live',
  'constants.gameLive2_DG': 'DreamGame',
  'constants.gameLive2_SEXY': 'Sexy Live',
  'constants.gameLive2_VENUS': 'Venus Live',
  'constants.gameLive2_MAYE': 'Maya Live',
  'constants.gameLive2_AB': 'AB',
  'constants.gameLive2_BBIN': 'BBIN',
  'constants.gameLive2_NEWBBIN': 'NEWBBIN',
  'constants.gameLive2_SA': 'SA',
  'constants.gameLive2_TP': 'TP',
  'constants.gameLive2_GPI': 'GPI',
  'constants.gameLive2_NEWSA': 'New SA',

  'constants.gameSport3_XSPORT': 'HAHA Sport',
  'constants.gameSport3_AVIA': 'AVIA E-sports',
  'constants.gameSport3_IBC': 'IBC Sports',
  'constants.gameSport3_UG': 'UG Sports',
  'constants.gameSport3_UG2': 'UG Sports',
  'constants.gameSport3_PINGBO': 'PINGBO Sports',
  'constants.gameSport3_BETLINK': 'BetLink Sports',
  'constants.gameSport3_IM': 'IM Sports',
  'constants.gameSport3_IMDJ': 'IM Sports',
  'constants.gameSport3_XINBAO': 'XINBAO Sports',
  'constants.gameSport3_IBC2': 'IBC2 ESports',
  'constants.gameSport3_ESPORTS': 'ESports',
  'constants.gameSport3_THREESING': '3 liters of sports',
  'constants.gameSport3_UWIN': 'UWIN E-sports',
  'constants.gameSport3_DSDJ': 'Dongsen E-sports',
  'constants.gameSport3_SPB': 'SPB Arcade',
  'constants.gameSport3_PHSBO': 'SBO Sport',
  'constants.gameSport3_NEWIM': 'NEW IM',
  'constants.gameLottery4_CQ': 'ST lottery',
  'constants.gameLottery4_VR': 'VR lottery',
  'constants.gameLottery4_VL': 'VL lottery',
  'constants.gameLottery4_KG': 'KG lottery',
  'constants.gameLottery4_DSEN': 'DSEN lottery',
  'constants.gameLottery4_TCG': 'TCG lottery',
  'constants.gameLottery4_TCG_VN': 'TCG lottery',
  'constants.gameLottery4_IG_GFC': 'IG official colors',
  'constants.gameLottery4_GS': 'Local lottery',
  'constants.gameLottery4_DBCP': 'DB lottery',
  'constants.gameLottery4_NEWDB': 'DB lottery',
  'constants.gameLottery4_TP': 'TP',
  'constants.gameLottery4_BBIN': 'BBIN',
  'constants.gameLottery4_DB': 'DB lottery',
  'constants.gameLottery4_SPRIBE': 'SPRIBE lottery',
  'constants.gameLottery4_CG': 'CG lottery',
  'constants.gameLottery4_QQK': 'QQKeno lottery',
  'constants.gameLottery4_FG': 'Funky Games lottery',
  'constants.gameLottery4_SEA': 'Sealotto lottery',
  'constants.gameLottery4_YESB': 'YES BINGO lottery',
  'constants.gameLottery4_YESBINGO': 'YES BINGO lottery',
  'constants.gameLottery4_AE': 'AE',

  'constants.gameFish5_GG': 'GG fishing',
  'constants.gameFish5_BBIN': 'BBIN',
  'constants.gameFish5_NEWBBIN': 'NEWBBIN',
  'constants.gameFish5_SA': 'SA',
  'constants.gameFish5_SA2': 'New SA',
  'constants.gameFish5_AG': 'AG',
  'constants.gameFish5_NEWAG': 'New AG',
  'constants.gameFish5_OBBY': 'OBBY',
  'constants.gameChess6_OBQP': 'DB Chess',
  'constants.gameFish5_JILI': 'JILI',
  'constants.gameFish5_TP': 'TP',
  'constants.gameFish5_YL': 'YL',
  'constants.gameFish5_KA': 'KA',
  'constants.gameFish5_VA': 'VA',
  'constants.gameFish5_FTG': 'FTG',
  'constants.gameFish5_PLAYSTAR': 'PLAYSTAR',
  'constants.gameFish5_ASKME': 'ASKME',
  'constants.gameFish5_VNRTG': 'VNRTG',
  'constants.gameFish5_FC': 'FC',
  'constants.gameFish5_YESBINGO': 'YESBINGO',
  'constants.gameFish5_LUCKY': 'Lucky',
  'constants.gameFish5_PHPSG': 'SG',
  'constants.gameFish5_WG': 'WG',

  'constants.gameFish5_ACE': 'ACE Fish',
  'constants.gameFish5_SGFISH': 'SG Fish',
  'constants.gameFish5_JDB': 'JDB',
  'constants.gameFish5_PHJILI': 'PHJILI',
  'constants.gameChess6_KY': 'KY Chess',
  'constants.gameChess6_LUCKY': 'LUCKY Chess',
  'constants.gameChess6_V8': 'V8 Chess',
  'constants.gameChess6_LY': 'LY Chess',
  'constants.gameChess6_YL': 'YL Chess',
  'constants.gameChess6_KM': 'KM Chess',
  'constants.gameChess6_TP': 'TP',
  'constants.gameChess6_VNRICH88': 'VNRICH88',
  'constants.gameChess6_FTG': 'FTG',
  'constants.gameChess6_PHJILI': 'PHJILI',
  'constants.gameChess6_WG': 'WG',
  'constants.gameChess6_KINGMAKER_CHESS': 'KINGMAKER Chess',
  'constants.gameChess6_VG': 'VG Chess',
  'constants.gameChess6_SSO761': '761 Chess',
  'constants.gameChess6_LEG': 'LEG Chess',
  'constants.gameChess6_CS': 'Fortune Chess',
  'constants.gameChess6_GAMMA': 'Gama Chess',
  'constants.gameChess6_HT': 'Spade Chess',
  'constants.gameChess6_JILI': 'JILI',
  'constants.gameChess6_PHKM': 'KM Chess',

  'constants.platforms_BBIN': 'BBIN',
  'constants.platforms_NEWBBIN': 'NEWBBIN',
  'constants.platforms_SA': 'SA',
  'constants.platforms_SA2': 'New SA',
  'constants.platforms_NEWSA': 'New SA',
  'constants.platforms_AG': 'AG',
  'constants.platforms_NEWAG': 'New AG',
  'user.searchUser': 'Usuario encontrado, nombre de usuario: {userAccount}',
  'user.searchUserFail': 'Usuario no encontrado',
  'user.logout': 'Cerrar sesión',
  'user.changePass': 'Cambiar contraseña',
  'user.title.message': 'noticias',
  'user.title.memberGroup': 'Grupo de miembros',
  'user.empty.message': 'Ha leído todos los mensajes',
  'user.icon.online': 'En línea',
  'user.button.confirm': 'confirmar',
  'user.form.oldPass': 'Ingrese la contraseña anterior',
  'user.form.newPass': 'Ingrese una contraseña nueva',
  'user.form.newPassAgain': 'Ingrese la contraseña nueva nuevamente',
  'msg.clear': 'limpiar',
  'msg.allRead': 'Todo leído',
  'msg.closeBeep': 'Desactivar el sonido',
  'msg.openBeep': 'Activar el sonido',
  'bet.title.platformCode': 'Número de plataforma',
  'bet.title.betAmount': 'Monto de la apuesta',
  'bet.title.betflow': 'Suma efectiva',
  'common.title.resultAmount': 'Rentabilidad de la plataforma',
  'bet.title.betTime': 'Hora de la apuesta',
  'bet.title.createTime': 'Tiempo de liquidación',
  'pay.label.pageAmount': 'Monto de esta página',
  'pay.label.pageUnTotal': 'Número de órdenes de efectivo en la aplicación en esta página',
  'pay.label.pageRiskSuccess': 'Número de órdenes revisadas por control de riesgo en esta página',
  'pay.label.pageSuccess': 'Número de órdenes retiradas exitosamente en esta página',
  'pay.label.pageRefuse': 'Número de órdenes rechazadas en esta página',
  'pay.label.amount': 'Suma total',
  'pay.label.unTotal': 'Número de órdenes de efectivo en total',
  'pay.label.riskSuccessTotal': 'Número de órdenes revisadas por control de riesgo general',
  'pay.label.successTotal': 'Número total de órdenes retiradas exitosamente',
  'pay.label.refuseTotal': 'Órdenes de efectivo rechazadas totales',
  'bet.label.pageBet': 'Monto de apuesta en esta página (yuan)',
  'bet.label.pageBetVN': 'Monto de apuesta en esta página (VND)',
  'bet.label.pageFlow': 'Apuesta efectiva en esta página (yuan)',
  'bet.label.pageFlowVN': 'Apuesta efectiva en esta página (VND)',
  'bet.label.pageProfit': 'Ganancia de la plataforma en esta página (yuan)',
  'bet.label.pageProfitVN': 'Ganancia de la plataforma en esta página (VND)',
  'bet.label.totalBet': 'Apuesta total (yuan)',
  'bet.label.totalBetVN': 'Apuesta total (VND)',
  'bet.label.totalFlow': 'Apuesta efectiva total (yuan)',
  'bet.label.totalFlowVN': 'Apuesta efectiva total (VND)',
  'bet.label.totalProfit': 'Ganancia total de la plataforma (yuan)',
  'bet.label.totalProfitVN': 'Ganancia total de la plataforma (VND)',
  'bet.strAttr1.game': 'Juego',
  'bet.strAttr1.platType': 'Tipo de plataforma',
  'bet.strAttr1.period': 'Número de ronda',
  'bet.strAttr1.titleNumber': 'Número de mesa',
  'bet.strAttr1.result': 'Resultado',
  'game.platform.order': 'Número de plataforma: {gsId}',
  'game.game.order': 'Número de juego: {bizNo}',
  'bet.export.exportName': 'Exportación de registro de apuestas',
  'bet.export.title': 'Sugerencia de exportación',
  'bet.export.content': 'La tarea de exportación ha entrado en la cola de exportación. Haga clic en Aceptar para ver el progreso de la exportación. También puede ver la descarga más tarde a través de la consola - > Exportar datos',
  'bet.queryFrm.betDate': 'Hora de la apuesta',
  'bet.queryFrm.createDate': 'Tiempo de liquidación',
  'bet.queryFrm.platformCode': 'Plataforma de juegos',
  'bet.queryFrm.gameType': 'Tipo de juego',
  'bet.select.gameType': 'Seleccione el tipo de juego',
  'user.chart.memberCount': 'Número de miembros',
  'user.chart.memberCount1': 'Número de usuarios (persona)',
  'user.title.activeUser': 'Usuarios activos',
  'user.title.peopleNumber': 'Número',
  'user.title.register': 'registrarse',
  'common.chart.orderCount': 'Volumen de órdenes (1000 órdenes)',
  'common.chart.orderCount1': 'Volumen de órdenes',
  'common.chart.betOrderCount': 'Volumen de apuestas',
  'common.chart.date': 'fecha',
  'common.chart.date1': 'Seleccione una fecha',
  'common.chart.percentage': 'Porcentaje',
  'common.chart.user': 'usuario',
  'common.chart.count': 'Número',
  'common.chart.amount': 'Monto (10000 yuan)',
  'common.chart.amount1': 'Monto de dinero',
  'common.chart.amount3': 'Monto (yuan)',
  'common.chart.amount3VN': 'Monto (VND)',
  'common.chart.validBet': 'Apuesta efectiva',
  'common.chart.amount2': 'Monto (mil yuan)',
  'bet.chart.bettingSettlement': 'Liquidación de apuestas',
  'finance.title.prompt': 'Consejos',
  'finance.content.prompt': '¿Desea incluirlo en el depósito?',
  'finance.content.prompt2': '¿Desea no incluirlo en el depósito?',
  'bet.title.userAccount': 'Nombre de miembro',
  'bet.title.ticketNumber': 'Número de boleto',
  'finance.title.transNoAndTransName': 'Número de orden / nombre',
  'finance.title.transName': 'Nombre: {transDetail}',
  'finance.title.transType': 'Tipo de ajuste de cuenta',
  'finance.title.amount': 'Monto del ajuste de cuenta',
  'finance.title.transType1': 'modo',
  'finance.title.transType1_1': 'Sin contabilizar',
  'finance.title.transType1_9': 'Acreditado al depósito',
  'finance.title.transType1_10': 'Contabilización de retiros',
  'finance.title.afterAmount': 'Saldo después',
  'finance.title.remark': 'Observaciones',
  'finance.title.remark1': 'Ingrese comentarios',
  'finance.title.createTimeAndCreateAdmin': 'createTimeAndCreateAdmin',
  'finance.title.updateTimeAndUpdateAdmin': 'updateTimeAndUpdateAdmin',
  'finance.title.totalAmount': 'Suma total',
  'finance.title.totalOrderCount': 'Número total de órdenes',
  'finance.button.call': 'Llamar',
  'finance.export.name': 'Informe de reconciliación.xls',
  'finance.queryFrm.ManualTransferDate': 'Tiempo de ajuste de cuenta',
  'finance.queryFrm.ManualTransferType': 'Tipo de ajuste de cuenta',
  'finance.queryFrm.urmoo': 'Nombre de usuario, observación, ajustador de cuenta, número de orden, nombre de orden',
  'finance.queryFrm.urmoo2': 'Ingrese palabras clave de observaciones/ajustador de cuenta',
  'user.title.name': 'Nombre completo',
  'user.title.mobilePhone': 'Nombre completo',
  'user.title.idNo': 'Número de contacto',
  'user.title.regType': 'fuente',
  'user.title.domain': 'Última URL de inicio de sesión',
  'user.title.registerTime': 'Fecha de registro',
  'user.title.createTime': 'Tiempo en línea',
  'user.title.level': 'Nivel | nivel de control de riesgo',
  'user.title.totalDeposit': 'Depósito total',
  'user.title.totalWithdraw': 'Retiros totales',
  'user.title.totalBonus': 'Descuento total',
  'user.title.balance': 'Saldo total de la cuenta maestra',
  'user.description.totalUserNum': 'Número en línea',
  'user.description.totalDeposit': 'Depósitos totales de miembros en línea actuales',
  'user.description.totalWithdraw': 'Retiro total de miembros en línea actuales',
  'user.description.totalBonus': 'Ofertas totales para miembros en línea actuales',
  'user.description.totalBetFlow': 'Flujo de membresía en línea total actual',
  'user.radio.onlineUserType_-1': 'No seleccionado',
  'user.radio.onlineUserType_1': 'Depósito total',
  'user.radio.onlineUserType_2': 'Retiros totales',
  'user.radio.onlineUserType_3': 'Descuento total',
  'user.radio.onlineUserType_4': 'Saldo actual',
  'user.select.channelType_1': 'No seleccionado',
  'user.select.channelType_0': 'Depósito total',
  'user.select.channelType_4': 'Retiros totales',
  'user.select.channelType_2': 'Descuento total',
  'user.select.channelType_3': 'Saldo actual',
  'sys.title.createTime': 'Tiempo de operación',
  'sys.title.createAdmin': 'Operador',
  'sys.title.beingAdmin': 'Operador',
  'sys.title.operatingMsg': 'Instrucciones de operación',
  'sys.title.resultMsg': 'El resultado muestra',
  'sys.title.logType': 'Tipo de registro',
  'sys.title.operatingStatus': 'Estado de operación',
  'sys.title.operatingStatusFail': 'fallo',
  'sys.title.operatingStatusSuccess': 'Éxito',
  'bonus.title.newNumber': 'usuario nuevo',
  'bonus.title.oldNumber': 'Usuarios antiguos',
  'bonus.title.oldUserRatio': 'Proporción de usuarios antiguos',
  'analyze.card.cumulativeUser': 'Usuario acumulativo',
  'analyze.card.last7dayActiveUser': 'Usuarios activos en los últimos 7 días',
  'analyze.card.last30dayActiveUser': 'Usuarios activos en los últimos 30 días',
  'analyze.card.moreWaitting': 'Próximamente',
  'analyze.card.cumulativePayingUser': 'Usuarios pagadores acumulativos',
  'analyze.card.cumulativePaymentAmount': 'Monto de pago acumulado',
  'analyze.card.paymentRate': 'Tasa',
  'analyze.card.userComposition': 'Composición de usuarios',
  'analyze.card.activeUserComposition': 'Composición de usuario activo',
  'analyze.card.newUsers': 'Usuarios nuevos',
  'analyze.card.firstDepositUsers': 'Usuario de primer depósito',
  'analyze.card.withdrawalUsers': 'Usuario de retiros',
  'analyze.card.depositUsers': 'Usuario de depósito',
  'analyze.card.activeUser': 'Usuarios activos',
  'analyze.card.depositBet': 'Usuarios de depósito y apuesta total',
  'analyze.card.depositUsersDistinct': 'Usuario de depósito (distinto)',
  'analyze.card.activeUserDistinct': 'Usuarios activos (distinto)',
  'analyze.card.userRecharge': 'Recarga del usuario',
  'analyze.card.top-upUser': 'Usuarios de recarga',
  'analyze.card.depositAmount': 'Monto de recarga',
  'analyze.card.firstDepositAmount': 'Monto del primer cargo',
  'analyze.card.totalDeposit': 'Depósitos totales',
  'analyze.card.totalWithdrawal': 'Retiros totales',
  'analyze.card.offerDiscount': 'Trato preferencial',
  'analyze.card.platformFlow': 'Flujo de la plataforma',
  'analyze.card.platformFlow1': 'Flujo de plataforma (yuan)',
  'analyze.card.platformFlow1VN': 'Flujo de plataforma (VND)',
  'analyze.card.betUserCount': 'Número de personas apostando (por plataforma)',
  'analyze.card.betUserCount1': 'Número de apuestas',
  'analyze.card.orderCount': 'Cantidad de órdenes',
  'finance.title.firstDeposit': 'Primer depósito',
  'finance.title.totalDeposit': 'Almacenamiento total',
  'finance.title.totalWithdraw': 'Retiro total',
  'finance.title.totalBetflow': 'Flujo total',
  'finance.title.totalWin': 'Diferencia de reserva',
  'finance.title.profitLoss': 'Pérdidas y ganancias',
  'pay.platformName': 'plataforma de pago',
  'pay.orderAmount': 'Monto de la orden',
  'pay.orderCount': 'Monto de la orden',
  'pay.platformNameOrderAmount': 'Plataforma de pago * monto de la orden',
  'pay.platformNameOrderCount': 'Plataforma de pago * monto de la orden',
  'pay.title.amountStatistics': 'Estadísticas de monto de transacción de plataforma de pago',
  'pay.title.countStatistics': 'Estadísticas de transacción de plataforma de pago',
  'pay.title.successChannelRate': 'Tasa de éxito de pago de cada canal',
  'pay.title.usageRatio': 'Proporción de plataformas de pago utilizadas',
  'pay.title.successRatio': 'Porcentaje de éxito de la plataforma de pago',
  'pay.title.payName': 'Nombre del tercero',
  'pay.title.successCount': 'Número de operaciones exitosas',
  'pay.title.successAmount': 'Monto de éxito',
  'pay.title.orderCount': 'Número total de órdenes',
  'pay.title.amountSummary': 'Suma total',
  'pay.title.successRate': 'Tasa de éxito',
  'pay.export.payExcel': 'Informe de tasa de éxito de pago.xls',
  'pay.label.settlementDate': 'Fecha de liquidación',
  'pay.label.allChannel': 'Todos los canales',
  'pay.label.allPayType': 'Todos los tipos de pago',
  'pay.label.payChannel': 'Canal de pago',
  'pay.label.payChannel1': 'Seleccione el canal de pago',
  'pay.label.payType': 'Tipo de pago',
  'pay.label.payType1': 'Seleccione el tipo de pago',
  'pay.label.useLevel': 'Nivel de uso',
  'pay.label.useLevel1': 'Seleccione el nivel de uso',
  'pay.label.useLevelAbove': '¿A qué nivel necesita llegar?',
  'pay.label.depositMin': 'Suma mínima',
  'pay.label.depositMin1': 'Ingrese el monto mínimo',
  'pay.label.depositMax': 'Monto máximo',
  'pay.label.depositMax1': 'Ingrese el monto máximo',
  'pay.label.depositAmountNotice': 'Ingrese un monto legal',
  'pay.label.depositRequest': 'Requisito de recarga',
  'pay.label.depositRequest1': 'Ingrese requisito de recarga',
  'pay.label.param': 'parámetro',
  'pay.label.orderSort': 'Orden de arreglo',
  'pay.label.orderSort1': 'Ingrese orden legal',
  'pay.label.amountType': 'Tipo de monto',
  'pay.label.amountType1': 'Seleccione el tipo de monto',
  'pay.label.exchangeType': 'Seleccione el tipo de tipo de cambio',
  'pay.label.amountType_1': 'Monto de entrada del usuario',
  'pay.label.amountType_2': 'Lista de monto fijo',
  'pay.label.amountType_3': 'Ambos soportados',
  'pay.label.fixedAmountList': 'Monto fijo',
  'pay.label.fixedAmountList1': 'Ingrese un monto fijo',
  'pay.label.fixedAmountList2': 'Ingrese un monto fijo de hasta 200 caracteres',
  'pay.label.fixedAmountList3': 'Ingrese un monto fijo. Para más de un monto, use coma para dividir',
  'pay.label.cardNumber': 'Cuenta bancaria',
  'pay.label.cardOwner': 'Nombre del titular de la tarjeta',
  'pay.label.withdrawalAmount': 'Monto de retiro',
  'pay.label.withdrawalAmount1': 'Monto de retiro',
  'pay.label.withdrawType': 'Método de retiro',
  'pay.label.withdrawInfo': 'Información de pago',
  'pay.withdraw.apName': 'Nombre de Alipay',
  'pay.withdraw.apName_jk4': 'Nombre de GCash',
  'pay.withdraw.apAccount': 'Número de cuenta de Alipay',
  'pay.withdraw.apAccount_jk4': 'Número de cuenta de GCash',
  'pay.withdraw.usdtPayCount': 'Recuento de pagos',
  'pay.withdraw.cardOwner': 'Nombre de cuenta',
  'pay.withdraw.bankName': 'Banco asociado',
  'pay.withdraw.bankNumber': 'Número de tarjeta',
  'pay.label.bankName': 'Nombre del banco',
  'pay.label.bankName1': 'Ingrese nombre del banco',
  'pay.label.bankName2': 'Ingrese hasta 25 caracteres',
  'pay.label.bankAccount': 'Beneficiario',
  'pay.label.bankAccount1': 'Ingrese beneficiario',
  'pay.label.bankAccount2': 'Ingrese hasta 50 caracteres',
  'pay.label.bankAccount3': 'Ingrese hasta 100 caracteres',
  'pay.label.bankAccount4': 'Ingrese hasta 20 caracteres',
  'pay.label.bankAddr': 'Apertura de cuenta',
  'pay.label.bankAddr1': 'Ingrese la sucursal de apertura de cuenta',
  'pay.label.bankNumber': 'Número de tarjeta bancaria',
  'pay.label.bankNumber1': 'Ingrese el número de tarjeta bancaria',
  'pay.label.qrCode': 'Código QR',
  'pay.label.qrCode1': 'Cargue el código QR',
  'pay.label.payDesc': 'Descripción recomendada',
  'pay.label.payDesc1': 'Ingrese una descripción de recomendación',
  'pay.label.payDesc3': 'Ingrese descripción recomendada de hasta 200 caracteres',
  'pay.label.payViewName': 'Nombre personalizado del canal',
  'pay.label.payViewName1': 'Ingrese un nombre personalizado',
  'pay.loadConfigInfoFail': 'Error al cargar la información de configuración de pago',
  'pay.loadConfigInfoError': 'Error al cargar la información de configuración de pago',
  'pay.title.channelName': 'Nombre del canal',
  'pay.title.channelName1': 'Ingrese el nombre del canal',
  'pay.title.channelName2': 'Ingrese su nombre de canal personalizado',
  'analyze.title.cumulativeUsers': 'Usuarios acumulativos (usuarios de canal total / usuarios de plataforma total)',
  'pay.title.payCode': 'Número de canal',
  'pay.title.viewName': 'Tipo de canal',
  'pay.title.remark': 'Nombre de canal autodeterminado',
  'pay.title.depositMin': 'Limitación de monto',
  'common.agent': 'agente',
  'common.channel': 'agente',
  'common.title.agentAccount': 'Cuenta proxy',
  'common.title.agentCode': 'Código de agente',
  'agent.h3.channelDistribution': 'Distribución de canales',
  'finance.title.depositTime': 'Tiempo de depósito',
  'finance.title.depositAmount': 'Monto de depósito',
  'finance.title.depositType': 'Forma de depósito',
  'finance.title.totalDepositUsers': 'Número total de miembros',
  'finance.title.totalDepositAmount': 'Monto total de depósito (yuan)',
  'finance.title.totalDepositAmountVN': 'Monto total de depósito (VND)',
  'finance.export.excel': 'Informe de depósito.xls',
  'bonus.export.excel': 'Informe de oferta.xls',
  'bonus.title.offerTime': 'Tiempo de pago preferencial',
  'finance.title.bonusAmount': 'Monto preferencial',
  'finance.title.bonusName': 'Nombre preferencial',
  'finance.title.approveAdmin': 'Agregar operador manualmente',
  'finance.title.totalUserCount': 'Recuento total de usuarios',
  'finance.title.totalBonusAmount': 'Monto total de bonificación',
  'game.title.betUsers': 'Usuarios apostadores',
  'game.title.betOrderCount': 'Cantidad de apuestas',
  'game.title.betAmount': 'Monto de apuesta (yuan)',
  'game.title.betAmountVN': 'Monto de apuesta (VND)',
  'game.title.playerProfit': 'Ganancia del jugador (yuan)',
  'game.title.playerProfitVN': 'Ganancia del jugador (VND)',
  'game.title.platformProfit': 'Ganancia de la plataforma (yuan)',
  'game.title.platformProfitVN': 'Ganancia de la plataforma (VND)',
  'game.title.platformProfitLose': 'Pérdidas y ganancias de la plataforma',
  'user.title.pageBetOrderCount': 'Número total de apuestas en esta página',
  'user.title.pageBetAmount': 'Apuesta total en esta página',
  'user.title.pagePlayerResultAmount': 'Total de ganancias o pérdidas de jugadores en esta página',
  'user.title.pageBetflow': 'Flujo total en esta página',
  'user.title.totalOrderCount': 'Número total de apuestas',
  'user.title.totalResultAmount': 'Total de ganancias de jugadores',
  'pay.title.pageOrderAmount': 'Monto de orden en esta página',
  'pay.title.pagePaidOrders': 'Número de órdenes pagadas en esta página',
  'pay.title.pageUnpaidOrders': 'Número de órdenes no pagadas en esta página',
  'pay.title.pageExpiredOrders': 'Número de órdenes vencidas en esta página',
  'pay.title.totalOrderAmount': 'Monto total de orden',
  'pay.title.totalPaidOrders': 'Órdenes pagadas totales',
  'pay.title.totalUnpaidOrders': 'Órdenes no pagadas totales',
  'pay.title.totalExpiredOrders': 'Órdenes vencidas totales',
  'game.title.pageBetUserCount': 'Número de usuarios en esta página',
  'game.title.pageBetOrderCount': 'Cantidad de apuestas en esta página',
  'game.title.pageBetAmount': 'Monto de apuesta en esta página (yuan)',
  'game.title.pageBetAmountVN': 'Monto de apuesta en esta página (VND)',
  'game.title.pagePlatformProfit': 'Ganancia de la plataforma en esta página (yuan)',
  'game.title.pagePlatformProfitVN': 'Ganancia de la plataforma en esta página (VND)',
  'game.title.totalUserCount': 'Usuarios apostadores totales',
  'game.title.totalOrderCount': 'Volumen de apuesta total',
  'game.title.totalBetAmount': 'Apuesta total (yuan)',
  'game.title.totalBetAmountVN': 'Apuesta total (VND)',
  'game.title.totalBetAmount1': 'Apuesta total',
  'game.title.totalPlatformProfit': 'Ganancia total de la plataforma (yuan)',
  'game.title.killRate': 'Tasa de ganancia(%)',
  'game.title.killRateFormulas': 'Tasa de ganancia=Ganancia total de la plataforma/Apuesta total',
  'game.title.totalPlatformProfitVN': 'Ganancia total de la plataforma (VND)',
  'game.title.totalPlayerResultAmount': 'Ganancias o pérdidas del jugador',
  'game.title.totalPlayerResultAmount1': 'Ganancias o pérdidas del jugador',
  'finance.title.pageDepositCount': 'Número total de recargas en esta página',
  'finance.title.pageDepositAmount': 'Depósito total en esta página',
  'finance.title.pageFirstAmount': 'Primer depósito en esta página',
  'finance.title.totalDepositProfit': 'Número total de recargas',
  'finance.title.totalDepositAmount2': 'Depósito total (yuan)',
  'finance.title.totalDepositAmount2VN': 'Depósito total (VND)',
  'finance.title.totalFirstDepositAmount': 'Cargo inicial total (yuan)',
  'finance.title.totalFirstDepositAmountVN': 'Cargo inicial total (VND)',
  'game.export.platformExcel': 'Informe de plataforma de juegos.xlsx',
  'game.title.platformName': 'Nombre de plataforma',
  'game.title.platformName1': 'Ingrese nombre de plataforma',
  'common.title.dataDetail': 'Detalles de datos',
  'finance.title.withdrawalTime': 'Tiempo de retiro',
  'finance.title.withdrawalAmount': 'Monto de retiro',
  'finance.title.withdrawalType': 'Método de retiro',
  'finance.title.withdrawalType2': 'Método de retiro',
  'finance.title.totalWithdrawUsers': 'Recuento total de usuarios de retiro',
  'finance.title.totalWithdrawAmount': 'Monto total de retiro',
  'finance.export.withdrawalExcel': 'Informe de retiro.xls',
  'finance.export.userDepositExcel': 'Informe de recarga de usuario.xls',
  'user.export.userGameExcel': 'Informe de juego del usuario.xlsx',
  'activity.export.excel': 'Registro de lotería de mini juegos.xls',
  'common.title.type': 'tipo',
  'common.title.type1': 'Autenticación de nombre real',
  'common.title.type2': 'SMS',
  'common.title.type3': '¿Hay un nombre real?',


  'msg.title.certificationTime': 'Tiempo de autenticación',
  'msg.title.period': 'Ranura de tiempo',
  'game.title.gameName': 'Nombre del juego',
  'bet.title.betFlowId': 'Número de serie',
  'bet.title.rawData': 'Datos sin procesar (hora de la plataforma de juegos)',
  'finance.title.depositCount': 'Número de recargas',
  'finance.title.totalDepositAmount1': 'Monto total de recarga',
  'finance.title.firstDepositTime': 'Hora del primer cargo',
  'finance.title.lastDepositTime': 'Hora de la última recarga',
  'finance.text.addBlacklist': 'Agregar a la lista negra',
  'finance.title.disablePaymentChannels': 'Deshabilitar canales de pago',
  'finance.label.selectDisablePaymentChannels': 'Seleccione canales de pago a deshabilitar',
  'user.title.lastLoginTime': 'Hora del último inicio de sesión',
  'user.title.userLevel': 'Nivel de usuario',
  'user.title.riskLevel': 'Nivel de riesgo',
  'user.title.registerIP': 'IP registrada',
  'user.title.registerAddress': 'Dirección registrada',
  'user.title.registerType': 'Tipo de registro',
  'analyze.title.statisticalDate': 'Fecha estadística',
  'user.title.betOrderCount': 'Número de apuestas',
  'user.title.betAmount': 'Monto de apuesta',
  'user.title.dataOverview': 'Descripción general de datos',
  'user.title.displayNumber': 'Número de pantalla',
  'sys.title.exportName': 'Nombre',
  'sys.title.exportName1': 'Ingrese el nombre correcto',
  'sys.title.nodeNumber': 'Número de nodo',
  'sys.title.exportStatus': 'Estado de exportación',
  'sys.title.exportStatus0': 'Esperando exportación',
  'sys.title.exportStatus1': 'completado',
  'sys.title.exportStatus2': 'fallo',
  'sys.title.exportStatus3': 'Exportando',
  'sys.title.exportStatus4': 'Descarga expirada',
  'sys.title.finishTime': 'Tiempo de finalización',
  'sys.title.nameAndNumber': 'Nombre / número',
  'sys.title.confirmDelete': 'confirmar eliminación',
  'sys.title.deletePicGroup': 'A punto de eliminar configuración de grupo de imágenes: {imgCode}',
  'sys.title.deleteButton': 'Botón a ser eliminado: {btnName}',
  'sys.title.deleteConfig': 'Configuración a ser eliminada: {configKey}',
  'sys.title.deleteMenuName': 'Menú a ser eliminado: {menuName}',
  'sys.title.deleteNotifyName': 'Tipo de notificación a ser eliminado: {notifyName}',
  'sys.title.deleteBeforeDisable': 'Para evitar errores, deshabilite antes de eliminar',
  'sys.title.addGroupConfig': 'Agregar configuración de grupo',
  'sys.title.repeatGroup': 'Agregar configuración de grupo',
  'sys.title.imgCode': 'Código de grupo de imágenes',
  'sys.title.imgCode1': 'Código de grupo de imágenes:',
  'sys.title.imgCode2': 'Ingrese código de grupo de imágenes',
  'sys.title.imgName': 'Nombre del grupo de imágenes',
  'sys.title.imgName1': 'Nombre del grupo de imágenes:',
  'sys.title.imgName2': 'Ingrese nombre del grupo de imágenes',
  'sys.title.remark': 'describir',
  'sys.title.remark1': 'Descripción:',
  'sys.title.remark2': 'Descripción del grupo de imágenes',
  'sys.title.maxAmount': 'Número máximo de imágenes que se pueden transferir',
  'sys.title.maxAmount1': 'Número máximo de imágenes que se pueden transferir:',
  'sys.title.maxAmount2': 'Número máximo de imágenes que se pueden transferir',
  'user.title.submit': '¿Enviar?',
  'user.title.confirmSubmit': 'Verifique que la información sea correcta y envíela cuidadosamente',
  'user.title.notSamePass': 'La contraseña es inconsistente, verifique',
  'user.title.wrongPassNotice': 'Solo puede comenzar con una letra minúscula, solo contiene letras minúsculas y números',
  'user.title.existUser': 'El usuario ya existe',
  'user.title.addBackAccount': 'Agregar cuenta de fondo',
  'user.title.minUserNameLength': 'Ingrese un nombre de usuario de menos de 6 caracteres',
  'user.title.maxUserNameLength': 'Ingrese un nombre de usuario de hasta 25 caracteres',
  'user.title.userNameLengthLimit': 'Ingrese nombre de usuario de inicio de sesión, 6-25 caracteres',
  'user.title.name1': 'Ingrese un nombre',
  'user.title.name2': 'Ingrese el nombre correcto',
  'user.title.pass': 'Contraseña',
  'user.title.pass1': 'Ingrese la contraseña de inicio de sesión y déjela en blanco',
  'user.title.pass2': 'Ingrese una contraseña',
  'user.title.pass3': 'Ingrese la contraseña de inicio de sesión',
  'user.title.pass4': 'Confirmar contraseña',
  'user.title.pass5': 'Ingrese la contraseña de inicio de sesión nuevamente',
  'user.title.pass6': 'Confirme la contraseña',
  'user.title.mail': 'buzón',
  'user.title.mail1': 'Ingrese el correo electrónico correcto',
  'user.title.mail2': 'Ingrese correo electrónico',
  'user.title.phone': 'Teléfono móvil',
  'user.title.phone1': 'Ingrese el número de móvil correcto',
  'user.title.phone2': 'Ingrese su número de móvil',
  'user.title.role': 'rol',
  'user.title.role1': 'Seleccione un rol',
  'user.title.status': 'estado',
  'user.title.status1': 'Seleccione estado',
  'user.title.goBack': 'Volver',
  'user.title.submit1': 'Sumisión',
  'user.title.name3': 'Nombre',
  'user.title.isOnline': '¿Está en línea?',
  'user.title.online': 'En línea',
  'user.title.offline': 'Desconectado',
  'user.title.forceOffline': 'Desconectado',
  'sys.button.cleanCache': 'Limpiar caché nativa',
  'user.button.addAccount': 'Agregar cuenta',
  'user.button.addButton': 'agregar botón',
  'user.button.addConfig': 'Agregar configuración',
  'sys.button.addLeafMenu': 'Agregar submenú',
  'sys.button.addParam': 'Agregar parámetro',
  'sys.button.addTopMenu': 'Agregar menú superior',
  'sys.button.addNotifyType': 'Agregar tipo de notificación',
  'sys.button.addExternalChain': 'Agregar pago externo',
  'user.disableNotice': '¿Está seguro de que desea deshabilitar esta cuenta de fondo?',
  'user.enableNotice': '¿Está seguro de que desea habilitar la cuenta de fondo?',
  'user.title.confirmNotice': 'Aviso de confirmación',
  'user.offlineUserAccountNotice': '¿Está seguro de que desea desconectar forzadamente la cuenta de fondo?',
  'sys.title.fillButtonInfo': 'Rellenar información del botón',
  'sys.title.fillRejectReason': 'Rellenar motivo del rechazo',
  'sys.title.fillMenuInfo': 'Rellenar información del menú',
  'sys.title.fillInfo': 'Rellenar información',
  'sys.title.fillPayChannelInfo': 'Rellenar parámetros del canal de pago',
  'sys.title.fillNoticeTypeInfo': 'Rellenar información del tipo de notificación',
  'sys.title.fillOnlinePayInfo': 'Rellenar información de pago en línea',
  'sys.title.fillOffLinePayChannelInfo': 'Rellenar información del canal de pago fuera de línea',
  'sys.title.groupName': 'Nombre del grupo',
  'sys.title.groupName1': 'Ingrese nombre del grupo',
  'sys.title.groupName2': 'Ingrese nombre del grupo de menos de 20 caracteres',
  'sys.title.buttonName': 'Nombre del botón',
  'sys.title.buttonName1': 'Ingrese el nombre del botón',
  'sys.title.buttonName2': 'Ingrese nombre del botón de menos de 20 caracteres',
  'sys.title.buttonNumber': 'Número de botón',
  'sys.title.buttonNumber1': 'Ingrese el número de botón',
  'sys.title.buttonNumber2': 'Ingrese número de botón de menos de 100 caracteres',
  'sys.title.buttonDes': 'Descripción del botón',
  'sys.title.buttonDes1': 'Ingrese la descripción del botón',
  'sys.title.buttonDes2': 'Ingrese descripción del botón de menos de 1000 caracteres',
  'sys.title.groupNameAndNumber': 'Nombre del grupo / número',
  'sys.title.buttonAndLink': 'Nombre del botón / enlace',
  'sys.title.configNameValueGroup': 'Nombre de configuración / valor / grupo',
  'sys.title.belongUserGroup': 'Grupo de usuarios',
  'sys.title.userGroup': 'Grupo de usuarios',
  'sys.title.adminGroup': 'Grupo de administración',
  'sys.title.userGroup1': 'Seleccione un grupo de usuarios',
  'sys.title.configGroup': 'Grupo de configuración',
  'sys.title.configGroup1': 'Ingrese grupo de configuración',
  'sys.title.group': 'grupo',
  'sys.title.group1': 'Ingrese grupo',
  'sys.title.limitLength20': 'Ingrese menos de 20 caracteres',
  'sys.title.limitLength50': 'Ingrese menos de 50 caracteres',
  'sys.title.limitLength100': 'Ingrese menos de 100 caracteres',
  'sys.title.limitLength1000': 'Ingrese menos de 1000 caracteres',
  'sys.title.keyNotice': 'Ingrese clave',
  'sys.title.value': 'valor',
  'sys.title.valueNotice': 'Ingrese valor.',
  'sys.title.sort': 'orden',
  'sys.title.sortNotice': 'Ingrese el orden',
  'sys.title.fillMenuInfoNotice': 'El número de menú debe ser el último / último enlace',
  'sys.title.hierarchical': 'Jerarquía de menú',
  'sys.title.hierarchical1': 'Nivel de menú {menuLevel}',
  'sys.title.topMenu': 'Menú superior',
  'sys.title.leafMenu': 'Menú de hoja',
  'sys.title.leafMenu1': 'Menú de hoja',
  'sys.title.menuName': 'Nombre del menú',
  'sys.title.menuName1': 'Ingrese nombre del menú',
  'sys.title.menuName2': 'Ingrese nombre del menú de menos de 20 caracteres',
  'sys.title.menuLevel': 'Nivel de menú',
  'sys.title.menuLevel1': 'Seleccione el nivel de menú',
  'sys.title.menuLevel_1': 'Menú de primera clase',
  'sys.title.menuLevel_2': 'Menú de dos niveles',
  'sys.title.menuLevel_3': 'Menú de tres niveles',
  'sys.title.menuType': 'Tipo de menú',
  'sys.title.menuType1': '¿Es un menú hoja?',
  'sys.title.menuOrder': 'Orden del menú',
  'sys.title.menuOrder1': 'Ingrese el orden del menú',
  'sys.title.menuLink': 'Enlace de menú',
  'sys.title.menuLink1': 'Ingrese el número de menú para empalmar enlaces',
  'sys.title.menuLink2': 'Ingrese un número de menú con menos de 100 caracteres',
  'sys.title.menuLink3': '"/" inicio + enlace superior + "/" + número de menú',
  'sys.title.menuCode': 'Número de menú',
  'sys.title.menuCode1': 'Ingrese el número de menú, letra, número y punto decimal',
  'sys.title.menuCode2': 'Ingrese un número de menú con menos de 100 caracteres',
  'sys.title.menuCode3': 'Composición del enlace: número de menú padre / número de menú',
  'sys.title.menuIcon': 'Icono de menú',
  'sys.title.menuIcon1': 'Ingrese un icono de menú con menos de 20 caracteres',
  'sys.title.menuIcon2': 'Ingrese el icono de menú. El menú de primer nivel no necesita',
  'sys.title.reviewIcon': 'Vista previa del icono',
  'sys.title.menuGroup': 'Grupo de menú',
  'sys.title.menuNameAndLink': 'Nombre del menú / enlace',
  'msg.title.notifyName': 'Nombre de notificación',
  'msg.title.notifyName1': 'Ingrese un nombre de tipo de notificación',
  'msg.title.notifyName2': 'Ingrese un nombre de tipo de notificación con menos de 20 caracteres',
  'msg.title.notifyCode': 'Número de notificación',
  'msg.title.notifyCode1': 'Ingrese el número de tipo de notificación para empalmar enlaces',
  'msg.title.notifyCode2': 'Ingrese un número de tipo de notificación con menos de 100 caracteres',
  'msg.title.notifyCode3': 'Composición del enlace: número de tipo de notificación superior / número de tipo de notificación',
  'msg.title.notifyDesc': 'Descripción de notificación',
  'msg.title.notifyDesc1': 'Ingrese una descripción del tipo de notificación con menos de 20 caracteres',
  'msg.title.notifyDesc2': 'Ingrese una descripción del tipo de notificación',
  'msg.title.notifyNameAndLink': 'Nombre del tipo de notificación / enlace',
  'msg.title.notifyNameR': 'Nombre de notificación',
  'msg.title.notifyCodeR': 'Número de notificación',
  'sys.title.updateDesc': 'Notas de lanzamiento:',
  'sys.title.updateDesc1': 'Se recomienda no exceder 5 líneas, con 15 caracteres (incluyendo caracteres) por línea',
  'agent.title.confirmOffer': 'Confirmación de pago',
  'agent.title.confirmOffer1': '¿Por favor confirme si desea emitir comisión?',
  'agent.title.confirmReject': 'Confirmar rechazo',
  'agent.title.confirmReject1': '¿Por favor confirme si desea rechazar la emisión?',
  'agent.title.confirmCumulative': 'Confirmar contabilidad acumulada',
  'agent.title.confirmCumulative1': '¿Por favor confirme si la liquidación de comisión se acumula al próximo mes?',
  'agent.title.settlementDate': 'Día de liquidación',
  'agent.title.monthlyProfitLoss': 'fase',
  'agent.title.bonusAmount': 'Monto del bono',
  'agent.title.depositWithdrawalFee': 'Cargo de servicio por depósito y retiro',
  'agent.title.depositWithdrawAndFee': 'Depósitos, retiros y comisiones',
  'agent.title.deposit': 'Depósitos',
  'agent.title.withdraw': 'retiros',
  'agent.title.transFee': 'comisiones',
  'agent.title.netProfit': 'Ganancia neta',
  'agent.title.earningCommission': 'Comisión de ingresos',
  'agent.title.commissionStatus1': 'Por revisar I (control de riesgo)',
  'agent.title.commissionStatus2': 'Por revisar II (Finanzas)',
  'agent.title.commissionStatus3': 'Comisión distribuida',
  'agent.title.commissionStatus4': 'Rechazar otorgamiento',
  'agent.title.commissionStatus5': 'Mes acumulativo',
  'agent.title.offerCommission': 'Comisión',
  'agent.title.reject': 'rechazar',
  'agent.title.marketCost': 'Costo de mercado',
  'agent.title.refundFee': 'Comisión de reembolso',
  'agent.title.taxDeduction': 'deducción fiscal',
  'agent.title.lowerLevel': 'Extracción de nivel inferior',
  'agent.title.alreadyOffer': 'Han sido emitidas',
  'sys.upload.success': 'Archivo cargado exitosamente',
  'sys.upload.fail': 'La carga de archivo falló. Por favor elimine y cargue el archivo nuevamente.',
  'sys.upload.deleteSuccess': 'Eliminado exitosamente.',
  'sys.upload.picture': 'Cargar imágenes.',
  'sys.lengthLimit': 'Ingrese hasta 300 caracteres',
  'sys.input': 'Por favor ingrese',
  'pay.offline': 'Pago sin conexión',
  'pay.online': 'Canal en línea',
  'pay.title.payTypeInfo': 'Información de tipo de pago',
  'sys.title.parentCode': 'Agrupación de atribución',
  'sys.title.parentCode1': 'Seleccione el grupo al que pertenece',
  'sys.title.forwardUrl': 'Enlace de salto',
  'sys.title.forwardUrl1': 'Ingrese un enlace de salto',
  'sys.title.forwardUrl2': 'Ingrese un enlace de salto válido',
  'sys.title.background': 'Color de fondo',
  'sys.title.background1': 'Ingrese el color de fondo',
  'sys.title.background2': 'Ingrese el color de fondo del pedido',
  'sys.title.background3': 'Recomendación: azul #0ae / verde #22ac38 / azul oscuro #4a79d6 / amarillo #d55a26 / rojo #dd524d / amarillo claro #e9e5af / gris claro #f3f3f3f3',
  'sys.title.imgPC': 'Icono (PC)',
  'sys.title.imgMobile': 'Icono (H5)',
  'sys.title.img1': 'Por favor cargue el icono',
  'sys.title.img2': 'Recomendado: ancho ilimitado, alto 40px, formato png',
  'pay.title.insideName': 'nombre interno',
  'pay.title.payViewName': 'Nombre del cliente',
  'pay.title.groupLevel': 'Nivel de grupo',
  'pay.title.sort': 'ordenar',
  'pay.title.recommendDesc': 'Tipo: recomendación',
  'pay.title.externalChain': 'Pago de cadena externa',
  'pay.title.builtGrouping': 'Agrupación incorporada',
  'pay.title.builtGrouping1': 'Grupo incorporado: {payDesc}',
  'pay.title.img': 'Icono',
  'pay.title.attributes': 'atributo',
  'pay.title.attributes1': 'mostrar',
  'pay.title.attributes2': 'latente',
  'pay.title.attributes3': 'Recomendación',
  'pay.title.edit': 'editar',
  'pay.title.confirmOrder': 'Confirmación de pedido',
  'pay.title.confirmOrder1': '¿Por favor verifique si ha llegado?',
  'sys.title.loadingCallBtnFail': 'No se pudo cargar el botón de llamada',
  'sys.title.callSuccess': 'Marcación exitosa',
  'sys.title.callError': 'Errores de marcación',
  'sys.title.callError1': 'Tiempo de espera de llamada agotado, por favor espere',
  'sys.title.orderNo': 'Número de pedido',
  'sys.title.thirdPlatform': 'El tercero',
  'sys.title.userAccount': 'Miembro',
  'sys.title.payName': 'plataforma de pago',
  'sys.title.payerName': 'Información de depósito',
  'sys.title.withdrawalInfo': 'Información de retiro',
  'sys.title.bankName': 'Información de cobro',
  'sys.title.orderAmount': 'Cantidad de dinero',
  'sys.title.orderAmount1': 'Recarga exitosa',
  'sys.title.orderAmount0': 'No pagado',
  'sys.title.orderAmount2': 'Expirado',
  'sys.title.create': 'Tiempo de creación / procesamiento',
  'sys.title.update': 'Tiempo de procesamiento / personal',
  'sys.title.dealTime': 'tiempo de procesamiento',
  'sys.title.dealAdmin': 'Personal de procesamiento',
  'sys.title.applyTime': 'Tiempo de aplicación',
  'finance.export.depositOfflineExcel': 'Informe de recarga de pedido (pago sin conexión).xls',
  'finance.export.depositOnlineExcel': 'Informe de recarga de pedido (pago en línea).xls',
  'pay.input.orderUserAccountPlatform': 'Número de pedido, nombre de usuario, plataforma de pago',
  'sys.title.checkPaymentPercent': 'Ver tasa de éxito',
  'sys.title.orderStatus': 'Estado del pedido',
  'sys.title.dataType': 'tipo de datos',
  'sys.title.dataType0': 'Registro de recarga',
  'sys.title.dataType1': 'Resumen de miembros',
  'sys.title.dataType2': 'Resumen de canal',
  'pay.title.deviceSource': 'Fuente de pedido',
  'pay.title.deviceSource1': 'Terminal PC',
  'pay.title.deviceSource2': 'Terminal móvil',
  'pay.title.deviceSource3': 'Terminal Android',
  'pay.title.deviceSource4': 'Terminal IOS',
  'finance.export.orderDepositExcel': 'Informe de recarga de pedido.xls',
  'finance.export.orderWithdrawalExcel': 'Informe de orden de retiro.xls',
  'pay.title.confirmReason': 'Razones para la confirmación',
  'pay.title.confirmReason1': 'Ingrese la razón para la confirmación',
  'pay.title.confirmUnlock': 'Confirmar desbloqueo',
  'pay.title.confirmUnlock1': 'Confirmar para desbloquear el retiro',
  'pay.title.confirmWithdrawal': 'Confirmación de retiros',
  'pay.title.confirmWithdrawal1': '¿Está de acuerdo en retirarse con {name}?',
  'pay.title.wrongSplitAmount': 'Error de cantidad dividida',
  'pay.title.wrongSplitAmount2': 'La cantidad dividida no puede ser mayor que la cantidad total',
  'pay.title.splitOrder': '¿Está seguro de dividirlo en {length} pedidos?',
  'pay.title.success': 'Éxito',
  'pay.title.success1': '¿Está seguro de retirarse a la cuenta?',
  'pay.title.fail': 'fallar',
  'pay.title.fail1': '¿Está seguro de que el retiro falló?',
  'pay.title.withdrawalOrder': 'Número de orden de retiro',
  'pay.title.windControlAudit': 'Auditoría de control de riesgo',
  'pay.title.paymentReview': 'Auditoría de pago',
  'pay.title.requestWithdrawalTime': 'Tiempo de solicitud de retiro',
  'pay.title.paymentMethod': 'Forma de pago',
  'pay.title.splitOrder1': 'Pedido dividido',
  'pay.title.splitMasterOrder': 'Dividir pedido principal',
  'pay.title.splitMolecularOrder': 'Pedido dividido',
  'pay.title.molecularTransNo': 'Número de subpedido: {transNo}',
  'pay.title.masterTransNo': 'Número de pedido maestro: {transNo}',
  'pay.title.refuseWithdrawCash': 'Rechazar depósito en efectivo',
  'pay.title.confirmPayment': 'Confirmación de pago',
  'pay.title.payForMoney': 'Envío de pago',
  'pay.title.unlock': 'Desbloquear',
  'pay.title.denialReason': 'Razones para la negativa',
  'pay.title.withdrawalStatus2': 'Retiros exitosos',
  'pay.title.withdrawalStatus1': 'Esperando pago',
  'pay.title.withdrawalStatus3': 'Rechazado',
  'pay.title.withdrawalStatus0': 'Control de riesgo a revisar',
  'pay.title.withdrawalStatus4': 'Pago en nombre de',
  'pay.title.withdrawalStatus5': 'Incumplimiento de pago',
  'pay.title.withdrawalStatus6': 'Bloqueo de pago',
  'pay.title.withdrawalStatus8': 'División exitosa',
  'pay.title.withdrawalStatus_1': 'Por auditar',
  'pay.title.withdrawalStatus_2': 'Retiros exitosos',
  'pay.title.withdrawalStatus_3': 'Rechazado',
  'pay.title.withdrawalStatus_0': 'Auditoría de control de riesgo en curso',
  'pay.title.withdrawalStatus_4': 'Pago en nombre de',
  'pay.title.withdrawalStatus_5': 'Incumplimiento de pago',
  'pay.title.choseWithDrawalChannel': 'Por favor seleccione el canal de pago',
  'pay.title.rate': 'tasa',
  'pay.title.eachOrderAmount': 'Cada suma',
  'pay.title.splitAmountConfig': 'Configuración de cantidad dividida',
  'pay.title.splitAmount': 'Ingrese la cantidad dividida',
  'pay.title.rejectReason': 'Ingrese la razón del rechazo',
  'pay.title.withdrawalSuccessTime': 'Tiempo de éxito del retiro',
  'pay.title.withdrawalChannel': 'Canal de pago',
  'pay.title.SuccessTimeOrFailTime': 'Tiempo de éxito o fracaso',
  'pay.title.withdrawalOrderUserAccount': 'Número de orden de retiro, nombre de usuario',
  'login.title.qrcode': 'Por favor verifique el código QR',
  'login.install.verify0': 'Versión de Chrome',
  'login.install.verify1': 'Versión de Android',
  'login.install.verify2': 'Versión de IOS',
  'login.title.idcard': 'Ingrese el código de autenticación',
  'login.title.verifyIdcard': 'Por favor verifique el código de autenticación',
  'login.title.verificationCode': 'Código de verificación',
  'login.title.finishVerify': 'Validación completa',
  'lottery.title.userAccount': 'Cuenta de membresía',
  'lottery.title.complainantType': 'Tipos de quejas',
  'lottery.title.targetId': 'Número de objeto de queja',
  'lottery.title.targetId1': 'Publicación',
  'lottery.title.targetId2': 'comentario',
  'lottery.title.complainantAndComplainantTime': 'Demandante / tiempo de queja',
  'lottery.title.complainantDate': 'Fecha de queja',
  'lottery.title.keyword': 'Palabra clave',
  'lottery.title.targetCode': 'Número de destino',
  'lottery.title.read': 'Leer',
  'lottery.title.open': 'abierto',
  'lottery.title.close': 'Cerrar',
  'lottery.title.dayLimit': 'Techo diario',
  'lottery.title.article': 'pieza',
  'lottery.title.ordinaryStickers': 'Publicación general',
  'lottery.title.cash': 'efectivo',
  'lottery.title.flow': 'Flujo de agua',
  'lottery.title.point': 'integral',
  'lottery.title.expertStickers': 'Pegatinas de experto',
  'lottery.title.greatGodSticker': 'Pegatina de gurú',
  'lottery.title.attention': 'seguir',
  'lottery.title.perPerson': 'Enviar para todos',
  'lottery.title.person': 'gente',
  'lottery.title.comment': 'comentario',
  'lottery.title.eachDelivery': 'Enviar para cada uno',
  'lottery.title.article1': 'tira',
  'lottery.title.like': 'pulgar hacia arriba',
  'lottery.title.everyTimeSend': 'Enviar cada vez',
  'lottery.title.one': 'individual',
  'lottery.title.buyLotterySwitch': 'Interruptor de lotería',
  'lottery.title.handicapTime': 'Tiempo de ventaja',
  'lottery.title.switchOpen': 'abierto',
  'lottery.title.closingTime': 'Hora de cierre',
  'lottery.title.inputNumber': 'por favor ingrese un número',
  'lottery.title.postReply': 'Publicación / Respuesta',
  'lottery.title.post': 'Publicación',
  'lottery.title.reply': 'Respuesta',
  'lottery.title.sticker': 'Publicación',
  'lottery.title.applyForGod': 'Solicitar ser un gurú',
  'lottery.title.recentWinningStreak': 'Racha ganadora reciente',
  'lottery.title.inputPeriods': 'Ingrese el número de etapa',
  'lottery.title.periods': 'etapa',
  'lottery.title.periods1': 'Número de etapa',
  'lottery.title.inputPeriods1': 'Seleccione el número de etapa',
  'lottery.title.periods2': 'Emisión {item}',
  'lottery.title.weekWinRate': 'Tasa de ganancia semanal',
  'lottery.title.monthWinRate': 'Tasa de ganancia mensual',
  'lottery.title.addMemberLevel': 'Agregar nivel de miembro',
  'lottery.title.levelName': 'Nombre de nivel',
  'lottery.title.level': 'nivel',
  'lottery.title.addTime': 'Hora de adición',
  'lottery.title.addAdmin': 'Agregar gente',
  'lottery.title.addBannedMember': 'Agregar miembro prohibido',
  'lottery.title.inputMemberAccount': 'Ingrese la cuenta de miembro',
  'lottery.title.inputMemberAccount1': 'Ingrese el número de cuenta de miembro. Varias cuentas están separadas por comas',
  'lottery.title.banCount': 'Duración',
  'lottery.title.inputBanCount': 'Ingrese la duración',
  'lottery.title.reason': 'Razón',
  'lottery.title.inputReason': 'Ingrese la razón',
  'lottery.title.confirmNotice': 'Solicitud de confirmación',
  'lottery.title.confirmNotice1': '¿Está seguro de que desea rechazar el bono de pedido?',
  'lottery.title.confirmNotice2': '¿Está seguro de que desea eliminar el miembro prohibido seleccionado?',
  'lottery.title.confirmNotice3': '¿Está seguro de que desea eliminar la fecha de apertura del premio de {month} mes {day} en {year}?',
  'lottery.title.confirmNotice4': '¿Está seguro de que desea usar el número de fuente como número de premio?',
  'lottery.title.confirmNotice5': '¿Está seguro de que todos los pedidos de {period} en {year} han sido distribuidos?',
  'lottery.title.confirmNotice6': '¿Está seguro de que desea distribuir el bono de pedido seleccionado?',
  'lottery.title.confirmNotice7': '¿Está seguro de que desea eliminar la respuesta seleccionada?',
  'lottery.title.confirmNotice8': '¿Está seguro de que desea modificar el tipo de orden?',
  'lottery.title.confirmNotice9': '¿Está seguro de que desea eliminar la publicación seleccionada?',
  'lottery.title.confirmNotice10': '¿Está seguro de que desea restablecer la contraseña del agente? ¿Necesita una contraseña nueva para iniciar sesión como agente después de restablecer?',
  'lottery.title.confirmNotice11': '¿Está seguro de eliminar la proporción de comisión?',
  'lottery.title.confirmNotice13': '¿Este envío afecta el porcentaje de cálculo de comisión predeterminada global. Por favor verifique la información cuidadosamente?',
  'lottery.title.confirmNotice14': '¿Este envío afecta el porcentaje de cálculo integral global. Por favor verifique la información cuidadosamente?',
  'lottery.title.confirmNotice15': '¿Este envío afecta el porcentaje de cálculo de comisión predeterminada del agente subordinado global. Por favor verifique la información cuidadosamente?',
  'lottery.title.banTime': 'Tiempo prohibido',
  'lottery.title.time': 'tiempo',
  'lottery.title.timeStart': 'hora de inicio',
  'lottery.title.timeEnd': 'Hora de finalización',
  'lottery.title.batchAdd': 'Adición por lotes',
  'lottery.title.batchRemove': 'Extracción por lotes',
  'lottery.title.openDate': 'Tiempo de sorteo',
  'lottery.title.openPeriods': 'Etapa de lotería de sorteo',
  'lottery.title.openNumber': 'Número de lotería de sorteo',
  'lottery.title.openLottery1': 'Premio incompleto',
  'lottery.title.openLottery2': 'Premio terminado',
  'lottery.title.confirmLotteryOpen': 'Finalización del premio',
  'lottery.title.lotteryResult': 'Resultado del premio de lotería',
  'lottery.title.batchGrant': 'Premio por lotes',
  'lottery.title.orderDate': 'Fecha de pedido',
  'lottery.title.officialTime': 'Oficial',
  'lottery.title.platfromTime': 'Plataforma',
  'lottery.title.year': 'año',
  'lottery.title.inputYear': 'Ingrese el año',
  'lottery.title.month': 'Mes',
  'lottery.title.inputMonth': 'Ingrese el mes',
  'lottery.title.date': 'fecha',
  'lottery.title.inputDate': 'Ingrese la fecha',
  'lottery.title.enteringPersonAndTime': 'Ingresado por / Hora de entrada',
  'lottery.title.openPersonAndOpenTime': 'Sorteo por / Hora de sorteo',
  'lottery.title.addOpenDate': 'Agregar fecha de sorteo',
  'lottery.title.enteringOpenNumber': 'Ingrese el número de lotería de sorteo',
  'lottery.title.enteringDate': 'Ingresar fecha',
  'lottery.title.enteringNumber': 'Número de entrada',
  'lottery.title.firstBall': 'Primera bola',
  'lottery.title.firstBall1': 'Ingrese el número de primera bola',
  'lottery.title.secondBall': 'Segunda bola',
  'lottery.title.secondBall1': 'Ingrese el número de segunda bola',
  'lottery.title.thirdBall': 'Tercera bola',
  'lottery.title.thirdBall1': 'Ingrese el número de tercera bola',
  'lottery.title.fourthBall': 'Cuarta bola',
  'lottery.title.fourthBall1': 'Ingrese el número de cuarta bola',
  'lottery.title.fifthBall': 'Quinta bola',
  'lottery.title.fifthBall1': 'Ingrese el número de quinta bola',
  'lottery.title.sixthBall': 'Sexta bola',
  'lottery.title.sixthBall1': 'Ingrese el número de sexta bola',
  'lottery.title.seventhBall': 'Séptima bola',
  'lottery.title.seventhBall1': 'Ingrese el número de séptima bola',
  'lottery.title.status1': 'Pendiente de adopción',
  'lottery.title.status2': 'Adoptado',
  'lottery.title.status3': 'Abandonado',
  'lottery.title.firstLevelName': 'Nombre de lotería de clase I',
  'lottery.title.secondLevelName': 'Nombre de lotería de clase II',
  'lottery.title.hongkong': 'Lotería de Hong Kong',
  'lottery.title.markSix': 'Lotería de Liuhe',
  'lottery.title.playName': 'Nombre de juego',
  'lottery.title.playName1': 'Por favor elija cómo jugar',
  'lottery.title.bonusNumber': 'Números ganadores',
  'lottery.title.bonusAmount': 'Cantidad ganadora',
  'lottery.title.grantAdminAndGrantTime': 'Premio por / Hora del premio',
  'lottery.title.grantDate': 'Hora del premio',
  'lottery.title.orderNumber': 'Número de pedido',
  'lottery.title.number': 'Número',
  'lottery.title.orderTimeAndOpenTime': 'Hora del pedido / Hora de sorteo',
  'lottery.title.orderStatus1': 'Esperando pago',
  'lottery.title.orderStatus2': 'Esperando el premio',
  'lottery.title.orderStatus3': 'Extracción',
  'lottery.title.orderStatus4': 'Facturación',
  'lottery.title.orderStatus5': 'Ganancia',
  'lottery.title.orderStatus6': 'Sin ganancia',
  'lottery.title.orderStatus7': 'Pedido inválido',
  'lottery.title.orderStatus8': 'Cancelar pedido',
  'lottery.title.betAmount': 'Monto de apuesta',
  'lottery.title.eachBetAmount': 'Cada monto de apuesta',
  'lottery.title.totalAmount': 'Monto de suma total',
  'lottery.title.galleryName': 'Nombre de galería',
  'lottery.title.isHeat': '¿Es popular?',
  'lottery.title.isHeat1': 'Popular',
  'lottery.title.isHeat0': 'No popular',
  'lottery.title.thumbnail': 'Miniatura',
  'lottery.title.periodsMgt': 'Gestión de etapa específica',
  'lottery.title.isDisplaySort': 'Si se debe mostrar el orden por vistas',
  'lottery.title.ptrr': 'Me gusta / No me gusta / Lecturas / Comentarios',
  'lottery.title.praiseCount': 'Recuento de elogios',
  'lottery.title.treadCount': 'Recuento de no me gusta',
  'lottery.title.readCount': 'Recuento de lecturas',
  'lottery.title.reviewCount': 'Recuento de comentarios',
  'lottery.title.lookBigPic': 'Ver la imagen grande',
  'lottery.title.likeCount': 'Puntos de elogio',
  'lottery.title.content': 'Contenido del comentario',
  'lottery.title.content1': 'Por favor ingrese comentarios',
  'lottery.title.UserAccountAndContent': 'Nombre de usuario, contenido del comentario',
  'lottery.title.sendPushMsg': 'Enviar mensaje push',
  'lottery.title.pushPlatform': 'Plataforma push',
  'lottery.title.pushDate': 'Fecha de push',
  'lottery.title.pushPlatform1': 'Por favor seleccione una plataforma push',
  'lottery.title.android': 'Android',
  'lottery.title.ios': 'IOS',
  'lottery.title.title': 'Título',
  'lottery.title.title1': 'Por favor complete el título de push',
  'lottery.title.title2': 'Por favor ingrese el título de la publicación',
  'lottery.title.contents': 'Contenido de push',
  'lottery.title.contents1': 'Por favor complete el contenido del push',
  'lottery.title.pushAdminAndContents': 'Quien empuja / tiempo',
  'lottery.title.addSuccess': '¡Agregado exitosamente!',
  'lottery.title.addException': 'Anomalía de aumento',
  'lottery.title.addLikeCountAndReadCount': 'Aumentar me gusta o lecturas',
  'lottery.title.choseType': 'Tipo de selección',
  'lottery.title.choseType1': 'Por favor seleccione Agregar tipo',
  'lottery.title.countNumber': 'Número',
  'lottery.title.countNumber1': 'Por favor ingrese la cantidad',
  'lottery.title.commentSuccess': '¡Comentario exitoso!',
  'lottery.title.commentError': 'Error de comentario',
  'lottery.title.postAndReply': 'Respuesta de publicación',
  'lottery.title.numberCode': 'número',
  'lottery.title.replyAdmin': 'Responder a gente',
  'lottery.title.secondReply': 'Recuperación de dos niveles',
  'lottery.title.upperNumberCode': 'Número superior',
  'lottery.title.firstReply': 'Respuesta de primer orden',
  'lottery.title.replyTime': 'Tiempo de recuperación',
  'lottery.title.replyLevel': 'Jerarquía de respuesta',
  'lottery.title.conten': 'contenido',
  'lottery.title.addLikeAndRead': 'Aumentar me gusta o lecturas',
  'lottery.title.addLikeAndRead1': 'Aumentar el número de me gusta, lecturas y documentos',
  'lottery.title.follow': 'documental',
  'lottery.title.postNew': 'Liberar nuevas publicaciones',
  'lottery.title.category': 'clasificación',
  'lottery.title.category1': 'Por favor seleccione una clasificación',
  'lottery.title.postDate': 'Fecha de publicación',
  'lottery.title.adPic': 'Imagen publicitaria',
  'lottery.title.adPic1': 'Por favor cargue la imagen publicitaria',
  'lottery.title.public': '¿Es público?',
  'lottery.title.public1': 'Por favor elija si publicar',
  'lottery.title.public2': 'abierto',
  'lottery.title.public3': 'La respuesta se puede ver',
  'lottery.title.pushSingleSticker': 'Empujar o no',
  'lottery.title.pushSingleSticker1': 'Por favor seleccione el tipo de publicación',
  'lottery.title.pushSingleSticker2': 'Hoja sin push',
  'lottery.title.pushSingleSticker3': 'Hoja de push',
  'lottery.title.secondaryPlay': 'Juego de dos niveles',
  'lottery.title.secondaryPlay1': 'Por favor elija el método de juego de segundo nivel',
  'lottery.title.thirdPlay': 'Juego de tres niveles',
  'lottery.title.thirdPlay1': 'Por favor elija tres niveles de juego',
  'lottery.title.amountPerBet': 'Cantidad por nota',
  'lottery.title.amountPerBet1': 'Por favor ingrese la cantidad de cada nota',
  'lottery.title.ranking': 'Clasificación',
  'lottery.title.ranking1': 'Colocación de techo',
  'lottery.title.ranking2': 'Recomendar',
  'lottery.title.giftChoice': 'Elección de regalo',
  'lottery.title.giftChoice1': 'gastar dinero para nada',
  'lottery.title.giftChoice2': 'Enviar puntos',
  'lottery.title.readSendCash': 'Efectivo por lectura',
  'lottery.title.readSendCash1': 'Por favor ingrese la cantidad',
  'lottery.title.readSendPoint': 'Puntos por lectura',
  'lottery.title.readSendPoint1': 'Por favor ingrese puntos',
  'lottery.title.postAccount': 'Número de cuenta de publicación',
  'lottery.title.postAccount1': 'Por favor ingrese la cuenta de publicación',
  'lottery.title.setStickerType': 'Establecer tipo de publicación',
  'lottery.title.stickerType': 'Tipo de publicación',
  'lottery.title.stickerType1': 'Por favor ingrese el nombre del tipo de publicación',
  'lottery.title.typeName': 'Nombre del tipo',
  'lottery.title.showOrder1': 'Por favor ingrese el orden de presentación',
  'lottery.title.showOrder': 'Orden de visualización',
  'lottery.title.addType': 'Agregar tipo',
  'lottery.title.moveBeforeDelete': 'Por favor transfiera sus publicaciones a otra categoría antes de eliminarlas.',
  'lottery.title.postAdmin': 'Cartelista',
  'lottery.title.categoryAndTitle': 'Categoría / Título',
  'lottery.title.readContentLike': 'Leer / comentar / me gusta',
  'lottery.title.postAndEditTime': 'Publicar / tiempo de edición',
  'lottery.title.unpin': 'Cancelar el techo',
  'lottery.title.cancelRecom': 'Cancelar recomendación',
  'lottery.title.viewReply': 'Ver respuesta',
  'lottery.title.addQuantity': 'Cantidad agregada',
  'lottery.title.addSticker': 'Nuevas publicaciones',
  'lottery.title.deleteSticker': 'Eliminar publicaciones',
  'lottery.title.updateCategory': 'Cambiar clasificación',
  'lottery.title.setCategory': 'Clasificación de configuración',
  'lottery.title.targetType': 'Tipo de destino',
  'lottery.title.likeContent': 'Contenido del objeto que me gusta',
  'lottery.title.likeTime': 'Tiempo de elogio',
  'lottery.title.beLikeAccount': 'Número de cuenta de la persona interesada',
  'lottery.title.attentionTime': 'Tiempo de atención',
  'lottery.title.taskTime': 'Tiempo de misión',
  'lottery.title.type': 'tipo',
  'lottery.title.readingTask1': 'Tarea de lectura - Publicación general',
  'lottery.title.readingTask2': 'Tarea de lectura - publicación experta',
  'lottery.title.readingTask3': 'Tarea de lectura - Cartelista',
  'lottery.title.readTask': 'Tarea de lectura',
  'lottery.title.focusTask': 'Enfocarse en tareas',
  'lottery.title.contentTask': 'Tarea de comentario',
  'lottery.title.likeTask': 'Misión de elogio',
  'lottery.title.taskTarget': 'Objetivos de misión',
  'lottery.title.completed': 'Completado',
  'lottery.title.isReceive': 'Si recibir',
  'lottery.title.received': 'Han recibido',
  'lottery.title.unaccalimed': 'Sin cobrar',
  'lottery.title.upgradeTime': 'Tiempo de actualización',
  'agent.title.verificationFail': 'Validación falló',
  'agent.title.verificationFail1': 'El nombre de usuario ya existe. Por favor vuelva a ingresar',
  'agent.title.confirmPassWrong': '¡Las dos contraseñas no coinciden!',
  'agent.title.fillAgentInfo': 'Complete información del agente',
  'agent.title.agentType': 'Tipo de proxy',
  'agent.title.ordinaryAgent': 'Agente ordinario',
  'agent.title.agentLevel': 'Nivel de agencia',
  'agent.title.manualAmount': 'Monto de ajuste',
  'agent.title.agentLevel1': 'Agente de primer nivel',
  'agent.title.agentLevel2': 'Agencia de dos niveles',
  'agent.title.agentLevel3': 'Agencia de tres niveles',
  'agent.title.adChannel': 'Canal publicitario',
  'agent.title.addAdChannel': 'Agregar canal publicitario',
  'agent.title.adCode': 'Código de canal publicitario',
  'agent.title.adCode1': 'Por favor seleccione el código de anuncio',
  'agent.title.adName': 'Nombre de anuncio',
  'agent.title.adName1': 'Por favor ingrese el nombre de anuncio correcto',
  'agent.title.adAddress': 'Dirección publicitaria',
  'agent.title.adAddress1': 'Por favor ingrese la dirección publicitaria correcta',
  'agent.title.adDesc': 'Descripción publicitaria',
  'agent.title.adDesc1': 'Por favor ingrese la descripción publicitaria correcta',
  'agent.title.adPutDate': 'Fecha de lanzamiento',
  'agent.title.adPutDate1': 'Por favor seleccione la fecha de lanzamiento',
  'agent.title.payName': 'Nombre de pago',
  'agent.title.payName1': 'Por favor ingrese el nombre de pago correcto',
  'agent.title.bankNo': 'Número de tarjeta bancaria',
  'agent.title.bankNo1': 'Por favor ingrese el número de tarjeta bancaria correcto',
  'agent.title.adMgt': 'Gestión publicitaria',
  'agent.title.onlyOne': 'Solo se puede seleccionar un canal de agencia publicitaria',
  'agent.title.outOfIndex': 'El canal de agencia publicitaria no está en el rango de selección, por favor seleccione nuevamente.',
  'agent.title.baseInfo': 'Información esencial',
  'agent.title.payInfo': 'Información de pago',
  'agent.title.complete': 'completar',
  'agent.title.nextStep': 'Siguiente paso',
  'agent.title.backStep': 'Paso anterior',
  'agent.title.oneMore': 'Agregar uno más.',
  'agent.title.resetPassSuccess': 'Restablecimiento de contraseña exitoso',
  'agent.title.newPassIs': 'Restablecimiento de contraseña exitoso. La nueva contraseña es:',
  'agent.title.unfreezeAgent': '¿Desea descongelar este agente?',
  'agent.title.activationAgent': '¿Desea activar este agente?',
  'agent.title.freezeAgent': '¿Desea congelar este agente?',
  'agent.title.rejectActivationAgent': '¿Desea rechazar la activación de este agente?',
  'agent.title.confirmOperate': 'Confirmación de operación',
  'agent.title.trackCode': 'Código de seguimiento',
  'agent.title.registerTimeAndLastLoginTime': 'Tiempo de registro / último inicio de sesión',
  'agent.title.status0': 'no activo',
  'agent.title.status1': 'Activado',
  'agent.title.status2': 'Congelado',
  'agent.title.status3': 'Rechazado',
  'agent.title.activation': 'activación',
  'agent.title.freeze': 'Congelado',
  'agent.title.thaw': 'Descongelar',
  'agent.title.resetPass': 'Restablecer contraseña de inicio de sesión',
  'agent.title.userCodeNameMail': 'Nombre de usuario, código, nombre, correo electrónico',
  'agent.title.registerTime': 'Tiempo de registro',
  'agent.title.upperCode': 'CÓDIGO superior',
  'agent.title.upperAgentCode': 'Por favor ingrese el código de agente superior',
  'agent.title.platform': 'plataforma',
  'agent.title.platformDetail': 'Detalles de la plataforma',
  'agent.title.desc': 'Ganancia/pérdida de plataforma: {resultAmount}, proporción de comisión: {commissionPercent}, comisión ganada: {Commission}',
  'agent.title.monthSettlementCommission': 'Comisión de liquidación periódica',
  'agent.export.agentMonthExcel': 'Informe de comisión de liquidación mensual del agente.xls',
  'agent.title.agentName': 'Nombre del agente',
  'agent.title.depositAmount': 'depósito',
  'agent.title.withdrawAmount': 'retiro',
  'agent.title.totalChangeMoney': 'Cargo de servicio',
  'agent.title.commissionReport1': 'Comisión del agente = comisión de plataforma sin conexión - descuento sin conexión - tarifa de servicio de depósito y retiro sin conexión',
  'agent.title.commissionReport2': 'Comisión de plataforma sin conexión = (ganancias de plataforma a * {platformCost} * proporción de comisión de plataforma a) + (ganancias de plataforma B * {platformCost} * proporción de comisión de plataforma B) + (ganancias de plataforma C * {platformCost} * proporción de comisión de plataforma C) +....',
  'agent.title.commissionReport3': 'Descuento sin conexión = la suma de todos los descuentos emitidos por los miembros subordinados del agente',
  'agent.title.commissionReport4': 'Cargo de servicio por depósito y retiro sin conexión = (depósito sin conexión + retiro sin conexión) * {minAmount}',
  'agent.title.commissionReport5': 'Comisión del agente = (ganancia/pérdida de plataforma * {platformCost} - bono del sistema - monto de depósito/retiro del usuario * {minAmount}) * Proporción de comisión.',
  'agent.title.commissionReport6': 'Ganancia/pérdida de plataforma = ganancia/pérdida total de cada plataforma de juego.',
  'agent.title.commissionReport7': 'Bono del sistema = la suma de todos los dividendos pagados en nombre de los miembros subordinados.',
  'agent.title.commissionReport8': 'Monto de depósito y retiro del usuario = el monto total de depósito y retiro en nombre de los miembros subordinados.',
  'agent.title.commissionReport9': 'Proporción de comisión = proporción de comisión de agencia.',
  'agent.title.commissionForm': 'Informe de comisión',
  'agent.title.dataForm': 'Informe de datos',
  'agent.title.childFlow': 'Canalización sin conexión',
  'agent.title.childBonus': 'Descuento sin conexión',
  'agent.title.childDeposit': 'Depósito sin conexión',
  'agent.title.childWithdrawal': 'Retiro sin conexión',
  'agent.title.childResult': 'Ganancia o pérdida de última línea',
  'agent.title.childCommission': 'Comisión de plataforma sin conexión',
  'agent.title.viewDetail': 'Ver detalles',
  'agent.title.childDWFee': 'Cargo de servicio por depósito y retiro sin conexión',
  'agent.title.commission': 'Comisión',
  'agent.title.childPlatformResult': 'Ganancias de plataforma sin conexión',
  'agent.title.minimumMonthlyTotalNetProfit': 'Ganancia neta total mínima mensual',
  'agent.title.minimumMonthlyTotalNetProfit1': 'Por favor ingrese la ganancia neta total mínima mensual',
  'agent.title.maximumMonthlyTotalNetProfit': 'Ganancia neta total máxima mensual',
  'agent.title.maximumMonthlyTotalNetProfit1': 'Por favor ingrese la ganancia neta total máxima mensual',
  'agent.title.addAgentCommissionRatio': 'Agregar proporción de comisión del agente',
  'agent.title.activeMember': 'Miembro activo',
  'agent.title.activeMember1': 'Por favor ingrese miembro activo',
  'agent.title.commissionRatio': 'tasa de comisión',
  'agent.title.commissionRatio1': 'Por favor ingrese la proporción de comisión',
  'agent.title.cancel': 'cancelar',
  'agent.title.save': 'Preservación',
  'agent.title.defaultAgentDivision': 'Agente predeterminado dividido por porcentaje de plataforma',
  'agent.title.platformFeeRatio': 'Proporción de tarifa de plataforma',
  'agent.title.platformWinLose': 'Coeficiente de ganancia/pérdida de plataforma',
  'agent.title.depositWithdrawalFeeMui': 'Coeficiente de cargo de servicio de depósito y retiro',
  'agent.title.comprehensiveCost': 'Por favor ingrese la tarifa integral (porcentaje 0 - 100)',
  'agent.title.eachMonthSettlementDay': 'Fecha de liquidación mensual',
  'agent.title.agentTaxPercentage': 'Tasa de impuesto de plataforma',
  'agent.title.agentSharePercent': 'Proporción',
  'agent.title.childAgent': 'Configuración de comisión de suagente',
  'agent.title.agentCommission': 'Comisión de agencia',
  'agent.title.domainCheck': 'Los nombres de dominio al comienzo de HTTP, HTTPS y WWW no se pueden ingresar. Por favor omita.',
  'agent.title.fillDomainInfo': 'Completar información de nombre de dominio',
  'agent.title.agentDomain': 'Nombre de dominio proxy',
  'agent.title.agentDomain1': 'Por favor ingrese el nombre de dominio',
  'agent.title.isDefault': '¿Es el predeterminado?',
  'agent.title.isDefault1': 'Por favor elija si establecer como predeterminado',
  'agent.title.isDefault2': 'predeterminado',
  'agent.title.isDefault3': 'No predeterminado',
  'agent.title.domain': 'nombre de dominio',
  'agent.title.domain1': 'Nombre de dominio predeterminado',
  'agent.title.domain2': 'Nombre de dominio no predeterminado',
  'agent.title.addDomain': 'Agregar nombre de dominio',
  'agent.title.userNameDomainCode': 'Nombre de usuario, nombre de dominio, código',
  'agent.title.currentStatus': 'estado actual',
  'common.title.detailInfo': 'información detallada',
  'agent.title.addRemark': 'Agregar observaciones',
  'agent.title.addRemarkSuccess': '¡Agregar comentario exitoso!',
  'agent.title.addRemarkFail': 'No se pudo agregar comentario',
  'agent.title.addRemarkError': 'Error al agregar comentario',
  'agent.title.bankName': 'Nombre del banco',
  'agent.title.bankAccount': 'Nombre de cuenta',
  'agent.title.bankAccount1': 'Por favor ingrese el nombre de cuenta',
  'agent.title.bankAddr': 'Dirección de sucursal',
  'agent.title.bankAddr1': 'Por favor ingrese la dirección de sucursal',
  'agent.title.bankNumber': 'Cuenta bancaria',
  'agent.title.normal': 'normal',
  'agent.title.activationCard': '¿Desea activar esta tarjeta bancaria?',
  'agent.title.deleteCard': '¿Desea eliminar esta tarjeta bancaria?',
  'agent.title.offlineCard': '¿Desea deshabilitar esta tarjeta bancaria?',
  'agent.title.bankInfo': 'Información bancaria',
  'agent.title.addBank': 'Agregar tarjeta bancaria',
  'agent.title.qrCode': 'Imagen de código QR',
  'agent.title.pubQrCode': 'Código QR de publicidad',
  'agent.title.phoneNumber': 'Número de teléfono',
  'user.title.registerTime1': 'Tiempo de registro',
  'user.title.firstDepositTime': 'Tiempo de primer depósito',
  'user.title.lastLoginTime1': 'Hora del último inicio de sesión',
  'user.title.lastDepositTime': 'Hora del último depósito',
  'user.title.lastWithdrawalTime': 'Hora del último retiro',
  'user.title.taotalDepositAmount': 'Monto total de recarga',
  'user.title.totalWithdrawalAmount': 'Monto total de retiro',
  'user.title.totalBonus1': 'Descuento total',
  'user.title.totalBetFlow': 'Flujo total',
  'user.title.goFail': 'Fallo del salto',
  'user.title.disableLogin': 'Esta cuenta no está activada o congelada. No puede saltar para iniciar sesión.',
  'agent.export.agentChildUserExcel': 'Usuario del agente.xls',
  'user.title.agentCommissionConfig': 'Configuración de comisión del agente',
  'user.title.goingTo': 'Saltando...',
  'user.title.bonusBinding': 'Vinculación preferencial',
  'user.title.lastWithdrawalTime1': 'Hora del último retiro',
  'user.title.loginAsAgent': 'Iniciar sesión como agente',
  'user.title.birthday': 'Cumpleaños',
  'user.title.upperAgent': 'Agente superior',
  'user.title.accountFunds': 'Fondos de cuenta',
  'user.title.freezingFunds': 'Fondos congelados',
  'user.title.availableFunds': 'Fondos disponibles',
  'user.title.profileStatistics': 'Estadísticas generales',
  'user.title.historyPay': 'Pago histórico',
  'user.title.exportChildUser': 'Informe de usuario de exportación bajo nombre.xls',
  'user.title.fillBankCardInfo': 'Completar información de tarjeta bancaria',
  'user.title.adjustAccountBalanceSuccess': 'El saldo de la cuenta se ajusta exitosamente. El saldo ajustado:',
  'user.title.adjustAccountBalanceFail': 'No se pudo ajustar el saldo de la cuenta',
  'user.title.adjustAccountBalanceError': 'Error al ajustar el saldo de la cuenta',
  'user.title.manualTransfer1': 'Por favor seleccione tipo de reconciliación',
  'user.title.increaseAmount': 'Aumentar cantidad',
  'user.title.decreaseAmount': 'Reducir la cantidad',
  'user.title.agencySpecificCommissionRatio': 'Porcentaje de comisión exclusiva',
  'user.title.addAgencySpecificCommissionRatio': 'Añadir proporción de comisión exclusiva de agente',
  'user.title.previousBalance': 'Saldo anterior',
  'user.title.afterBalance': 'Saldo después',
  'user.title.approved': 'Aprobado',
  'user.title.notApproved': 'No examinado y aprobado',
  'user.title.pendingApproved': 'Pendiente de aprobación',
  'user.title.rejected': 'Rechazado',
  'user.title.historyBill': 'Factura histórica',
  'user.title.deleteThisFee': '¿Eliminar este cargo?',
  'user.title.costTime': 'Tiempo de generación de gastos',
  'user.title.costType': 'Tipo de gasto',
  'user.title.costCreateTime': 'Tiempo de creación de gasto',
  'user.title.settled': 'Liquidado',
  'user.title.unsettlement': 'Sin liquidar',
  'user.title.changeFee': 'Tarifa de enmienda',
  'user.title.addFee': 'Costo adicional',
  'user.title.notCalculated': 'No calculado',
  'user.title.Calculated': 'Calculado',
  'user.title.fillCostInfo': 'Completar información de gasto',
  'user.title.uploadPromotionPicture': 'Subir imágenes de promoción',
  'user.title.oldPromotionPicture': 'Imágenes de promoción antiguas',
  'user.title.uploadFile': 'Por favor, cargue el archivo',
  'user.title.imageName': 'Nombre de la imagen',
  'user.title.imageName1': 'Ingrese el nombre de una imagen',
  'user.title.imageName2': 'Ingrese el nombre de la imagen de promoción',
  'user.title.addPromotionPicture': 'Añadir imagen de promoción',
  'user.title.confirmActivation': 'Confirmar activación',
  'user.title.activationPicture': '¿Activar esta imagen?',
  'user.title.banPicture': '¿Desea deshabilitar esta imagen?',
  'user.title.deletePicture': '¿Eliminar esta imagen?',
  'user.title.newChildCount': 'Número de nuevos registros',
  'user.title.activationChildCount': 'Número de líneas descendentes activas',
  'user.title.lowerBetCount': 'El número total de apostadores en el nivel inferior',
  'user.title.depositChildCount': 'Número de líneas de depósito',
  'user.title.firstDepositChildCount': 'Número de primer depósito y fin de línea',
  'user.title.whitdrawalChildCount': 'Número de líneas de retiro',
  'user.title.totalDepositChildAmount': 'Depósito total sin conexión',
  'user.title.totalWithdrawalChildAmount': 'Retiro total sin conexión',
  'user.title.totalBonusChild': 'Beneficios totales sin conexión',
  'user.title.totalBetFlowChild': 'Flujo total de línea descendente',
  'user.title.totalResultChild': 'Siempre ganar o perder sin conexión',
  'user.title.confirmWithdrawal': '¿Confirma el retiro?',
  'user.title.confirmConfirm': '¿No se puede cambiar después de la confirmación?',
  'user.title.rejectWithdrawal': '¿Desea rechazar este retiro?',
  'user.title.rejectConfirm': '¿No se puede cambiar después del rechazo?',
  'user.title.withdrawalNumber': 'Número de presentación',
  'user.title.agree': '¡Aceptar!',
  'user.title.userAccountAndNumber': 'Nombre de usuario / número',
  'user.title.fillRemarkInfo': 'Completar notas',
  'user.title.confirmBinding': 'Confirmar vinculación',
  'user.title.confirmBinding1': '¿Está seguro de vincular esta oferta?',
  'user.title.alreadyBiding': 'Oferta ya vinculada',
  'user.title.changeBindingBonus': 'El agente ya ha vinculado {bonusName} Esta oferta de inscripción. ¿Está seguro de que desea reemplazarla?',
  'user.title.alreadyBindingBonus': '{agentAccount} este agente ya ha vinculado la oferta {bonusName}.',
  'user.title.registerBonusBiding': 'Vinculación de oferta de registro relacionada',
  'user.title.registerGiftAmount': 'Monto de regalo registrado',
  'user.title.flowTimes': 'Múltiple de flujo',
  'user.title.binding': 'vinculación',
  'user.title.noBackFlowAgent': '¿Hay un descuento sin retorno para miembros bajo este agente? (descuento de agua y descuento de retorno en tiempo real)',
  'user.title.haveBackFlowAgent': '¿Desea configurar un descuento de retorno para miembros bajo este agente? (descuento de agua y descuento de retorno en tiempo real)',
  'user.title.resetPayPass': 'Restablecer contraseña de pago',
  'user.title.haveBackFlow': 'Retorno de agua',
  'user.title.noBackFlow': 'Sin retorno de agua',
  'user.title.addCommonAgent': 'Añadir agente general',
  'user.title.noSelect': 'Sin opción',
  'user.title.assignUser': 'Seleccione los usuarios a asignar',
  'user.title.choseSalesperson': 'Seleccione el personal de telemarketing a asignar',
  'user.title.wrongChose': 'Opción incorrecta',
  'user.title.assignUserError': 'El usuario seleccionado para distribución debe ser mayor que o igual al personal de telemarketing seleccionado',
  'user.title.userType': 'tipo de cliente',
  'user.title.importUser': 'Importando usuarios',
  'user.title.silentUser': 'Usuario silencioso',
  'user.title.registerUndepositUser': 'Registrar usuarios sin depósito',
  'user.title.memberListImport': 'Importar lista de miembros',
  'user.title.importInfo': 'Información de importación',
  'user.title.importRemark': 'Observaciones de importación',
  'user.title.importSrouce': 'Fuente de importación',
  'user.title.stepTwo': 'Paso 2 seleccionar y asignar el personal de telemarketing',
  'user.title.allSalesperson': 'Todo el personal de telemarketing',
  'user.title.assign': 'distribución',
  'user.title.assignList': 'Lista de asignación',
  'user.title.assignListDetail': 'Detalles de la lista de distribución',
  'user.title.assignTime': 'Tiempo de asignación',
  'user.title.isRecycle': '¿Se recicla?',
  'user.title.confirmRecycle': '¿Está seguro de que desea reciclar?',
  'user.title.assignedTo': 'Asignar a',
  'user.title.assignedUser': 'Persona de distribución',
  'user.title.recycled': 'Recuperado',
  'user.title.recycle': 'recuperación',
  'user.title.recycleAll': 'Reciclaje total',
  'user.title.confirmRecycle1': 'Nota: después de que se recicle el número, el rendimiento generado por el número no se calculará.',
  'user.title.assignTime1': 'Tiempo de asignación',
  'user.title.userAttribute': 'atributo de usuario',
  'user.title.assignPersonCount': 'Número de distribución',
  'user.title.alreadyAssignList': 'Lista asignada',
  'user.title.importListMode': 'El formato de la lista de importación es el siguiente',
  'user.title.importListMode1': 'Columna 1: número de teléfono',
  'user.title.importListMode2': 'Columna 2: detalles de importación',
  'user.title.importListMode3': 'Tercera columna: notas de importación',
  'user.title.teleSaleAssignList': 'Telemarketing - lista de distribución',
  'user.title.importDesc': 'Instrucciones de importación',
  'user.title.assignMgt': 'Gestión de distribución',
  'user.title.waitAssignList': 'Lista de espera',
  'user.title.lastLogin': 'Último inicio de sesión',
  'user.title.activationTime': 'Tiempo de activación',
  'user.title.activationFirstDeposit': 'Primer guardado después de la activación',
  'user.title.activationTotalDeposit': 'Depósito total después de la activación',
  'user.title.salesperson': 'Especialista en telemarketing',
  'user.title.Salesperson1': 'Seleccione el personal de telemarketing',
  'user.title.Salesperson2': 'Sin personal de telemarketing seleccionado',
  'user.title.times': 'segundo',
  'user.title.firstDepositCount': 'Primer depósito {regNotDepositCount} persona',
  'user.title.recoverCount': 'Recuperar {silentUserCount} personas',
  'user.title.registerCount': 'Registrar {importRegCount} personas',
  'user.title.saleStatus': 'Estado de ventas (puede hacer clic en cualquier estado para entrar en la lista de usuarios)',
  'user.title.undialedUser': 'Suscriptor no marcado',
  'user.title.followUpUsers': 'Usuarios a seguir',
  'user.title.dialed': 'Ya marcado',
  'user.title.dialedThisMonth': 'Marcado este mes',
  'user.title.connectionRate': 'Tasa de conexión',
  'user.title.teleQuality': 'Calidad de llamada',
  'user.title.performanceOverview': 'Resumen de rendimiento',
  'user.title.averageCallDuration': 'Duración promedio de llamada',
  'user.title.commissioner': 'Comisionista',
  'user.title.numberDials': 'Número de llamadas',
  'user.title.chooseSalesperson': 'Seleccionar personal de telemarketing',
  'user.title.uncalledUserList': 'Lista de usuarios no marcada',
  'user.title.dialedUserList': 'Lista de usuarios marcados',
  'user.title.followUpListUsers': 'Lista de usuarios a seguir',
  'user.title.activationDeposit': 'Depósito después de la activación',
  'user.title.notDialed': 'No marcado',
  'user.title.keepFollow': 'Continuar siguiendo',
  'user.title.cancelFollow': 'Cancelar seguimiento',
  'user.title.affiliatedSales': 'Pines eléctricos',
  'user.title.invitationCodeUser': 'Usuario de código de invitación',
  'user.title.myPerformance': 'Mis logros',
  'user.title.performanceDetails': 'Detalles del rendimiento',
  'user.title.performanceList': 'Detalles del rendimiento',
  'user.title.dailyPerformanceStatistics': 'Estadísticas diarias de rendimiento',
  'user.title.registrationNoDeposit': 'Recién registrado pero sin depósito',
  'user.title.dialCount': 'Marcar y medir',
  'user.title.activationsCount': 'Número de activación',
  'user.title.currentPerformanceOverview': 'Resumen de rendimiento actual',
  'user.title.calledThisMonth': 'Marcado este mes',
  'user.title.seatNumber': 'Número de asiento',
  'user.title.currentAgentAssignor': 'Asignador de asiento actual',
  'user.title.seatMgt': 'Telemarketing - gestión de asientos',
  'user.title.assignSeatSalesperson': 'Distribución de asientos de telemarketing',
  'user.title.seatSalesperson': 'Personal de asiento',
  'user.title.seatSalesperson1': 'Ingrese el personal de telemarketing asignado',
  'user.title.times1': 'frecuencia',
  'user.title.percent': 'Porcentaje (%)',
  'user.title.seatSalesperson2': 'Seleccione la persona a asignar',
  'user.title.offlineOutThreeDay': 'Usuarios no conectados por más de tres días',
  'user.title.userInfo': 'Información del usuario',
  'user.title.registerAndLogin': 'Registrarse / Iniciar sesión',
  'user.title.telemarketing': 'Telemarketing',
  'user.title.remarkInfo': 'Información de observaciones',
  'user.title.editAt': 'Editor en',
  'user.title.confirm': 'Determinar',
  'user.title.waitIntoDialList': 'Si entrar en la lista de usuarios a marcar',
  'user.title.confirmWaitIntoDialList': 'Confirme si desea entrar en la lista de usuarios a marcar',
  'user.title.waitIntoDialedList': 'Si entrar en la lista de usuarios marcados',
  'user.title.confirmWaitIntoDialedList': 'Confirme si desea entrar en la lista de usuarios marcados',
  'user.title.waitIntoFollowList': 'Si entrar en la lista de usuarios a seguir',
  'user.title.confirmWaitIntoFollowList': 'Confirme si desea entrar en la lista de usuarios a seguir',
  'user.title.platformSerialNumber': ', número de serie de la plataforma:',
  'user.title.gameSerialNumber': 'Número de serie del juego',
  'user.title.rawData': 'Datos sin procesar (hora de la plataforma de juego)',
  'user.title.verified': 'Certificado',
  'user.title.unfilled': 'No completado',
  'user.title.notCertified': 'Sin certificar',
  'user.title.userInfoExcel': 'Informe de información del miembro.xls',
  'user.title.riskControlLevel': 'Nivel de control del viento',
  'user.title.dateEnrollment': 'Fecha de admisión',
  'user.title.firstDepositDate': 'Fecha del primer depósito',
  'user.title.bankCardList': 'Lista de tarjetas bancarias',
  'user.title.unBinding': 'Desvincular',
  'user.title.confirmUnBinding': '¿Está seguro de desvincular?',
  'user.title.confirmEnableBankCard': '¿Está seguro de habilitar esta tarjeta bancaria?',
  'user.title.isDisable': '¿Está prohibido?',
  'user.title.confirmDisableBankCard': '¿Desea deshabilitar esta tarjeta bancaria?',
  'user.title.bankRelated': 'Relacionado con banco',
  'user.title.bankCode': 'Código bancario',
  'user.title.accountRelated': 'Relacionado con cuenta',
  'user.title.unbindingAll': 'Desvincular todo',
  'user.title.confirmUnbindingAllCard': 'Nota: después de esta operación, todas las tarjetas bancarias del usuario serán desvinculadas.',
  'user.title.changeUpperAgent': 'Modificar agente padre',
  'user.title.oldAgent': 'Agente original',
  'user.title.newAgent': 'Nuevo agente',
  'user.title.newAgentAccount': 'Cuenta del nuevo agente',
  'user.title.deviceRelateUser': 'Iniciar sesión en el usuario asociado del dispositivo',
  'user.title.devicId': 'ID del dispositivo',
  'user.title.devicIdAppType': 'Fuente de equipo',
  'user.title.relateUser': 'Usuarios asociados',
  'user.title.relateUserNum': 'Número de cuentas de usuario vinculadas',
  'user.title.emailAuthentication': 'Autenticación de correo',
  'user.title.newMail': 'Nuevo correo',
  'user.title.oldMail': 'Correo antiguo',
  'user.title.lockFundsList': 'Lista de fondos bloqueados',
  'user.title.bonusLock': 'Bloqueo preferencial',
  'user.title.depositLock': 'Bloqueo de depósito',
  'user.title.confirmOffer': '¿Confirma si emitir?',
  'user.title.confirmRejectApply': '¿Está seguro de que desea rechazar esta oferta?',
  'user.title.confirmCancel': 'Confirmar cancelación',
  'user.title.confirmCancelBonus': '¿Está seguro de que desea cancelar esta oferta?',
  'user.title.baseBonus': 'Principal preferencial',
  'user.title.lockAmount': 'Cantidad de bloqueo',
  'user.title.getBonusTime': 'Tiempo de recopilación preferencial',
  'user.title.flowCompletionProgress': 'Progreso de finalización del flujo',
  'user.title.completedFlow': 'Flujo completado',
  'user.title.targetFlow': 'Flujo objetivo',
  'user.title.confirmUnlockDeposit': '¿Está seguro de desbloquear este depósito?',
  'user.title.inviteUserRecordList': 'Lista de registro de miembro de invitación',
  'user.title.getBonus': 'Trato preferencial',
  'user.title.loginIpRelateUser': 'Iniciar sesión en usuario asociado por IP',
  'user.title.verifiedName': 'Autenticación de nombre real',
  'user.title.realName': 'Nombre real',
  'user.title.newRealName': 'Nuevo nombre real',
  'user.title.newIdNo': 'Nuevo número de identificación',
  'user.title.oldRealName': 'Nombre real anterior',
  'user.title.oldIdNo': 'Número de identificación anterior',
  'user.title.realName1': 'Ingrese el nombre real correcto',
  'user.title.idNo1': 'Ingrese el número de identificación correcto',
  'user.title.verifyPhone': 'Autenticación de teléfono móvil',
  'user.title.phoneNumber': 'Número de teléfono móvil',
  'user.title.newPhoneNumber': 'Nuevo número de teléfono móvil',
  'user.title.oldPhoneNumber': 'Número de teléfono móvil anterior',
  'user.title.phoneNumber1': 'Ingrese el número de teléfono móvil correcto',

  'user.title.aliPayAccount': 'Cuenta de Alipay',
  'user.title.alipayPhone': 'Número de teléfono móvil de Alipay',
  'user.title.alipayEmail': 'Número de correo de Alipay',
  'user.title.alipayRealName': 'Nombre real de Alipay',
  'user.title.delAlipay': 'Eliminar su cuenta de Alipay',
  'user.title.askDelAlipay': 'Confirme para eliminar su cuenta de Alipay',
  'user.title.confirmUnbindingAllAliPay': 'Nota: Después de esta operación, todas las cuentas de Alipay del usuario serán desvinculadas.',
  'user.title.confirmUnbindingAllUSDT': 'Nota: Después de esta operación, todas las cuentas de USDT del usuario serán desvinculadas.',
  'user.title.confirmUnbindingAllVirtual': 'Nota: Después de esta operación, todas las cuentas de criptomoneda virtual del usuario serán desvinculadas.',
  'user.title.delUSDT': 'Ejemplo Eliminar una dirección de USDT',
  'user.title.askDelUSDT': '¿Confirme para eliminar la dirección de USDT?',

  'user.title.getAccountBalanceFail': 'Error al obtener el monto de la cuenta.',
  'user.title.getAccountBalanceError': 'Error al obtener el monto de la cuenta.',
  'user.title.getBackSuccess': 'Volver al éxito',
  'user.title.batchGetBack': 'En la recuperación por lotes, verifique el saldo de la cuenta más tarde.',
  'user.title.getBackFail': 'Fallo en la recuperación',
  'user.title.getBackError': 'Error de recuperación',
  'user.title.refreshSuccess': 'Actualización exitosa',
  'user.title.refreshFail': 'actualización fallida',
  'user.title.refreshError': 'error de actualización',
  'user.title.accountInfo': 'Información de la cuenta (unidad: yuan)',
  'user.title.accountInfoVN': 'Información de la cuenta (unidad: VND)',

  'user.title.getBackAll': 'Recuperar todo',
  'user.title.refreshAll': 'Actualización completa',
  'user.title.totalBalance': 'Saldo total',
  'user.title.mainAccount': 'Cuenta principal',
  'user.title.detail': 'detalles',
  'user.title.refresh': 'Actualizar',
  'user.title.money': 'elemento',
  'user.title.moneyVND': 'VND',
  'user.title.point': 'puntos',
  'user.title.requestTimeAndOfferTime': 'Tiempo de solicitud | tiempo de lanzamiento',
  'user.title.bonusContent': 'Contenido preferencial',
  'user.title.bonusType': 'Tipo preferencial',
  'user.title.offerAdmin': 'Distribuidor',
  'user.title.resetWithdrawalPass': 'Restablecer contraseña de retiro',
  'user.title.inviteRecord': 'Registro de invitación',
  'user.title.relatedDevice': 'Dispositivo asociado',
  'user.title.relateIP': 'IP de correlación',
  'user.title.bankCard': 'Tarjeta bancaria',
  'user.title.noeLogin': 'No iniciado sesión',
  'user.title.relate': 'Asociado',
  'user.title.noBindingBankCard': 'Tarjeta bancaria no vinculada',
  'user.title.relateBankCard': 'Tarjeta bancaria relacionada',
  'user.title.female': 'Femenino',
  'user.title.male': 'Masculino',
  'user.title.unverifiedID': 'Identidad no autenticada',
  'user.title.verifiedMail': 'Correo autenticado',
  'user.title.unverifiedMail': 'Correo no autenticado',
  'user.title.verifiedPhone': 'Teléfono certificado',
  'user.title.mobilePhoneAttribution': 'Hogar móvil',
  'user.title.confirmResetUserPass': '¿Está seguro de que desea restablecer la contraseña del usuario? ¿Necesita una nueva contraseña para iniciar sesión después del restablecimiento?',
  'user.title.confirmResetUserWithdrawal': '¿Está seguro de que desea restablecer la contraseña de retiro del usuario?',
  'user.title.confirmChangeSourceToRegister': '¿Desea eliminar el agente de fuente de miembro y registrarse en su lugar?',
  'user.title.noneSet': 'No configurado',
  'user.title.cancelAgent': 'Revocar agencia',
  'user.title.playerInviteCode': 'Código de invitación del jugador',
  'user.title.invited': ', invitado:',
  'user.title.noneInvitedRecord': 'Sin registro de invitación aún',
  'user.title.noneLoginRecord': 'Sin iniciar sesión aún',
  'user.title.changeRegisterSource': 'Modificar fuente de registro',
  'user.title.signPoint': 'Puntuación de registro',
  'user.title.userLevel1': 'Nivel de membresía',
  'user.title.expireDate': 'Tiempo de vencimiento',
  'user.title.permanent': 'Validez permanente',
  'user.title.totalManualTransfer': 'Reconciliación manual general',
  'user.title.wechat': 'WeChat',
  'user.title.loginTimes': 'Iniciar sesión 9999 {loginCount} veces',
  'user.title.pointChange': 'Cambio de puntos',
  'user.title.remarkCount': 'Hay {length} comentarios',
  'user.title.getRiskInfoFail': 'Error al obtener información de control de riesgo.',
  'user.title.getRiskInfoError': 'Error al obtener información de control de riesgo.',
  'user.title.transactionTime': 'Hora de transacción',
  'user.title.addBonusError': 'Error al añadir oferta',
  'user.title.addBonus': 'Añadir descuento',
  'user.title.bonusName1': 'Ingrese el nombre de la oferta',
  'user.title.bonusName2': 'Ingrese cuánto flujo objetivo se necesita para retirar',
  'user.title.withdrawTargetFlow': 'Flujo objetivo retirable',
  'user.title.orderNo': 'Ingrese el número de pedido',
  'user.title.processingFail': 'Error en el procesamiento, intente más tarde',
  'user.title.adjustedLevelSuccess': '¡El ajuste de nivel tuvo éxito!',
  'user.title.adjustedLevelFail': 'Error al ajustar el nivel',
  'user.title.adjustedLevelError': 'Error de ajuste de nivel',
  'user.title.liuheLevel': 'Rango Liuhe',
  'user.title.adjustLiuheLevel': 'Ajustar los seis niveles de membresía',
  'user.title.liuheLevel1': 'Seleccione el nivel de Seis Armonías',
  'user.title.adjustUserLevel': 'Ajustar nivel de membresía',
  'user.title.adjustAccountPointSuccess': 'El ajuste de puntos de cuenta fue exitoso. Puntos después del ajuste:',
  'user.title.adjustAccountPointFail': 'Error al ajustar puntos de cuenta',
  'user.title.adjustAccountPointError': 'Error al ajustar puntos de cuenta',
  'user.title.pointAdjust': 'Ajuste de puntos',
  'user.title.changePoint': 'Puntos de suma y resta',
  'user.title.changePoint1': 'Ingrese los puntos a sumar o restar',
  'user.title.changedPoint': 'Puntos de suma y resta',
  'user.title.showColor': 'Color de visualización',
  'user.title.showColor1': 'Seleccione color de visualización',
  'user.title.defaultBlack': 'Negro (predeterminado)',
  'user.title.red': 'Rojo',
  'user.title.blue': 'azul',
  'user.title.green': 'verde',
  'user.title.riskLevel1': 'Seleccione el nivel de riesgo',
  'user.title.noneBindingMail': 'El correo del usuario no está vinculado',
  'user.title.sendMailSuccess': 'Correo enviado con éxito',
  'user.title.sendMailFail': 'Error al enviar correo',
  'user.title.sendMailError': 'Error al enviar correo',
  'user.title.loadTemplateFail': 'Error al cargar la plantilla',
  'user.title.loadTemplateError': 'Error al cargar la plantilla',
  'user.title.sendMail': 'Enviar correos',
  'user.title.sendMail1': 'Enviar correo',
  'user.title.optionalTemplate': 'Plantilla opcional',
  'user.title.mailTitle': 'Título del correo',
  'user.title.mailTitle1': 'Ingrese el título del mensaje',
  'user.title.mailContent': 'Contenido del correo',
  'user.title.mailContent1': 'Ingrese el contenido del mensaje',
  'user.title.sendSiteTextSuccess': 'Se logró enviar mensaje en la estación',
  'user.title.sendSiteTextFail': 'Error al enviar mensaje en la estación',
  'user.title.sendSiteTextError': 'Error al enviar mensaje en la estación',
  'user.title.sendSiteText': 'Enviar mensaje en la estación',
  'user.title.siteText': 'correo',
  'user.title.missOrder': 'Puede ir a gestión de miembros - gestión de orden de recarga para confirmación manual después del pago.',
  'user.title.countIn': 'Acreditado a depósito y retiro',
  'user.title.orderName1': 'Ingrese el nombre de la orden, de lo contrario se utilizará el valor predeterminado',
  'user.title.orderName': 'Número de pedido',
  'user.title.orderName2': 'Ingrese el número de pedido',
  'user.title.unbindingSeatNumber': 'El número de asiento no está vinculado. Vincule el número de asiento antes de la operación',
  'user.title.recentMainAccountTran': 'Transacciones recientes de cuenta principal',
  'user.title.last7DayBet': 'Últimos siete días',
  'user.title.bonusBonus': 'Trato preferencial',
  'user.title.userPoint': 'Puntuación de membresía',
  'user.title.operateLog': 'Registro de operación',
  'user.title.allUser': 'Todos los usuarios',
  'user.title.depositRate': 'Tasa de depósito',
  'user.title.depositRate1': 'Tasa de depósito: usuario que deposita / usuario total',
  'user.title.depositUserComposition': 'Composición de usuarios que depositan',
  'user.title.depositAmount': 'Monto de depósito (día actual)',
  'user.title.totalDepositCount': 'Depósitos totales',
  'user.title.totalDepositAmount': 'Monto de depósito total',
  'user.title.senderRecipientTitle': 'De / a / Título',
  'user.title.recipient': 'Destinatario',
  'user.title.sender': 'Remitente',
  'user.title.registerAndFirstAndLastLoginTime': 'Registro, primer inicio de sesión e información del último inicio de sesión',
  'user.title.unDeposit': 'Sin depósito',
  'user.title.totalDepositTotalWithdrawal': 'Depósito total',
  'user.title.realNamePhoneMail': 'Nombre real | teléfono móvil | correo',
  'user.title.userListExcel': 'Informe de lista de miembros.xls',
  'user.title.friendsInvite': 'Invitación de amigo',
  'user.title.minDepositCount': 'Mínimo de depósitos',
  'user.title.maxDepositCount': 'Máximo de depósitos',
  'user.title.depositCount': 'Número de depósitos',
  'user.title.minDepositAmount': 'Monto mínimo de depósito',
  'user.title.maxDepositAmount': 'Monto máximo de depósito',
  'user.title.depositAmount1': 'Monto de depósito',
  'user.title.resultExport': 'Exportación de resultados',
  'user.title.firstDepositRate': 'Tasa de supervivencia en primer lugar',
  'user.title.rate': 'ratio',
  'user.title.7DaysLost': '7 días perdidos: usuarios que no han iniciado sesión por 7 días consecutivos',
  'user.title.14DaysLost': '14 días perdidos: usuarios que no han iniciado sesión por 14 días consecutivos',
  'user.title.30DaysLost': '30 días perdidos: usuarios que no han iniciado sesión por 30 días consecutivos',
  'user.title.7DaysLostAndBack': 'Usuarios de reflujo: usuarios perdidos en 7 días e iniciados sesión dentro del período de tiempo',
  'user.title.lostAndUserCount': 'Tasa de pérdida: Usuarios perdidos / usuarios totales',
  'user.title.lostBackAndTotalLost': 'Tasa de reflujo: usuarios de reflujo / usuarios perdidos totales',
  'user.title.7DaysLost1': 'Pérdida de 7 días',
  'user.title.14DaysLost1': 'Pérdida de 14 días',
  'user.title.30DaysLost1': 'Pérdida de 30 días',
  'user.title.lostAndLostBack': 'Usuarios perdidos y devueltos',
  'user.title.lostAndLostBack1': 'Tasa de pérdida y tasa de retorno',
  'user.title.lostUser': 'Usuario perdido',
  'user.title.lostBackUser': 'usuario recurrente',
  'user.title.lostRate': 'Tasa de desperdicio',
  'user.title.lostBackRate': 'Tasa de reflujo',
  'user.title.newUserCount': 'Número de nuevos usuarios',
  'user.title.silentUserCount': 'Número de usuarios silenciosos',
  'user.title.silentUser90Days': 'Usuarios silenciosos: usuarios que no han iniciado sesión por {days} días consecutivos',
  'user.title.silentUserRate': 'Proporción de usuarios silenciosos: usuarios silenciosos / usuarios totales',
  'user.title.silentUserRate1': 'Proporción de usuarios silenciosos',
  'user.title.absoluteValue': 'valor absoluto',
  'user.title.retentionRate': 'Retención',
  'user.title.dayAfter': 'Días después',
  'user.title.weekAfter': 'Zhou Hou',
  'user.title.monthAfter': 'Después del mes',
  'user.title.retentionUser': 'Usuario retenido: el nuevo usuario que deposita se llama usuario retenido',
  'sys.added.prize1': 'Premio añadido',
  'sys.stock': 'Stock',
  'sys.download': 'descargar',
  'sys.stockNum': 'Número de stock',
  'sys.stockNum1': 'Ingrese inventario',
  'sys.hasStock': 'Tipo de inventario',
  'sys.hasStock0': 'Ilimitado',
  'sys.hasStock1': 'Cantidad limitada',
  'sys.hasStock3': 'Seleccione el tipo de premio',
  'lottery.lotteryTime': 'Hora del sorteo',
  'sys.set': 'Configurar',
  'sys.update': 'modificar',
  'sys.platformCode': 'Código de plataforma',
  'sys.msg24': 'Tiempo para descuento de retorno de agua (si se establecen dos tiempos de retorno de agua, el sistema emitirá el descuento según el tiempo de creación anterior)',
  'sys.msg28': 'Regalo de salario semanal',
  'sys.msg29': 'Ingrese salario y regalo',
  'sys.msg30': 'Salario mensual y regalo',
  'sys.msg31': 'Ingrese salario mensual y regalo',
  'sys.vip6': '¡Cantidad máxima de VIP {vipLevel} debe ser mayor que la cantidad mínima!',
  'sys.msg41': 'Método de monto de apuesta: tasa múltiple integral: {pointPercent}, máximo no más de: {maxPoint}',
  'sys.msg42': 'Método de pago: tasa múltiple de cantidad: {moneyPercent}, máximo no más de: {maxMoney} yuan|',
  'sys.msg42VN': 'Método de pago: tasa múltiple de cantidad: {moneyPercent}, máximo no más de: {maxMoney} VND|',
  'sys.msg61': 'Monto preferencial',
  'sys.msg66': 'Monto de depósito: {minDeposit} ~ {maxDeposit} requisito diario: {betMultiple} veces o más',
  'sys.msg67': 'Efectivo libre: {giftPercent}%, efectivo máximo: {maxBonusAmount} | múltiple de flujo: {betMultiple}',
  'sys.msg87': 'A punto de eliminar tipo de artículo de Título {name}',
  'sys.msg93': 'Móvil - cargar logotipo del juego',
  'sys.msg94': 'Móvil - cargar logotipo del juego',
  'sys.msg95': '¡A punto de eliminar elemento de configuración {name}!',
  'sys.msg105': 'A punto de deshabilitar grupo de imagen con nombre: {imgName}',
  'sys.submitPer': 'presentante',
  'sys.submitTime': 'Tiempo de envío',
  'sys.inputYear': 'Año de importación',
  'sys.h5': 'Soportar H5',
  'sys.h51': 'Seleccione si H5 es compatible',
  'sys.pcPic': 'Imágenes de PC',
  'sys.h5Pic': 'Imágenes de H5',
  'sys.operatePermission': 'Autoridad de operación',
  'sys.uploadApp': 'Cargar archivo de aplicación',
  'user.title.totalUserCount': 'Total:',
  'user.title.totalDepositUserCount': 'Depósitos totales',
  'user.title.totalFirstDepositUserCount': 'Monto del primer depósito',
  'common.operateSuccess2': 'La operación es exitosa. El sistema lo procesará automáticamente. Actualice la consulta más tarde.',
  'common.export.type2': 'Exportación de agente general',
  'common.export.type1': 'Exportación total de miembro',
  'common.radio.seconds': 'segundo',
  'menu.operation.frontContent.nav': 'Gestión de navegación',
  'menu.information.lotteryUserTrace.lotteryUserDailyTask': 'Tareas diarias',
  'menu.information.lotteryUserTrace': 'Rastro de miembro',
  'menu.information.lotteryOrder.orderList': 'Orden de compra',
  'menu.information.lotteryOrder.giveBonusList': 'Registro de premios',
  'menu.information.lotteryOrder': 'Orden de Liuhe',
  'menu.information.lotteryManager.generalManager': 'Configuración general',
  'menu.information.lotteryManager.userBanList': 'Gestión prohibida',
  'menu.information.lotteryManager.dailyTaskManager': 'Tareas diarias',
  'menu.information.lotteryManager.lotteryLevelSetting': 'Configuración de nivel',
  'menu.information.lotteryManager': 'Gestión de Liuhe',
  'menu.information.lotteryOpen.queryLotteryEntryList': 'Entrada de fuente de premio',
  'menu.information.lotteryOpen.queryLotteryHistoryList': 'Resultados de lotería',
  'menu.information.lotteryOpen.queryLotteryOpenDateList': 'Fecha de lotería',
  'menu.information.lotteryOpen': 'Gestión de lotería',
  'menu.information': 'información',
  'menu.queryMarket': 'Mi lista',
  'menu.unLoggedList': 'Lista no cotizada',
  'menu.queryAllocation': 'Lista de asignación',
  'menu.querySeat': 'Gestión de asientos',
  'menu.queryTeam': 'Rendimiento del equipo',
  'menu.queryMyScore': 'Mis logros',
  'menu.queryAllScore': 'Ver los detalles del comisionista',
  'menu.callListA': 'Detalles de la llamada',
  'menu.callRecord': 'Registro de llamada',
  'menu.userInfoCallRecord': 'Registro de llamada de detalles de miembro',
  'menu.tele': 'Sistema de pin eléctrico',
  'menu.queryAgent': 'Lista de proxies',
  'menu.agentContact': 'Información del agente',
  'menu.queryPhoto': 'Imágenes promocionales',
  'menu.agentCommissionSetting': 'Configuración de comisión',
  'menu.queryOtherCost': 'Otras tarifas de agencia',
  'menu.agentDomain': 'Nombre de dominio proxy',
  'menu.commissionReport': 'Informe de comisión',
  'menu.agentReport': 'Declaración de proxy',
  'menu.agent': 'Sistema de agentes',
  'menu.addAdvertising': 'Nuevos gastos publicitarios',
  'menu.queryAdAgent': 'Lista de canales publicitarios',
  'menu.ad': 'Gestión publicitaria',
  'menu.market': 'Promoción de mercado',
  'menu.riskSetting': 'Aprobación de retiro',
  'menu.userPropAuth': 'Revisión de atributo de miembro',
  'menu.bonusLockList': 'Bloqueo preferencial',
  'menu.depositLockList': 'Bloqueo de depósito',
  'menu.checkAgentCommissionByRisk': 'Auditoría de control de riesgo de comisión de agente',
  'menu.queryGameTrans': 'Transferencia de juego anormal',
  'menu.risk': 'Gestión de riesgos',
  'menu.overall': 'Tendencia general',
  'menu.reportBetRecord': 'Informe de registro de apuestas',
  'menu.sportUnSettlement': 'Registros sin liquidar de deportes',
  'menu.realTimeStatistics': 'Estadísticas en tiempo real',
  'menu.analyze.onlineUser': 'Usuarios en línea',
  'menu.reportPlatform': 'Descripción general de la plataforma',
  'menu.reportChannel': 'Informe de canal',
  'menu.reportGamePlatform': 'Informe de plataforma de juego',
  'menu.analyze.reportManualTransfer': 'Declaración de reconciliación',
  'menu.reportDeposit': 'Declaración de depósito',
  'menu.reportWithdrawal': 'Declaración de retiro',
  'menu.reportDividend': 'Declaración preferencial',
  'menu.analyze.userGameReport': 'Informe de juego del usuario',
  'menu.userDeposit': 'Informe de recarga del usuario',
  'menu.paymentStatistics': 'Informe de canal de pago',
  'menu.analyze.paymentTab': 'Informe de tasa de éxito de pago',
  'menu.operationLog': 'Registro de operación',
  'menu.analyze.smsNameVerifyLog': 'Registro de generación de certificación',
  'menu.analyze': 'Análisis de datos',
  'menu.queryPayOrder': 'Gestión de orden de recarga',
  'menu.finance.queryOfflinePayOrder': 'Revisión de pago sin conexión',
  'menu.finance.queryOnlinePayOrder': 'Gestión de pago en línea',
  'menu.finance.payFrontConfig': 'Configuración de clasificación de pago',
  'menu.finance.payConfig': 'Configuración de canal de pago',
  'menu.finance.withdrawPay': 'Configuración de canal de pago',
  'menu.checkAgentCommissionByFinance': 'Auditoría financiera de comisión de agencia',
  'menu.finance.config.payChannel': 'Configuración de canal de pago',
  'menu.finance.config.withdraw': 'Configuración de canal de pago',
  'menu.finance.config': 'Configuración de pago',
  'menu.finance': 'Centro financiero',
  'menu.queryRole': 'Gestión de roles',
  'menu.adminAccount': 'Gestión de cuenta de fondo',
  'menu.sys.userSysAdmin': 'Gestión de parámetros del sistema',
  'menu.sys.lottery.queryLotteryMethodList': 'Gestión de juego',
  'menu.sys.lottery.queryLotteryPropList': 'Gestión de atributos',
  'menu.sys.lottery.queryLotteryRateList': 'Gestión de probabilidades',
  'menu.sys.lottery.queryLotteryHistoryList': 'Resultados de lotería',
  'menu.sys.lottery': 'Gestión de lotería',
  'menu.queryMailPool': 'Configuración de correo',
  'menu.queryMailTemplate': 'Plantilla de correo',
  'menu.queryGameList': 'Configuración de lista de juegos',
  'menu.paymentSuccessRate': 'Configuración de alerta de tasa de éxito de pago',
  'menu.slotManage': 'Gestión de espacios',
  'menu.payIpWhitelist': 'Lista blanca de IP de pago',
  'menu.sys.ipBlockList': 'Lista negra de IP de usuario',
  'menu.sys.deviceBlockList': 'Lista negra de equipos de usuario',
  'menu.ipWhitelist': 'Lista blanca de IP de fondo',
  'menu.ticket': 'Sistema de orden de trabajo',
  'menu.unlockCondition': 'Configuración de canalización de desbloqueo automático',
  'menu.uploadPackage': 'Gestión de paquetes de aplicación',
  'menu.sys': 'Configuración del sistema',
  'menu.queryMenu': 'Gestión de menús',
  'menu.queryButton': 'Gestión de botones',
  'menu.queryNotify': 'Gestión de tipo de notificación',
  'menu.queryConfig': 'parámetro del sistema',
  'menu.ee.withdrawPay': 'Configuración de canal de pago',
  'menu.paySetting': 'Parámetros de pago',
  'menu.queryAdmin': 'Gestión de cuenta de administrador ',
  'menu.ee': 'Huevo',
  'menu.pictureGroup': 'Gestión de imágenes',
  'menu.queryGamePlatform': 'Configuración de plataforma de juego',
  'menu.signQueryGamePlatform': 'Configuración de logotipo de plataforma de juego',
  'menu.queryWithdraw': 'Gestión de orden de retiro',
  'menu.C2CWithdraw': 'Gestión de orden de retiro C2C',
  'constants.riskLevelType_-10': 'Acceso limitado a beneficios',
  'constants.nav_0': 'página de inicio',
  'constants.nav_1': 'Persona real',
  'constants.nav_2': 'Deportes',
  'constants.nav_3': 'Electrónica',
  'constants.nav_4': 'Ajedrez y cartas',
  'constants.nav_5': 'pesca',
  'constants.nav_6': 'lotería',
  'constants.nav_7': 'Club de diamantes',
  'constants.nav_8': 'Descuento',
  'constants.nav_9': 'Sala de concesiones',
  'constants.nav_10': 'Otro',
  'constants.transferType_6': 'Congelado',
  'constants.transferType_7': 'Descongelar',
  'constants.regSourceType_4': 'Invitación',
  'constants.bonusType_1': 'Tratamiento preferencial del agua',
  'constants.bonusType_2': 'Descuento de depósito',
  'constants.bonusType_3': 'Invitación a descuento',
  'constants.bonusType_4': 'Preferencia de inicio de sesión',
  'constants.bonusType_5': 'Oferta de revisión manual',
  'constants.bonusType_6': 'Preferencia de depósito continuo',
  'constants.bonusType_7': 'Preferencias de registro',
  'constants.bonusType_8': 'Canales de depósito preferenciales',
  'constants.bonusType_9': 'Preferencia de nota',
  'constants.bonusType_10': 'Preferencia de apuesta',
  'constants.bonusType_11': 'Descuento de retorno de agua',
  'constants.bonusType_12': 'Oferta de depósito en tiempo real',
  'constants.bonusType_13': 'Oferta de vinculación de información',
  'constants.bonusType_14': 'Descuento de lotería',
  'constants.bonusType_15': 'Bono de inicio de sesión',
  'constants.bonusType_16': 'Preferencia de depósito e inversión continua',
  'constants.bonusType_19': 'Descuento de tarea diaria',
  'constants.bonusType_24': 'Invitación a descuento(Nuevo)',
  'constants.bonusType_26': 'Sobre rojo codificado',
  'constants.bonusType_28': 'Oferta de primer retiro',
  'constants.bonusType_30': 'Oferta de gran giro',
  'constants.bonusType_31': 'Descuentos acumulados de depósito e inversión',
  'constants.bonusType_32': 'Guardado de bolígrafo de juego',
  'constants.bonusType_33': 'Canales de retiro preferenciales',
  'constants.bonusType_34': 'Oferta de depósito de siete días',
  'constants.bonusType_38': 'Descuento de página de recarga',
  'constants.gameSport3_XA': 'Competencia Ai Ai',
  'constants.gameSport3_LH': 'Competencia de trueno y rayo',
  'constants.gameSport3_FB': 'Deportes de velocidad',
  'constants.gameSport3_SBO': 'Deportes SBO',
  'constants.gameSport3_JC': 'Deportes de lotería competitiva',
  'constants.gameSport3_AISPORT': 'Deportes de IA',
  'constants.gameSport3_FBTY': 'Deportes FB',
  'constants.gameSport3_HG': 'deportes de corona',
  'constants.gameSport3_PM': 'Deportes PM',
  'constants.gameSport3_SBOI': 'Deportes SBOI',
  'constants.gameChess6_TM': 'Ajedrez y cartas de Tian Mei',
  'constants.gameChess6_LC': 'Ajedrez de la ciudad del dragón',
  'constants.signType_0': 'Popular',
  'constants.signType_1': 'actividad',
  'constants.signType_2': 'Un Gran Premio',
  'constants.gameSignType_0': 'Popular',
  'constants.gameSignType_1': 'Electrónica',
  'constants.gameSignType_2': 'Persona real',
  'constants.gameSignType_3': 'Deportes',
  'constants.gameSignType_4': 'lotería',
  'constants.gameSignType_5': 'pesca',
  'constants.gameSignType_6': 'Ajedrez y cartas',
  'analyze.card.rechargeRate': 'Tasa de recarga',
  'game.title.betAmount1': 'Monto de apuesta',
  'game.title.playerProfit1': 'Rentabilidad del jugador',
  'user.title.channel': 'canal',
  'sys.navName': 'Nombre de navegación',
  'sys.navName.prompt': 'Ingrese un nombre de navegación',
  'sys.nav.type': 'Tipo de navegación',
  'sys.nav.type.prompt': 'Seleccione un tipo de navegación',
  'sys.nav.img': 'Imágenes de navegación',
  'sys.nav.img.prompt': 'Cargue la imagen de navegación',
  'sys.nav.modal.list': 'Lista de navegación',
  'sys.title.limitLength200': 'Ingrese menos de 200 caracteres',
  'agent.settlementDate.month': 'Mes de liquidación',
  'agent.settlementDate.startDate': 'Inicio',
  'agent.settlementDate.endDate': 'Fin',
  'pay.title.cancelOrder': 'Cancelación de orden',
  'pay.title.cancelOrder1': '¿Está seguro de que desea cancelar la orden?',
  'sys.title.orderAmount3': 'Cancelado',
  'pay.title.rejectInfo': 'Información de rechazo',
  'login.install.current': 'Número de versión actual',
  'lottery.title.confirmNotice16': '¿Confirmar para restablecer la contraseña de retiro del agente? Después de restablecer, ¿se requiere una nueva contraseña para el retiro del agente?',
  'lottery.title.day': 'día',
  'agent.title.resetPassSuccess1': 'Contraseña de retiro restablecida exitosamente',
  'agent.title.newPassIs1': 'Contraseña de retiro restablecida exitosamente. La nueva contraseña es:',
  'user.title.address': 'dirección',
  'user.title.updatePromotionPicture': 'Modificar imagen de promoción',
  'user.title.unTied': 'Desvinculando',
  'user.title.silentRate': 'Usuario silencioso',
  'user.title.assignDetail': 'Detalles de distribución',
  'user.title.activationCount': 'Activar {importCount} personas',
  'user.title.dial': 'marcar',
  'user.title.loading': 'Cargando...',
  'user.title.gender': 'Género',
  'user.title.devicTime': 'Tiempo de correlación',
  'user.title.idNo2': 'Cédula No.',
  'user.title.device': 'equipo',
  'user.title.unVerifiedPhone': 'Teléfono no verificado',
  'user.title.playerInvite': 'Invitación del jugador',
  'user.title.registerSource': 'Fuente de registro',
  'user.title.riskDetail': 'Detalles de control de riesgo',
  'user.title.addBonusSuccess': 'Bono agregado exitosamente',
  'user.title.adjustedRiskLevel': 'Ajustar nivel de riesgo',
  'user.title.loadingUserInfoFail': 'Error al cargar la información del usuario',
  'user.title.loadingUserInfoError': 'Error al cargar la información del usuario',
  'user.title.firstDepositRate1': 'Tasa de primer depósito: usuario de primer depósito / usuario nuevo',
  'agent.export.agentReportExcel': 'Informe del agente.xls',
  'user.title.from': 'desde',
  'user.title.to': 'hasta',
  'user.title.last7': 'Últimos 7 días',
  'user.title.last30': 'Últimos 30 días',
  'user.title.last60': 'Últimos 60 días',
  'user.title.queryType': 'Tipo de consulta',
  'user.title.registerSelf': 'Registro propio',
  'user.title.registerAgent': 'Canal del agente',
  'user.title.channelSource': 'Fuentes de canal',
  'user.title.giveRequire': 'Restricciones de distribución',
  'game.title.changeGamePlatformSign': 'Modificar logo de plataforma de juegos',
  'game.title.signType': 'Tipo de identificación',
  'game.title.hotSignType': 'Tipo de logo popular',
  'game.title.signStatus': 'Estado de identificación',
  'game.title.hotSignStatus': 'Estado popular',
  'game.title.changeStatus_0': 'Identificador deshabilitado',
  'game.title.changeStatus_1': 'Logo habilitado',
  'game.title.changeStatus_01': 'Popular deshabilitado',
  'game.title.changeStatus_10': 'Popular habilitado',
  'common.finance.autoTransferOutGame': 'Transferir automáticamente {platformName} fuera del juego',
  'admin.pay.manualDepositWithDrawals': 'Depósito manual',
  'admin.finance.rejectWithdrawals': 'Rechazar retiro',
  'admin.finance.rejectWithdrawalsReason': 'Solicitud de retiro rechazada, saldo reducido devuelto',
  'admin.finance.recharge': 'Recarga',
  'common.bonus.bonusToGame': 'Bono {fullName} transferido automáticamente al juego',
  'common.bonus.issueBonus': 'Bono {fullName}',
  'common.finance.customerServiceManualTransfer': 'Ajuste manual de cuenta de servicio al cliente, {userName}',
  'common.finance.bonusAprove': 'Aprobación de {userName}, {bonusName}',
  'admin.bonus.realTimeDepositBonus': 'Descuento de depósito en tiempo real, {date}',
  'admin.bonus.remittanceChannelBonus': 'Dividendo de canal de remesa, {date}',
  'admin.bonus.dividends': 'Pago de bono, {date}',
  'common.bonus.inviteBonus': 'Bono de invitación, {date}',
  'common.bonus.signDrawBonus': 'Bono de lotería firmada, {date}',
  'common.bonus.continuousDepositDrawBonus': 'Bono de sorteo de depósito continuo, {date}',
  'common.bonus.continuousDepositPointsBonus': 'Bono de depósito continuo, {date}',
  'common.bonus.flowRebate': '{type} reembolso de flujo, {date}',
  'common.bonus.betBonus': '{type} dividendo, {date}',
  'common.bonus.rescueFundBonus': 'Fondo de rescate, {date}',
  'common.bonus.activityType1Prize': 'Premio de rueda de la suerte',
  'common.bonus.activityType2Prize': 'Premio de agitación',
  'common.bonus.activityType4Prize': 'Premios de caja ciega',
  'common.bonus.activityType5Prize': 'Premios de rueda de efectivo',
  'common.bonus.alwaysRebate': 'Reembolso de flujo {date} cuando {gametype}',
  'common.bonus.signPointsBonus2': 'Bono de inicio de sesión de {userAccount}, {date}',
  'front.bonus.noteBonus': 'Bono de nota',
  'front.bonus.memberInfoBindingBonus': 'Bono de vinculación de información de miembro',
  'front.bonus.agentRegisterBonus': 'Proporcionar preferencia de registro mediante registro de agente',
  'front.bonus.depositBonus': 'Bono de depósito',
  'front.bonus.upgradeReward': '{bonusName} - bono de mejora',
  'front.bonus.weekReward': '{bonusName} - recompensa de salario semanal',
  'front.bonus.monthReward': '{bonusName} - recompensa de salario mensual',
  'front.bonus.customerServiceRetrieval': 'Servicio al cliente retorna {platformKey}',
  'admin.finance.assetsAccountMsg1': 'Suplemento de servicio al cliente, error al recuperar del juego, {platform code}',
  'admin.finance.assetsAccountMsg2': 'Suplemento de servicio al cliente, error al transferir al juego, {platform code}',
  'front.bonus.customerServiceBatchRetrieval': 'Servicio al cliente recupera lote {platformKey}',
  'front.bonus.autoReplenishment1': 'Llenado automático de orden, error al recuperar del juego, {platformCode}',
  'front.bonus.autoReplenishment2': 'Llenado automático de orden, error al transferir al juego, {platformCode}',
  'common.finance.autoTransferInGame': 'Transferir automáticamente al juego {platformName}',
  'front.pay.applyForWithdrawal': 'Solicitud de retiro en efectivo',
  'front.pay.applyForWithdrawalMinusAmount': 'Reclamación de cantidad menor',
  'common.bonus.addBonusesBackground': 'Agregar bono en segundo plano:{name}',
  'front.pay.adjustableWithdrawal': 'Ajustar retiro: {betflowBalance} - > {availBalance}',
  'admin.bonus.approveBonus': 'Bono aprobado: {bonusName}',
  'admin.bonus.effectiveFlow': '{bonusName}, establecer tubería válida: {validBetflow}',
  'admin.bonus.cancelBonus': 'Cancelar bono: {bonusName}',
  'common.bonus.playerManuallyApply': 'Jugadores solicitan manualmente: {userAccount}',
  'front.bonus.extraBonus': 'Bono de entrada del jugador: {userAccount}',
  'front.bonus.redeemPointsManually': 'Jugadores recopilan manualmente canje de puntos: {userAccount}',
  'front.bonus.continuousDepositBonus': 'Bono de depósito continuo',
  'front.bonus.checkInBonus': 'Bono de asistencia',
  'front.bonus.invitationBonus': 'Bono de invitación',
  'admin.bonus.bounusCopy': '{articleName} (copia)',
  'admin.bonus.uploadNoticeError': 'Línea {num}; parámetro incorrecto, verifique cuidadosamente.',
  'common.userAccountNotExist4': 'usuario no existe',
  'admin.bonus.bonusArrivalNotice': '[{bonusName}] ¡notificación de recepción de dividendo!',
  'admin.bonus.bonusArrivalNotice1': 'Hola, tu bono {bonusName} ha llegado, la cantidad es {bonusAmount}, verifica.',
  'admin.msg.withDrawalsApproveNotice': 'Su solicitud de retiro {amount} ha sido aprobada exitosamente',
  'admin.msg.wihtDrawalsPayoutNotice': 'El retiro que solicitó el {date} ha pasado la revisión, entre los cuales la solicitud de retiro = {amount1}, (usted asume la comisión de manejo = {amount2}. Retiro real = {amount3}). El retiro ha pasado la revisión, verifique más tarde, gracias por su participación, siéntase libre de contactarnos si tiene alguna pregunta',
  'common.msg.withDrawalsSuccess': 'Su solicitud de retiro {amount} ha sido enviada a su tarjeta bancaria',
  'common.msg.withDrawalsSuccessNotice': 'Monto de pago = {amount}, ha sido pagado a su tarjeta bancaria, verifique. Gracias por su participación, si tiene alguna pregunta, siéntase libre de contactarnos',
  'admin.msg.riskControlApproveNotice': '(operación de control de riesgo) el usuario {userAccount} solicita retirar {amount} yuan, que ha sido aprobado por {userName} y puede ser auditado por el departamento de finanzas',
  'admin.msg.manualConfirmRechargeNotice': '(operación financiera) usuario {userAccount} recarga {orderAmount}, que es confirmado manualmente por {userName}',
  'admin.msg.riskControlRejectNotice': '(operación de control de riesgo) usuario {userAccount} solicitó retirar {amount} yuan, que ha sido rechazado por {Username}',
  'admin.msg.financeRejectWithdrawalsNotice': '(operación financiera) usuario {userAccount} solicitó retirar {amount} yuan, que ha sido rechazado por {userName}',
  'admin.msg.financeApproveNotice': '(operación financiera) usuario {userAccount} solicitó retirar {amount} yuan, que ha sido pagado por {userName}',
  'admin.msg.financePayforTimeoutNotice': '(operación financiera) el usuario {userAccount} solicitó retirar {amount} yuan, que ha sido acordado por {userName}, y la solicitud de pago de {payName} agotó el tiempo de espera. Verifique el estado del pedido de la plataforma de pago',
  'admin.msg.financePayforExceptionNotice': '(operación financiera) el usuario {userAccount} solicitó retirar {amount} yuan, que ha sido acordado por {userName}. La solicitud de pago de {payName} es anormal. Verifique el estado de la plataforma de pago',
  'admin.msg.financePayforFailNotice': '(operación financiera) el usuario {userAccount} solicitó retirar {amount} yuan, que ha sido acordado por {userName}, y la solicitud de pago de {payName} falló: {message}, verifique el estado del pedido de la plataforma de pago',
  'admin.msg.financePayforSuccess': '(operación financiera) el usuario {userAccount} solicita retirar {amount} yuan, que ha sido acordado por {username}, y {payName} está en el pago',
  'admin.msg.financePayforSuccess1': '(operación financiera) el usuario {userAccount} solicitó retirar {amount} yuan, que ha sido pagado exitosamente por {channel} en nombre del usuario',
  'admin.msg.financePayforFail': '(operación financiera) el usuario {userAccount} solicitó retirar {amount} yuan, y {channel} no pudo pagar el pago en nombre',
  'admin.msg.paymentSuccessRate1': 'operación financiera) método de pago: {payMark}, canal de pago: {viewName}, tasa de éxito de pago: {successRate}, por debajo de la tasa de éxito de alerta temprana. Preste atención al control.',
  'admin.msg.paymentSuccessRate2': 'operación financiera) método de pago: {payMark}, canal de pago: {viewName}, tasa de éxito de pago: {successRate}, por debajo de la tasa de éxito de alerta temprana. El método de pago se ha deshabilitado automáticamente. Verifique.',
  'admin.msg.companyDeposit': '(operación financiera) jugador: {userAccount}, aportación de empresa de solicitante {amount}, número de pedido {orderNo}',
  'front.finance.windControlAudit': '(control de riesgo) usuario {account} solicita retirar {amount} yuan, verifique por control de riesgo.',
  'front.finance.rechargeSuccess': '(sistema) usuario {userAccount} recargado exitosamente {orderAmount} elemento.',
  'admin.sys.ftpPathError': 'Error de creación de ruta FTP',
  'admin.sys.ftpReaptFileError': 'El archivo ya existe, error de reconstrucción',
  'admin.msg.realNameName': 'Nombre real: {userName}',
  'admin.finance.withdrawals': 'Retiro en efectivo',
  'admin.pay.manualTransfer': 'Conciliación manual',
  'admin.pay.manualDeposit': 'Depósito manual',
  'admin.pay.manualTransferRemoval': 'Ajuste manual de cuenta, retiro manual:{userName}',
  'sys.activity.win.type': 'Tipo de exposición de ganancia',
  'sys.activity.win.type.prompt': 'Seleccione el tipo ganador',
  'sys.activity.falseWin': 'Información de ganancia falsa',
  'sys.activity.realWin': 'Información de ganancia real',
  'sys.activity.lotteryStyle': 'Método de lotería',
  'sys.activity.selectLotteryStyle': 'Seleccione el método de lotería',
  'sys.activity.lotteryStyle1': 'La Gran Rueda',
  'sys.activity.lotteryStyle2': 'Máquina tragamonedas',

  'activity.batch.userAccount': 'NombreCuenta',
  'activity.batch.count': 'tamaño',
  'activity.batch.days': 'días',
  'activity.batch.status': 'estado',
  'activity.batch': 'ImportarLote',
  'activity.batchDetail': 'Detalle de Importación de Lote',
  'menu.activityBatch': 'ImportarLote',
  'activity.batch.desc1': '1.NombreCuenta;',
  'activity.batch.desc2': '2.Agregar Tamaño;',
  'activity.batch.desc3': '3.Días efectivos;',

  'sys.winningProbability1': 'Ingrese la probabilidad de ganar dentro de 11',
  'sys.pcImage': 'Imagen de extremo de PC',
  'sys.APPImage': 'Imágenes móviles',
  'sys.startTime2': 'Hora de apertura',
  'sys.bonus.lock.type': 'Tipo de bloqueo',
  'sys.bonus.lock.type.1': 'Cantidad preferencial',
  'sys.bonus.lock.type.2': 'Cantidad preferencial + principal',
  'sys.bonus.deposit.lock.type': 'Relacionado con desbloqueo',
  'sys.bonus.deposit.lock.type.0': 'Desbloqueando',
  'sys.bonus.deposit.lock.type.1': 'Desbloquear el bloqueo de recarga para este pedido',
  'sys.extraLogo': 'Iconos extras',
  'sys.msg201': 'Lado de PC: cargue logo adicional de juego',
  'sys.msg202': 'Móvil - cargar logo adicional de juego',
  'menu.member.signMember': 'Etiqueta de membresía',
  'menu.operation.balanceRate': 'Yu Bao',
  'menu.operation.balanceRate.programSetting': 'Configuración de esquema',
  'menu.operation.balanceRate.buyRecord': 'Registro de compra',
  'constants.bonusType_21': 'Oferta de nuevo inicio de sesión',
  'constants.newBonusType_21': 'Bono de nuevo inicio de sesión',
  'constants.bonusMainType_21': 'Bono de nuevo inicio de sesión',
  // 'constants.newBonusMainType_21': 'Bono de nuevo inicio de sesión',
  'constants.gameSlot1_IGS': 'IG electrónico',
  'constants.gameSlot1_PT2': 'PT electrónico',
  'constants.gameSlot1_GG2': 'Electrónico GG2',
  'constants.gameSport3_CMD': 'CMD Sports',
  'constants.gameSport3_WS168': 'WS168 Pelea de gallos',
  'constants.gameSport3_S128': 'S128 Pelea de gallos',
  'constants.gameSport3_BBIN': 'BBIN',
  'constants.gameSport3_TP': 'TP',
  'constants.gameSport3_BTI': 'BTI Sports',
  'constants.gameSport3_DS': 'DS88 Sport',
  'constants.gameSport3_DS888': 'DS888 Pelea de gallos',

  'constants.gameLottery4_KK': 'Lotería KK',
  'constants.gameChess6_DGC': 'Cartas de ajedrez DG',
  'sys.bonus.domain.type': 'Restricción de nombre de dominio o no',
  'sys.bonus.domain.type.prompt': 'El nombre de dominio restringido no puede estar vacío',
  'sys.bonus.domain.noLimited': 'Ilimitado',
  'sys.bonus.domain.Limited': 'Nombre de dominio restringido',
  'sys.bonus.domain.input.prompt': 'Lista de nombres de dominio (separados por comas)',
  'sys.bonus.domain.nullPrompt': 'Ingrese el nombre de dominio',
  'sys.bonus.domain.input.maxPrompt': 'Longitud máxima 256, no exceda',
  'sys.bonus.domain.prompt': 'Ingrese el nombre de dominio gratuito (solo dominio de nivel superior); por ejemplo: baidu.com, baidu.com',
  'front.bonus.selfRegisterBonus': 'Descuento de registro gratuito mediante registro propio',
  'sys.frontMatch.matchName': 'Nombre de la competencia',
  'sys.frontMatch.hTeam': 'Nombre del equipo local',
  'sys.frontMatch.hTeamLogo': 'Icono del equipo local',
  'sys.frontMatch.gTeam': 'Nombre del equipo visitante',
  'sys.frontMatch.gTeamLogo': 'Icono del equipo visitante',
  'sys.frontMatch.jumpUrl': 'Dirección de salto',
  'sys.frontMatch.insertMatch': 'Nuevo torneo',
  'sys.frontMatch.updateMatch': 'Torneos de enmienda',
  'menu.operation.frontContent.match': 'Gestión de eventos',
  'sys.bonus.refuseMessage': 'Información de rechazo',
  'sys.bonus.signInOnlyExistOn': 'Solo se puede establecer una oferta.',
  'sys.validit.joinUserLevel': 'Nivel de miembro participante',
  'sys.validit.pleaseSelectJoinUserLevel': 'Seleccione el nivel más bajo de miembros que pueden participar en la actividad',
  'sys.signInCnd': 'Condición de entrada',
  'sys.signInDay': 'día',
  'sys.signInTotalDeposit': 'Monto de depósito acumulado',
  'sys.signInOneDeposit': 'Monto de depósito único',
  'sys.signInGiveAmount': 'Monto de recompensa',
  'sys.signInGivePoint': 'Puntos de bonificación',
  'sys.signInBetflowMultiple': 'Múltiple de flujo',
  'sys.signInOtherAmount': 'Bono extra',
  'sys.signInOtherPoint': 'Puntos extra',
  'sys.signInTotalBetflowCnd': 'Apuestas efectivas',
  'sys.pcPicH5SmallPic': 'Icono pequeño de PC / H5',
  'sys.pcSmallPic': 'Icono pequeño de PC',
  'sys.h5SmallPic': 'Icono pequeño de H5',
  'menu.sys.popularPlatformGame': 'Configuración de plataforma de juegos popular',
  'sys.addGame': 'Agregar juego',
  'sys.select.gameList': 'Seleccione un juego',
  'sys.edit.popular': 'Modificar información popular',
  'sys.popularType': 'Tipos populares',
  'user.title.signName': 'Nombre de etiqueta',
  'user.title.signName1': 'Ingrese un nombre de etiqueta',
  'user.title.addMemberSign': 'Nueva etiqueta de miembro',
  'common.button.addMemberSign': 'Agregar etiqueta de miembro',
  'sys.title.deleteMemberSignName': 'Etiquetas de miembro a eliminar: {signName}',
  'sys.lengthLimit5': 'Entrada de hasta 7 caracteres chinos',
  'user.button.markMember': 'Usuario etiquetado',
  'user.title.noneSign': 'Actualmente, no hay etiqueta opcional. Vaya a la página de etiqueta de miembro para agregar una etiqueta',
  'user.msg.markMember': 'Marcado exitoso',
  'user.msg.markMember1': 'Marcado fallido',
  'user.title.memberSign': 'Etiqueta',
  'sys.cellphoneNumber4': 'Ingrese su número de móvil de Vietnam',
  'constants.gameChess6_BL': 'Bole ajedrez / electrónico',
  'constants.gameSlot1_AWS': 'AWS electrónico',
  'sys.rateBonus.allStatus': 'completo',
  'sys.rateBonus.create': 'Nuevo esquema',
  'sys.rateTable.amountLimit': 'Cuota individual',
  'sys.rateTable.totalRate': 'Tasa de interés bruta',
  'sys.rateTable.programCycle': 'Ciclo de liquidación de esquema',
  'sys.rateTable.scheduleCycle': 'Ciclo de programa',
  'sys.rateTable.settlementCycle': 'Ciclo de liquidación',
  'sys.rateTable.timeType': 'hora',
  'sys.rateTable.rateLimit': 'Techo de interés',
  'sys.rateTable.needBetflow': 'Requisitos de flujo',
  'sys.rateTable.capital': 'Principal',
  'sys.rateTable.rate': 'Interés',
  'sys.rateTable.multiple': 'veces',
  'sys.rateTable.settlement': 'Estado de ventas',
  'sys.rateTable.totalStock': 'Participación total',
  'sys.rateTable.selled': 'Vendido',
  'sys.rateTable.going': 'Generador de intereses',
  'sys.rateTable.edit': 'Editor',
  'sys.rateTable.market': 'Estante superior',
  'sys.rateTable.takeOff': 'Estante inferior',
  'sys.rateTable.sort': 'ordenar',
  'sys.singleTime': 'Tiempo único',
  'sys.accumulative': 'acumulativo',
  'bonus.rateTitle.createBalanceRate': 'Nuevo esquema yu\'ebao',
  'bonus.rateTitle.editBalanceRate': 'Editar esquema yu\'ebao',
  'bonus.rateTitle.bonusName': 'Nombre del esquema',
  'bonus.rateTitle.bonusName1': 'Ingrese el nombre del esquema',
  'bonus.rateTitle.sort': 'orden',
  'bonus.rateTitle.sort1': 'Ingrese el orden',
  'bonus.rateTitle.minBuyAmount': 'Monto de compra mínimo',
  'bonus.rateTitle.minBuyAmount1': 'Ingrese la cantidad de compra mínima',
  'bonus.rateTitle.maxBuyAmount': 'Monto de compra máximo',
  'bonus.rateTitle.maxBuyAmount1': 'Ingrese la cantidad de compra máxima',
  'bonus.rateTitle.buyAmountRightNotice': 'Ingrese la cantidad correcta',
  'bonus.rateTitle.totalRate': 'Interés total (%)',
  'bonus.rateTitle.totalRate1': 'Ingrese el interés total',
  'bonus.rateTitle.settlementCycle': 'Ciclo de liquidación (horas)',
  'bonus.rateTitle.settlementCycle1': 'Ingrese el período de liquidación',
  'bonus.rateTitle.settlementCycleNotice': 'En el ciclo del esquema, se emitirá interés una vez por ciclo de liquidación, y la tasa de interés de cada ciclo de liquidación es "tasa de interés total / (ciclo de esquema / ciclo de liquidación) = tasa de interés de ciclo de liquidación". Suponiendo que la tasa de interés total es 3%, el período del esquema es 24 horas y el período de liquidación es 1 hora, se pagará 0.125% de interés en cada período de liquidación.',
  'bonus.rateTitle.schemeCycle': 'Período de esquema (horas)',
  'bonus.rateTitle.schemeCycle1': 'Ingrese el período de esquema',
  'bonus.rateTitle.loopType': 'Cálculo cíclico',
  'bonus.rateTitle.loopType1': 'Seleccione el modo de cálculo de ciclo',
  'bonus.rateTitle.loopTypeNotice': 'Cálculo de ciclo en: liquidación de ciclo de interés al límite superior de interés o colección de iniciativa del cliente de acuerdo con el ciclo de esquema. Suponiendo que el interés de RMB 10 se liquidará en 3 horas del ciclo, continuar liquidando en la 6ª hora hasta el límite superior o retiro; cálculo de ciclo cerrado: después del final del ciclo de esquema, no se liquidará el próximo ciclo. Suponiendo que el interés de RMB 10 se liquidará dentro de 3 horas del ciclo, no se liquidará después de una liquidación.',
  'bonus.rateTitle.maxRateAmount': 'Monto de interés máximo',
  'bonus.rateTitle.maxRateAmount1': 'Ingrese el monto de interés máximo',
  'bonus.rateTitle.capitalBetflowMultiple': 'Múltiple actual del principal',
  'bonus.rateTitle.capitalBetflowMultiple1': 'Ingrese el múltiple actual requerido para el retiro del principal',
  'bonus.rateTitle.rateBetflowMultiple': 'Múltiple de interés actual',
  'bonus.rateTitle.rateBetflowMultiple1': 'Ingrese el múltiple actual requerido para el retiro de intereses',
  'bonus.rateTitle.totalStock': 'Número total',
  'bonus.rateTitle.totalStock1': 'Ingrese el número total de copias',
  'bonus.rateTitle.userBuyCount': 'Número de acciones que los miembros pueden comprar',
  'bonus.rateTitle.userBuyCount1': 'Ingrese el número máximo de miembros a comprar',
  'bonus.rateTitle.buyAgainTime': 'Tiempo entre recompras (horas)',
  'bonus.rateTitle.buyAgainTime1': 'Ingrese el intervalo',
  'bonus.rateTitle.buyUserVip': 'Nivel requerido para la compra',
  'bonus.rateTitle.buyUserVip1': 'Seleccione el nivel requerido para la compra',
  'sys.rateTable.deleteNotice': 'Todavía hay un plan que no ha sido canjeado, no se puede eliminar.',
  'bonus.rateMsg.buyAmountNotice': 'La cantidad de compra mínima no puede ser mayor que la cantidad de compra máxima',
  'bonus.rateMsg.scheduleNotice1': 'El período de liquidación no puede ser mayor que el período de esquema',
  'bonus.rateMsg.scheduleNotice2': 'El período de esquema debe ser divisible por el período de liquidación',
  'bonus.buyRecord.buyTime': 'Tiempo de compra',
  'bonus.buyRecord.ransomTime': 'Tiempo de redención',
  'bonus.buyRecord.status_1': 'Generador de intereses',
  'bonus.buyRecord.status_2': 'Redención',
  'bonus.buyRecord.status_3': 'Canjeado',
  'bonus.buyRecordTable.bonusName': 'Nombre del esquema',
  'bonus.buyRecordTable.programAmount': 'Monto del programa',
  'bonus.buyRecordTable.captipleAmount': 'Principal',
  'bonus.buyRecordTable.rateAmount': 'Interés',
  'bonus.buyRecordTable.programSchedule': 'Programa del programa',
  'bonus.buyRecordTable.schemeCycle': 'Ciclo de esquema: {schemeCycle} horas',
  'bonus.buyRecordTable.settlementCycle': 'Ciclo de liquidación: {settlementCycle} horas',
  'bonus.buyRecordTable.loopType': 'Modo de circulación',
  'bonus.buyRecordTable.status': 'estado',
  'bonus.buyRecordTable.status_1': 'Generador de intereses',
  'bonus.buyRecordTable.status_2': 'Redención',
  'bonus.buyRecordTable.status_3': 'Canjeado',
  'bonus.buyRecordTable.time': 'hora',
  'bonus.buyRecordTable.buyTime': 'Tiempo de compra',
  'bonus.buyRecordTable.ransomTime': 'Tiempo de redención',
  'bonus.buyRecordTable.finishTime': 'Hora de finalización de interés',
  'bonus.buyRecordTable.ransomAdmin': 'Canjero',
  'bonus.buyRecordTable.operate': 'operación',
  'bonus.buyRecordTable.forceRansom': 'Redención forzada',
  'bonus.buyRecordTable.capitalBetflowMultiple': 'Requisitos de flujo de redención de principal: {capitalBetflowMultiple}',
  'bonus.buyRecordTable.rateBetflowMultiple': 'Requisitos de flujo de redención de interés: {rateBetflowMultiple}',
  'bonus.buyRecordTable.maxRateAmount': 'Monto de interés máximo: {maxRateAmount}',
  'bonus.buyRecordTable.confirmForceRansomMsg': 'Indicación de confirmación',
  'bonus.buyRecordTable.confirmForceRansom': '¿Está seguro de que desea canjear forzadamente el esquema?',
  'admin.bonus.rejectBonus': 'Bono denegado: {bonusName}',
  'admin.msg.financePayforManualFail': '(operación financiera) El usuario {userAccount} solicitó retirar {amount} yuan, que ha sido establecido manualmente por el usuario {userName} como fallo de pago',
  'admin.msg.deposit': '(operación financiera) Jugador: {userAccount}, solicitud de depósito {amount}, número de pedido: {orderNo}',
  'admin.pay.depositType': 'Tipo de depósito',
  'sys.registerMember': 'Miembro no agente',
  'admin.pay.deletePayment': '¡Deshabilite antes de eliminar!',
  'sys.title.bonusArtId': 'ID de artículo',
  'sys.title.onlinePay': 'Pago en línea',
  'sys.title.offlinePay': 'Pagos sin conexión',
  'sys.title.officePay': 'Depósito de empresa',
  'pay.earlyWarning.addEarlyWarning': 'Agregar alerta',
  'pay.earlyWarning.earlyWarningThreshold': 'Umbral de alerta temprana',
  'pay.earlyWarning.earlyWarningThreshold1': 'Ingrese un umbral de advertencia',
  'pay.earlyWarning.editEarlyWarning': 'Completar la información de advertencia',
  'pay.earlyWarning.successRoteEarlyWarning': 'Alarma de tasa de éxito del canal',
  'admin.finance.payEarlyWarningNotify': 'Tasa de éxito de {customizeName} es menor que {earlyWarningThreshold}%, verifique a tiempo',
  'sys.msg1421': 'Detalles personales',
  'sys.attribution1': 'Propiedad de IP',
  'menu.gameMonitor': 'Monitoreo global de juegos',
  'user.userChangeParentAgent': 'Cambiar agente padre',
  'user.userChangeParentAgent1': 'Seleccione un miembro para cambiar el agente superior',
  'user.addTHAUser': 'Nuevos usuarios',
  'user.addTHAUser.withdrawPassword': 'Contraseña de retiro',
  'user.addTHAUser.agentCode': 'Número de agente',
  'user.phoneIsValid': 'Si el número está verificado',
  'user.updateBank': 'Modificar tarjeta bancaria',
  'finance.payGroup.remark': 'Instrucciones de pago',
  'finance.payGroup.addRemark': 'Agregar instrucciones de pago',
  'finance.payGroup.externalLinkAmountRange': 'Pantalla de rango de cantidad de enlace externo',
  'sys.uniqueLimit.IP': 'Restricciones de IP única',
  'sys.uniqueLimit.device': 'Restricciones de dispositivo único',
  'sys.uniqueLimit.phone': 'Límite de número de teléfono móvil',
  'sys.receiveCount': 'Tiempos de recogida',
  'user.member.signMember': 'Etiquetas de miembro',
  'sys.title.deleteFail': 'Error al eliminar, intente de nuevo',
  'user.title.realtimeListExcel': 'Informe de estadísticas de miembro en tiempo real.xls',
  'user.title.currentResultAmount': 'Ganancia o pérdida',
  'bet.queryFrm.gameName': 'Nombre del juego',
  'bet.queryFrm.agentName': 'Cuenta de proxy',
  'bet.queryFrm.betweenResultAmount': 'Intervalo de ganancia y pérdida',
  'common.queryFrm.searchGameName': 'Nombre del juego',
  'common.queryFrm.searchAgentName': 'Cuenta de proxy',
  'common.queryFrm.searchMinResultAmount': 'Ganancia mínima',
  'common.queryFrm.searchMaxResultAmount': 'Ganancia o pérdida máxima',
  'constants.gameSlot1_NEWSA': 'Nuevo SA',
  'constants.gameFish5_NEWSA': 'Nuevo SA',
  // 4.02
  'admin.withdraw.currentChannelDisable': 'El canal actual está deshabilitado, use otro canal',
  'withdraw.loadConfigInfoFail': 'Error al cargar la información de configuración del proxy',
  'withdraw.loadConfigInfoError': 'Error al cargar la información de configuración de pago',
  'withdraw.label.withdrawChannel': 'Canal de pago',
  'withdraw.label.withdrawChannel1': 'Seleccione el canal de pago',
  'withdraw.label.Code': 'Código de terceros',
  'withdraw.channel.submit.title.prompt': 'Enviar canal de pago',
  'withdraw.channel.submit.content.prompt': 'Después de agregar el canal de pago, complete los parámetros del canal de pago, de lo contrario habrá un error durante el pago!',
  'sys.bonus.editDisplaySort': 'Sala de eventos de ordenación',
  'sys.editSuccess': '¡Ordenación modificada exitosamente!',
  'sys.editFail': 'error al editar',
  'sys.editError': 'corregir errores',
  'sys.approveLock': 'Bloqueo de aprobación',
  'sys.confirmConsent3': '¿Aceptar para iniciar revisión?',
  'sys.confirmConsent4': 'Ya sea para bloquear el retiro para revisión',
  'sys.confirmConsent5': 'Indicación de bloqueo de control de riesgo',
  'sys.confirmConsent6': 'Este registro de control de riesgo está siendo revisado por (userAccount) y bloqueado',
  'sys.confirmConsent7': 'El registro de control de riesgo {userAccount} ha sido revisado y desbloqueado',
  'sys.confirmConsent8': 'El registro de control de riesgo es desbloqueado forzadamente por el administrador {userAccount}, y ha sido desbloqueado',
  'risk.approveLock': 'Revisión bloqueada',
  'risk.approveUnLock': 'Revisión desbloqueada',
  'pay.title.adminUnlock': 'Desbloqueo del administrador',
  'sys.autofresh': 'Actualización automática',
  'sys.autofresh.none': 'No actualizar',
  'sys.autofresh.15s': 'Actualizar 15 segundos',
  'sys.autofresh.30s': 'Actualizar 30 segundos',
  'sys.autofresh.60s': 'Actualizar 60 segundos',
  'pay.title.withdrawalStatus10': 'Aprobación bloqueada',
  'pay.title.withdrawalStatus11': 'Aprobación desbloqueada',
  'constants.riskLevelType_-5': 'Depósito restringido',
  'user.button.kickOffLine': 'Patear fuera de línea',
  'user.button.whetherOffline': 'Ya sea para desconectarse',
  'menu.operationalStatistics': 'Estadísticas operacionales',
  'menu.killAnalysis': 'Análisis de recuento de bajas',
  'menu.discountAnalysis': 'Análisis de descuento de actividades',
  'member.title.regCount': 'Registrado',
  'member.title.firstDepositTotal': 'Primer depósito',
  'member.title.firstDepositRate': 'Tasa de primer depósito',
  'member.title.firstDepositCount': 'Monto total del primer depósito del día',
  'member.title.secondDepositCount': '2 depósitos en el día',
  'member.title.thirdDepositCount': '3 depósitos en el día',
  'member.title.fourthDepositCount': '4 depósitos en el día',
  'member.title.fifthDepositCount': '5 depósitos en el día',
  'member.title.depositCount': 'Número total de depósitos',
  'member.title.depositTotal1': 'Monto total de depósito',
  'member.title.withdrawalCount': 'Retiros totales',
  'member.title.withdrawalTotal': 'Monto total de retiro',
  'member.title.depositWithdrawalDiff': 'Diferencia de depósito',
  'member.title.tripartitePlatformProfit': 'Todas las plataformas de terceros son rentables',
  'member.title.bonusName': 'Nombre de promoción',
  'member.title.attendCount': 'El número de participantes',
  'member.title.depositTotal': 'Depósito total del miembro participante',
  'member.title.withdrawTotal': 'Retiro total del miembro participante',
  'member.title.profitAndLoss': 'Ganancia y pérdida de la actividad',
  'member.title.codeBonusAmount': 'Recompensa de actividad',
  'member.title.codeBonusStrSet': 'Configuración de contraseña',
  'member.title.applicationConditions': 'Condiciones de aplicación',
  'member.title.luckyDrawOpportunity': 'Cómo obtener la oportunidad de sorteo',
  'member.title.raffleLife': 'Vida de la rifa',
  'member.title.participationRestriction': 'Restricción de participación',
  'member.extra.attendCountPage': 'Número de participantes en esta página',
  'member.extra.depositTotalPage': 'Depósitos totales en esta página (yuan)',
  'member.extra.depositTotalPageVN': 'Depósitos totales en esta página (VND)',
  'member.extra.bonusTotalPage': 'Ofertas totales en esta página (yuan)',
  'member.extra.bonusTotalPageVN': 'Ofertas totales en esta página (VND)',
  'member.extra.withdrawTotalPage': 'Retiros totales en esta página (yuan)',
  'member.extra.withdrawTotalPageVN': 'Retiros totales en esta página (VND)',
  'member.extra.profitAndLossPage': 'Ganancia y pérdida total en esta página (yuan)',
  'member.extra.profitAndLossPageVN': 'Ganancia y pérdida total en esta página (VND)',
  'member.extra.attendCountTotal': 'Número total de participantes',
  'member.extra.depositTotalTotal': 'Depósito total (yuan)',
  'member.extra.depositTotalTotalVN': 'Depósito total (VND)',
  'member.extra.bonusTotalTotal': 'Descuento total (yuan)',
  'member.extra.bonusTotalTotalVN': 'Descuento total (VND)',
  'member.extra.withdrawTotalTotal': 'Retiro total (yuan)',
  'member.extra.withdrawTotalTotalVN': 'Retiro total (VND)',
  'member.extra.profitAndLossTotal': 'Ganancia y pérdida total de la actividad (yuan)',
  'member.extra.profitAndLossTotalVN': 'Ganancia y pérdida total de la actividad (VND)',

  'member.title.platformName': 'Nombre de plataforma',
  'member.title.platformFlow': 'Flujo de plataforma',
  'member.title.platformWinAndLoss': 'Ganancia o pérdida de plataforma',
  'member.title.betCount': 'Número total de apuestas del día',
  'member.title.kill': 'Recuento de bajas',
  'menu.announcementList': 'Lista de anuncios',
  'sys.title.pubTime': 'hora de lanzamiento',
  'sys.title.title': 'Título del anuncio',
  'sys.title.content': 'Contenido del anuncio',
  'sys.title.pubAmdin': 'editor',
  'sys.title.isRead': '¿Has leído?',
  'sys.title.readTime': 'Tiempo transcurrido',
  'sys.title.datePlatform': 'Fecha / Plataforma',
  'user.title.operationalStatisticsExcel': 'Informe de estadísticas de datos operacionales.xls',
  'user.title.killAnalysisExcel': 'Informe de análisis de recuento de bajas.xls',
  'user.title.discountAnalysisExcel': 'Informe de análisis de actividades preferenciales.xls',
  'user.title.countTime': 'Hora de estadísticas',
  'constants.bonusType_23': 'Descuento de depósito VIP',
  'constants.gameSlot1_PT1': 'PT1 electrónico',
  'constants.payLevel1_0': 'Miembro de primer nivel',
  'constants.payLevel1_1': 'Todos los miembros',
  'constants.payLevel1_2': 'Miembro secundario',
  'constants.payLevel1_3': 'Miembros de tercer nivel',
  'constants.payLevel1_4': 'Miembros del nivel 4',
  'constants.payLevel1_5': 'Miembro de nivel 5',
  'constants.payLevel1_6': 'Miembro de nivel 6',
  'constants.payLevel1_7': 'Miembro de nivel 7',
  'constants.payLevel1_8': 'Miembro de nivel 8',
  'constants.payLevel1_9': 'Miembro de nivel 9',
  'constants.payLevel1_10': 'Miembro de nivel 10',
  'constants.gameLive2_WM': 'WM',
  'constants.gameLive2_WE': 'WE en vivo',
  'constants.gameLive2_EVO': 'EVO en vivo',
  'constants.gameLive2_AE': 'AE en vivo',
  'constants.gameLive2_XG': 'XG en vivo',
  // 'constants.gameLive2_Evolution': 'Persona en vivo de evolución',
  'pay.title.ipWhite': 'IP de lista blanca',
  'pay.title.operateDetail': 'Operador | tiempo de operación',
  'pay.add.newIpWhite': 'Agregar lista blanca',
  'pay.query.keyword': 'Nombre de canal o IP',
  'pay.label.ipWhite': 'Complete la IP de la lista blanca',
  'pay.setting.prompt': 'Consejos',
  'pay.setting.promptDetail': 'Primero establezca los parámetros',
  'pay.label.tokenKeyDetail': 'Información de cifrado',
  'user.title.authRealName': 'Autenticación de nombre real',
  'user.title.authEmail': 'Autenticación de buzón',
  'user.title.authPhone': 'Certificación de número de teléfono móvil',
  'user.title.registerAndLastLoginTime': 'Hora de registro | última hora de inicio de sesión',
  'sys.deposit': 'Recarga',
  'sys.needDeposit': 'necesario',
  'user.title.fundOverview': 'Descripción general de fondos',
  'sys.registerItem.msg1': 'Entrada de registro {typename}',
  'sys.validit.length': 'Longitud del campo',
  'sys.validit.requireSwith': 'Requerido o no',
  'constants.require.status_1': 'Requerido',
  'constants.require.status_0': 'No requerido',
  'menu.operation.frontContent.RegisterItem': 'Gestión del elemento de registro',
  'user.title.realWechat': 'WeChat real',
  'user.title.realQQ': 'QQ real',
  'user.title.showQQContact': 'Ver QQ',
  'user.title.showWechatContact': 'Ver WeChat',
  'user.title.changeQQContact': 'Modificar QQ',
  'user.title.changeWechatContact': 'Modificar WeChat',
  'user.title.oldWechat': 'WeChat antiguo',
  'user.title.newWechat': 'Nuevo WeChat',
  'user.title.oldQQ': 'QQ',
  'user.title.newQQ': 'Nuevo QQ',
  'user.title.pleaseEnterNewWechat': 'Ingrese una nueva cuenta de WeChat',
  'user.title.pleaseEnterNewQQ': 'Ingrese un nuevo número de QQ',
  'common.radio.requireTrue': 'Cambiar a requerido',
  'common.radio.requireFalse': 'Cambiar a no requerido',
  'sys.firstDepositTimeLimit': 'Límite de tiempo del primer depósito',
  'sys.selectFirstDepositTimeLimit': 'Seleccione el límite de tiempo del primer ahorro',
  'menu.newSetting': 'Nivel de membresía VIP',
  'agent.SubordinateTransfer': 'Transferir a subagente o miembro',
  'constants.agentSubordinate_0': 'Agente subordinado',
  'constants.agentSubordinate_1': 'Miembro junior',
  'agent.subordinateTransfer_0': 'Seleccione agente o miembro',
  'agent.subordinateTransfer_1': 'Seleccione personal',
  'agent.subordinateTransfer_2': 'Ingrese la cantidad de transferencia',
  'common.select.beginTime': 'Seleccione una hora de inicio',
  'common.select.endTime': 'Seleccione la hora de finalización',
  'common.title.questionnaire': 'Nombre del cuestionario',
  'common.title.questionnaireDesc': 'Descripción del cuestionario',
  'common.title.respondents': 'Encuestados',
  'common.title.questionnaireOperate': 'Operación de gestión de cuestionarios',
  'common.title.questionOperate': 'Operación temática',
  'menu.operation.questionnaire': 'investigación por cuestionario',
  'user.disableNotice1': '¿Está seguro de que desea deshabilitar este cuestionario?',
  'user.enableNotice1': '¿Está seguro de que desea habilitar este cuestionario?',
  'sys.addQuestionnaire': 'Agregar cuestionario',
  'sys.enterQuestionnaireTitle': 'Ingrese el nombre del cuestionario',
  'sys.enterQuestionnaireDesc': 'Ingrese la descripción del cuestionario',
  'sys.enterBeginDate': 'Seleccione una fecha de inicio',
  'sys.enterRespondents': 'Seleccione el objeto de la encuesta',
  'sys.enterEndDate': 'Seleccione la fecha de finalización',
  'common.title.questionDesc': 'Descripción del título',
  'common.title.questionType': 'Tipo de tema',
  'common.title.isMust': 'Requerido o no',

  'guessRecordData.roundNo': 'Número de ronda',
  'guessRecordData.orderNo': 'Número de pedido',
  'guessRecordData.createTime': 'Hora de apuesta',
  'guessRecordData.showId': 'Sesión de transmisión en vivo',
  'guessRecordData.roomNumber': 'Número de sala',
  'guessRecordData.groupName': 'Tipo de juego / Resultado del sorteo',
  'guessRecordData.nickname': 'Apostador',
  'guessRecordData.antes': 'Apuesta base',
  'guessRecordData.multiple': 'Multiplicador',
  'guessRecordData.status0': 'Apuesta realizada',
  'guessRecordData.status1': 'Cancelado',
  'guessRecordData.status2': 'Pagado',
  'guessRecordData.payAmount': 'Monto total',
  'guessRecordData.sendAwardAmount': 'Monto pagado',
  'guessRecordData.details': 'Detalles',

  'guessResultLogData.resultName': 'Nombre del resultado del sorteo',
  'guessResultLogData.resultData': 'Información de cierre y sorteo',
  'guessResultLogData.status0': 'Apuesta en progreso',
  'guessResultLogData.status1': 'Apuesta cerrada',
  'guessResultLogData.status2': 'Confirmado',
  'guessResultLogData.status3': 'Resultado anunciado',
  'guessResultLogData.status4': 'Cancelado',
  'guessResultLogData.status5': 'Modificación confirmada',
  'guessResultLogData.status6': 'Pendiente de anulación',
  'guessResultLogData.status7': 'Pendiente de modificación',
  'guessResultLogData.startTime': 'Hora de inicio',
  'guessResultLogData.sealTime': 'Hora de cierre',
  'guessResultLogData.confirmTime': 'Hora de confirmación',
  'guessResultLogData.reviewTime': 'Hora de revisión',
  'guessResultLogData.mark': 'Descripción',
  'guessResultLogData.showPic': 'Captura de pantalla de resultados',
  'guessResultLogData.sealPic': 'Captura de pantalla de cierre',
  'guessResultLogData.showClosePic': 'Video de cierre',
  'guessResultLogData.showDetails': 'Ver detalles',

  'guessRecordDetailsData.odds': 'Cuotas',


  'sys.enterQuestionDesc': 'Ingrese una descripción de título',
  'sys.enterQuestionType': 'Seleccione un tipo de tema',
  'sys.title.editBonus': 'Editar oferta',
  'sys.giftType': 'Tipo de regalo',
  'sys.rewardCashAmount': 'Recompensa en efectivo',
  'sys.enterRewardCashAmount': 'Ingrese el monto de la recompensa en efectivo',
  'sys.cashBetflow': 'Múltiple actual de recompensa en efectivo',
  'sys.enterCashBetflow': 'Ingrese el múltiple diario retirable del bono en efectivo',
  'sys.rewardPointAmount': 'Puntos de bonificación',
  'sys.enterRewardPointAmount': 'Ingrese puntos de bonificación',
  'sys.rewardSwingTimes': 'Veces de bonificación',
  'sys.enterRewardSwingTimes': 'Ingrese el número de veces de recompensas de agitación',
  'sys.rewardSpinTimes': 'Número de premios de rueda de la suerte',
  'sys.enterRewardSpinTimes': 'Ingrese el número de premios de rueda de la suerte',
  'sys.rewardConditionType': 'Tipo de condición de recompensa',
  'sys.enterRewardConditionType': 'Seleccione el tipo de condición de recompensa',
  'sys.title.result': 'Hallazgos',
  'sys.title.searchType': 'Tipo de búsqueda',
  'sys.title.searchType1': 'Número de pedido',
  'sys.title.searchType2': 'Cuenta de miembro',
  'sys.title.searchType3': 'Nombre del canal de pago',
  'sys.title.searchType4': 'Número de pedido de terceros',
  'menu.lottery': 'Gestión de lotería',
  'menu.queryLotteryMethodList': 'Gestión de jugabilidad',
  'menu.queryLotteryPropList': 'Gestión de atributos',
  'menu.queryLotteryRateList': 'Gestión de cuotas',
  'menu.popularPlatformGame': 'Configuración de plataforma de juegos popular',
  'menu.ipBlockList': 'Lista negra de IP de usuario',
  'menu.deviceBlockList': 'Lista negra de equipos de usuario',
  'menu.queryOfflinePayOrder': 'Revisión de pago sin conexión',
  'menu.queryOnlinePayOrder': 'Gestión de pagos en línea',
  'menu.config': 'Configuración de pagos',
  'menu.payGroup': 'Configuración de grupo de pago',
  'menu.payConfig': 'Configuración de canal de pago',
  'menu.withdrawPay': 'Configuración de canal de pago',
  'menu.payEarlyWarning': 'Configuración de alerta temprana del canal',
  'menu.payCallbackIpWhite': 'Configuración de lista blanca de devolución de llamada de pago',

  'menu.payChannel': 'Configuración de canal de pago',
  'menu.withdraw': 'Configuración de canal de pago',

  'menu.onlineUser': 'Usuarios en línea',
  'menu.reportManualTransfer': 'Estado de reconciliación de miembros',
  'menu.agentManualTransfer': 'Informe de reconciliación de agencia',
  'menu.userGameReport': 'Informe de juego del usuario',
  'menu.smsNameVerifyLog': 'Registro de generación de certificación',
  'menu.upgrade': 'Modo de actualización',
  'menu.upgradeSetting': 'Configuración de nivel',
  'menu.upgradeUser': 'Lista de jugadores',
  'menu.upgradeReport': 'Registro de emisión',
  'menu.programSetting': 'Configuración de esquema',
  'menu.buyRecord': 'Registro de compra',
  'menu.queryPushMessageList': 'Gestión de notificaciones push',
  'menu.signMember': 'Etiqueta de membresía',
  'menu.balanceRate': 'Yu Bao',
  'menu.articleMgmt': 'Gestión de artículos',
  'menu.articleTypeMgmt': 'Gestión de tipo de artículo',
  'menu.nav': 'Gestión de navegación',
  'menu.pageMgmt': 'Gestión de página',
  'menu.match': 'Gestión de eventos',
  'menu.RegisterItem': 'Gestión de elementos de registro',
  'menu.checkin': 'Registro de recompensa de entrada',
  'menu.integralExchange': 'Registro de canje de puntos',
  'menu.paymentTab': 'Informe de tasa de éxito de pago',
  'menu.bonusArticle': 'Gestión de artículos',
  'menu.bonusApplyRole': 'Configuración de exclusión mutua',
  'constants.transferType_16': 'El agente superior se transfiere manualmente',
  'sys.addLotteryLimit': 'Configuración del número máximo',
  'sys.cancelLottery': 'Descalificación',
  'sys.emptyLottery': 'Limpiar la elegibilidad de lotería',
  'sys.content2': '¿Desea cancelar la calificación de lotería de los miembros seleccionados?',
  'sys.enterCountLimit': 'Ingrese un número máximo de veces',
  'sys.countLimit': 'Número máximo de veces',
  'sys.countLimitLength': 'El número máximo de veces es 9999',
  'sys.noneLimit': 'Sin límite',
  'menu.userSysAdmin': 'Gestión de parámetros del sistema',
  'menu.questionnaire': 'Cuestionario',
  'sys.title.maintainBegin': 'Hora de inicio del mantenimiento',
  'sys.title.maintainEnd': 'Hora de fin del mantenimiento',
  'sys.button.maintainTickTock': 'Mantenimiento programado',
  'sys.button.add': 'Añadir',
  'sys.button.edit': 'Editar',
  'sys.button.button': 'Botón',
  'sys.button.addTitle': 'Añadir botón',
  'sys.button.editTitle': 'Editar botón',
  'sys.button.menu': 'Menú',
  'sys.button.selectMenu': 'Por favor seleccione Menú',
  'sys.button.buttonCode': 'Código de botón',
  'sys.button.enterButtonCode': 'Por favor ingrese Código de botón',
  'sys.button.buttonName': 'Nombre del botón',
  'sys.button.enterButtonName': 'Por favor ingrese Nombre del botón',
  'sys.button.menuName': 'Nombre del menú',
  'sys.button.deleteConfirm': '¿Está seguro de que desea eliminar este botón?',
  'sys.menu.add': 'Añadir',
  'sys.menu.edit': 'Editar',
  'sys.menu.menu': 'Menú',
  'sys.menu.addTitle': 'Añadir menú',
  'sys.menu.editTitle': 'Editar menú',
  'sys.menu.parentMenu': 'Nodo de menú principal',
  'sys.menu.selectParentMenu': 'Seleccione Nodo de menú principal',
  'sys.menu.menuLevel': 'Nivel de menú',
  'sys.menu.selectMenuLevel': 'Por favor seleccione Nivel de menú',
  'sys.menu.menuCode': 'Código de menú',
  'sys.menu.menuName': 'Nombre del menú',
  'sys.menu.isLeaf': 'Es nodo hoja',
  'sys.menu.yes': 'Sí',
  'sys.menu.no': 'No',
  'sys.menu.menuUrl': 'Dirección de URL de backend',
  'sys.menu.enterMenuUrl': 'Por favor ingrese Dirección de URL de backend',
  'sys.menu.menuOrder': 'Orden de menú',
  'sys.languageCurrency.languageConfig': 'Configuración multilingüe',
  'sys.languageCurrency.currencyConfig': 'Configuración multimoneda',
  'sys.language.add': 'Añadir',
  'sys.language.edit': 'Editar',
  'sys.language.icon': 'Icono',
  'sys.language.iconSpec': 'La especificación del icono es 130*130',
  'sys.language.language': 'Idioma',
  'sys.language.language.sign': 'Signo de idioma',
  'sys.language.enterLanguage': 'Por favor ingrese el idioma',
  'sys.language.enterLanguage.sign': 'Por favor ingrese el signo de idioma',
  'sys.language.cancel': 'Cancelar',
  'sys.language.confirm': 'Confirmar',
  'sys.language.initError': 'Por favor inicialice primero los parámetros de edición',
  'sys.language.operationSuccess': 'Operación exitosa',
  'sys.language.uploadSuccess': 'Carga exitosa',
  'sys.language.uploadFailed': 'Error en la carga',
  'sys.language.setDefaultConfirm': '¿Está seguro de que desea establecer el idioma seleccionado como idioma predeterminado?',
  'sys.language.enableConfirm': '¿Está seguro de que desea habilitar el idioma seleccionado?',
  'sys.language.disableConfirm': '¿Está seguro de que desea deshabilitar el idioma seleccionado?',
  'sys.language.currentDefault': 'Idioma predeterminado actual',
  'sys.language.setAsDefault': 'Establecer como predeterminado',
  'sys.language.addLanguage': 'Añadir idioma',
  'sys.currency.add': 'Añadir',
  'sys.currency.edit': 'Editar',
  'sys.currency.icon': 'Icono',
  'sys.currency.iconSpec': 'La especificación del icono es 130*130',
  'sys.currency.currencyName': 'Nombre de la moneda',
  'sys.currency.enterCurrencyName': 'Por favor ingrese el nombre de la moneda',
  'sys.currency.currencyAbbr': 'Abreviatura de moneda',
  'sys.currency.enterCurrencyAbbr': 'Por favor ingrese la abreviatura de moneda',
  'sys.currency.currencySign': 'Símbolo de moneda',
  'sys.currency.enterCurrencySign': 'Por favor ingrese el símbolo de moneda',
  'sys.currency.cancel': 'Cancelar',
  'sys.currency.confirm': 'Confirmar',
  'sys.currency.operationSuccess': 'Operación exitosa',
  'sys.currency.uploadSuccess': 'Carga exitosa',
  'sys.currency.uploadFailed': 'Error en la carga',
  'sys.currency.setDefaultConfirm': '¿Está seguro de que desea establecer la moneda seleccionada como moneda predeterminada?',
  'sys.currency.enableConfirm': '¿Está seguro de que desea habilitar la moneda seleccionada?',
  'sys.currency.disableConfirm': '¿Está seguro de que desea deshabilitar la moneda seleccionada?',
  'sys.currency.currentDefault': 'Moneda predeterminada actual',
  'sys.currency.setAsDefault': 'Establecer como predeterminado',
  'sys.currency.addCurrency': 'Añadir moneda',
  'sys.currency.noIcon': 'Sin icono',
  'sys.addMaintenanceInfoSuccess1': '¡Se agregó exitosamente la información de mantenimiento preestablecida!',
  'sys.addMaintenanceInfoFail1': 'Error al agregar información de mantenimiento preestablecida',
  'sys.addMaintenanceInfoError1': 'Error al agregar información de mantenimiento preestablecida',
  'sys.addMaintenanceInfoNotice': 'Aviso de información de mantenimiento preestablecida',
  'sys.addMaintenanceInfoNotice1': 'Está seguro de reemplazar la información preestablecida existente',
  'sys.addMaintenanceInfoNotice2': 'Está seguro de preestablecer mantenimiento para este período de tiempo',
  'member.remark.delete.all': 'eliminar todo',
  'user.title.getBack': 'recuperar',
  'sys.msgContentTooLong': 'El contenido excede los 1000 caracteres de longitud, verifique el contenido del texto y cópielo desde WordPad.',
  'constants.PAY_LEVEL1_VIP_MODEL_2_-1': 'Todo disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_0': 'Nivel 0 disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_1': 'Nivel 1 disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_2': 'Nivel 2 disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_3': 'Nivel 3 disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_4': 'Nivel 4 disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_5': 'Nivel 5 disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_6': 'Nivel 6 disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_7': 'Nivel 7 disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_8': 'Nivel 8 disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_9': 'Nivel 9 disponible',
  'constants.PAY_LEVEL1_VIP_MODEL_2_10': 'Nivel 10 disponible',
  'sys.offerCreateTime': 'Hora de creación de la oferta',
  'sys.betflowBonusGivePeriodType': 'Tipo de período de facturación',
  'sys.betflowBonusGivePeriodTime': 'Período de facturación',
  'sys.enterBetflowBonusGivePeriodType': 'Seleccione el tipo de período de liquidación',
  'sys.betflowBonusGivePeriodTypeDaily': 'Diario',
  'sys.betflowBonusGivePeriodTypeWeekly': 'Semanal',
  'sys.betflowBonusGivePeriodTypeMonthly': 'Mensual',
  'sys.enterBetflowBonusGivePeriodTime': 'Ingrese el período de liquidación',
  'menu.four': 'Lotería 4D',
  'menu.bet': 'Boleto 4D',
  'menu.drawOpen': 'Sorteo 4D abierto',
  'menu.fourConfig': 'Configuración de lotería 4D',
  'fourd.export.excel': 'Boleto de lotería 4D.xls',
  'fourd.merchant.profit': 'Ganancia del comerciante',
  'fourd.bet.countNumber': 'Total de apuestas impares',
  'fourd.bet.betCountNumber': 'Total de apuestas',
  'fourd.future.openPeriods': 'Hora esperada del sorteo',
  'fourd.title.enteringOpenNumber': 'Ingrese números de lotería, separe múltiples números con (,) coma',
  'fourd.title.firstPrize': 'Primer premio',
  'fourd.title.twoPrize': 'segundo premio',
  'fourd.title.therePrize': 'Tercer premio',
  'fourd.title.fourPrize': 'Finalista',
  'fourd.title.fivePrize': 'Consuelo general',
  'fourd.bet.countBetAmount': 'Cantidad total de apuesta',
  'fourd.titile.payAmount': 'Cantidad de premio',
  'fourd.title.lookDrawInfo': 'Ver información de lotería',
  'fourd.title.payBetCount': 'Número de apuestas ganadoras',
  'fourd.title.openType': 'Tipo de sorteo',
  'sys.title.weekType': 'semana',

  'menu.promote': 'Gestión de promociones',
  'menu.promoteSetting': 'Configuración de recompensa',
  'menu.promoteRewardReport': 'Informe de recompensa',
  'menu.promoteInvitationReport': 'Informe de invitación',
  'menu.mlmSetting': 'Configuración de Renrendai',
  'menu.mlmReport': 'Informe para todos',

  'mlm.title.betflowCheck': 'Se satisface el flujo de apuesta efectivo',
  'mlm.title.depositCheck': 'Definición del número válido de invitaciones: Se cumple el depósito',
  'mlm.title.settingEnable': 'Si habilitar logros de invitación',
  'mlm.title.desc1': 'Estadísticas desde la fecha de apertura (la fecha de apertura se muestra aquí)',
  'mlm.invite.id': 'número de serie',
  'mlm.invite.promoteName': 'Nombre del logro',
  'mlm.invite.promoteImgUrl': 'Imagen',
  'mlm.invite.inviteNumber': 'Número acumulado de invitaciones válidas',
  'mlm.invite.extraAmount': 'Monto de incentivo',
  'mlm.invite.betflowMultiple': 'múltiple de flujo',
  'mlm.invite.extraPoint': 'Puntos de recompensa',
  'mlm.invite.operation': 'Operación',
  'mlm.invite.settingAdd': 'Añadir logro de invitación',
  'mlm.invite.settingForm': 'Configuración de logro de invitación',
  'mlm.invite.field1': 'Nombre del logro',
  'mlm.invite.field2': 'Número total de invitaciones válidas',
  'mlm.invite.field3': 'Monto de recompensa',
  'mlm.invite.field4': 'múltiple de rollover',
  'mlm.invite.field5': 'Puntos de recompensa',
  'mlm.invite.field6': 'Si se restringe la misma IP y el mismo dispositivo',
  'mlm.invite.field7': 'Icono de tarea de PC',
  'mlm.invite.field8': 'Icono de tarea del lado H5',
  'mlm.invite.field9': 'Imagen',
  'mlm.invite.field10': 'Nombre de usuario del invitador',
  'mlm.invite.field11': 'Número de registros invitados',
  'mlm.invite.field12': 'Nombre de usuario invitado',
  'mlm.invite.field13': 'Monto de recompensa por invitación',
  'mlm.invite.field14': 'Estado de distribución',
  'mlm.invite.field15': 'Volumen efectivo acumulado',
  'mlm.invite.field16': 'Es un miembro válido',
  'mlm.invite.field17': 'Si es el mismo dispositivo IP',
  'mlm.invite.field18': 'Invitar usuarios válidos',
  'mlm.invite.field19': 'Tipo de bono',
  'mlm.invite.field20': 'Bono',
  'mlm.invite.field21': 'Puntos',
  'mlm.invite.field22': 'El logro de invitación ha sido emitido',
  'mlm.invite.field23': 'La rebaja de apuesta ha sido distribuida',
  'mlm.invite.field24': 'Los puntos para invitar estudiantes han sido emitidos',
  'mlm.invite.field25': 'Bolígrafo',
  'mlm.invite.field26': 'Descripción de invitación del escritorio frontal',

  'table.title.promote.level': 'Nivel',
  'table.title.promote.bonus': 'Monto del bono',
  'table.title.promote.multiple': 'Múltiple de secuencia',
  'table.title.promote.extra.status': '¿Hay alguna recompensa extra?',
  'table.title.promote.extra.nothing': 'Sin recompensa extra',
  'table.title.promote.extra.perecent': 'Porcentaje de recompensa',
  'table.title.promote.extra.level': 'Nivel de participación: {level} o superior',
  'table.title.promote.upgradeCnd': 'Condiciones de actualización y recompensas',
  'table.title.promote.extra.upgradeCount': 'Invitar {count} o más personas',
  'table.title.promote.extra.upgradeAmount': 'Recompensa {amount}',
  'table.title.promote.extra.upgradeMultiple': 'Necesita completar {multiple} veces la tubería',
  'table.title.promote.finishCnd': 'Condiciones de finalización',
  'table.title.promote.checkInCount': 'Número de registros: {count}',
  'table.title.promote.totalDeposit': 'Depósito acumulado: {amount}',
  'table.title.promote.betflowAmount': 'Apuesta válida: {amount}',
  'table.title.promote.balanceFee': 'Interés Yu Bao: {amount}',
  'table.title.promote.operate': 'Operación',
  'sys.smg167': '¿Está seguro de que desea eliminar la configuración de recompensa de promoción de nivel {level}? ',
  'btnText.addPromoteSetting': 'Añadir configuración',
  'input.placeholder.msg': 'Nivel de promoción',
  'btnText.editPromoteSetting': 'Editar configuración',
  'form.titalName.promote': 'Configuración de promoción',
  'form.lableName.promote.level': 'Nivel de promoción',
  'form.lableName.promote.level.prompt': 'Por favor ingrese el nivel de promoción',
  'form.lableName.promote.amount': 'Monto de recompensa',
  'form.lableName.promote.amount.prompt': 'Por favor ingrese el monto de recompensa',
  'form.lableName.promote.multiple': 'múltiples de promoción',
  'form.lableName.promote.multiple.prompt': 'Por favor ingrese el número de serie',
  'form.lableName.promote.extra': 'Bono extra',
  'form.lableName.promote.extraPercent': 'Porcentaje de recompensa extra',
  'form.lableName.promote.extraPercent.prompt': 'Por favor ingrese el porcentaje de recompensa extra',
  'form.lableName.promote.extraLevel': 'Nivel de participación en recompensa extra',
  'form.lableName.promote.extraLevel.prompt': 'Por favor seleccione el nivel de participación en recompensa extra',
  'form.lableName.promote.avoidRelegation': 'Evitar condición de degradación',
  'form.lableName.promote.upgradeCount': 'Condiciones de actualización',
  'form.lableName.promote.upgradeCount.prompt': 'Por favor ingrese las condiciones de actualización',
  'form.lableName.promote.upgradeAmount': 'Bono de actualización',
  'form.lableName.promote.upgradeAmount.prompt': 'Por favor ingrese la recompensa de actualización',
  'form.lableName.promote.upgradeMultiple': 'Múltiple de rollover de bono de actualización',
  'form.lableName.promote.upgradeMultiple.prompt': 'Por favor ingrese el múltiple de rotación de bono de actualización',
  'form.lableName.promote.checkIn': 'Número de registros',
  'form.lableName.promote.checkIn.prompt': 'Por favor elija si desea establecer condiciones de número de registros',
  'form.lableName.promote.checkInCount': 'Número de registros',
  'form.lableName.promote.checkInCount.prompt': 'Por favor rellene el número de registros',
  'form.lableName.promote.totalDeposit': 'Depósito acumulado',
  'form.lableName.promote.totalDeposit.prompt': 'Por favor elija si desea establecer condiciones de depósito acumulado',
  'form.lableName.promote.totalDepositAmount': 'Depósito acumulado',
  'form.lableName.promote.totalDepositAmount.prompt': 'Por favor rellene el monto de depósito acumulado',
  'form.lableName.promote.betflow': 'apuesta válida',
  'form.lableName.promote.betflow.prompt': 'Por favor elija si desea establecer una condición de monto de apuesta válida',
  'form.lableName.promote.betflowAmount': 'Apuesta válida',
  'form.lableName.promote.betflowAmount.prompt': 'Por favor rellene un monto de apuesta válida',
  'form.lableName.promote.balanceFee': 'Interés Yu Bao',
  'form.lableName.promote.balanceFee.prompt': 'Por favor elija si desea establecer condiciones de interés balanceFee',
  'form.lableName.promote.balanceFeeAmount': 'Monto de interés Yu Bao',
  'form.lableName.promote.balanceFeeAmount.prompt': 'Por favor rellene el monto de interés de Yu\'e Bao',
  'form.lableName.promote.extraLevel.1': 'Nivel VIP1 y superior',
  'form.lableName.promote.extraLevel.2': 'Nivel VIP2 y superior',
  'form.lableName.promote.extraLevel.3': 'Nivel VIP3 y superior',
  'form.lableName.promote.extraLevel.4': 'Nivel VIP4 y superior',
  'form.lableName.promote.extraLevel.5': 'Nivel VIP5 y superior',
  'form.lableName.promote.extraLevel.6': 'Nivel VIP6 y superior',
  'form.lableName.promote.extraLevel.7': 'Nivel VIP7 y superior',
  'form.lableName.promote.extraLevel.8': 'Nivel VIP8 y superior',
  'form.lableName.promote.extraLevel.9': 'Nivel VIP9 y superior',
  'form.lableName.promote.extraLevel.10': 'Nivel VIP10 y superior',
  'user.title.addBankCard': 'Añadir tarjeta bancaria',
  'user.title.addBankCardSuccess': 'Se agregó la tarjeta bancaria exitosamente',
  'user.title.addBankCardError': 'Error al agregar tarjeta bancaria',
  'user.title.addBankCardMendAuthMobilePhone': 'Añadir una tarjeta bancaria requiere vincular un número de teléfono móvil',
  'user.title.addBankCardMendAuthWithdrawPWD': 'Añadir una tarjeta bancaria requiere configurar una contraseña de retiro',
  'lable.addBankCard.name': 'nombre de la cuenta de tarjeta bancaria',
  'lable.addBankCard.name.msg': 'Por favor ingrese el nombre de la cuenta de tarjeta bancaria',
  'lable.addBankCard.bankName': 'Nombre del banco',
  'lable.addBankCard.bankName.msg': 'Por favor seleccione un nombre de banco',
  'lable.addBankCard.bankName.msg1': 'Por favor ingrese el nombre del banco',
  'lable.addBankCard.bankNumber': 'Número de cuenta de tarjeta bancaria',
  'lable.addBankCard.bankNumber.msg': 'Por favor ingrese el número de cuenta de tarjeta bancaria',
  'lable.addBankCard.subBank': 'Nombre del banco de apertura',
  'lable.addBankCard.subBank.msg': 'Por favor ingrese el nombre del banco que abrió la cuenta',
  'agent.title.subTotalShareProfit': 'Ganancia neta total de agentes subordinados: {shareProfit}',
  'agent.title.subTotalShareCom': 'Suma de comisión de agente subordinado: {shareCommission}',
  'agent.title.subTotalShareFee': 'Comisión de agente subordinado: {shareFee}',
  'agent.title.billAmount': 'Comisión de facturación',
  'agent.billType.selfAmount': 'autoingresos: {selfAmount}',
  'agent.billType.subAmount': 'Ingresos inferiores: {subAmount}',
  'agent.billType.billAmount': 'Ingresos de liquidación: {totalAmount}',
  'agent.title.superiorAccount': 'Agente superior',
  'agent.title.superiorAccount2': 'Cuenta de agente superior',
  'agent.title.level': 'Nivel',
  'agent.title.level.all': 'Todo',
  'agent.title.level.1': 'nivel uno',
  'agent.title.level.2': 'Nivel segundo',
  'agent.title.level.3': 'Nivel tres',
  'agent.monthlyTable.agentLevel': 'agente de nivel {level}',
  'agent.monthlyTable.superiorAccount': 'Agente superior: {account}',
  'agent.commissionReport.pageBetflow': 'Flujo de esta página',
  'agent.commissionReport.pageBonus': 'Oferta de esta página',
  'agent.commissionReport.pageDeposit': 'Depósito de esta página',
  'agent.commissionReport.pageWithdraw': 'Retiro de esta página',
  'agent.commissionReport.pageResult': 'Esta página gana o pierde',
  'agent.commissionReport.totalBetflow': 'Flujo de apuesta total',
  'agent.commissionReport.totalBonus': 'Bono total',
  'agent.commissionReport.totalDeposit': 'Depósito total',
  'agent.commissionReport.totalWithdraw': 'Retiro total',
  'agent.commissionReport.totalResult': 'Ganancia o pérdida total',
  'agent.monthlyReport.pageProfit': 'Ganancia y pérdida mensual de esta página',
  'agent.monthlyReport.pageBetflow': 'Apuesta de esta página',
  'agent.monthlyReport.pageBonus': 'Oferta de esta página',
  'agent.monthlyReport.pageTrans': 'tarifa de manejo de página',
  'agent.monthlyReport.pageFinalProfit': 'Ganancia neta de esta página',
  'agent.monthlyReport.pageShareCom': 'Rebaja de esta página',
  'agent.monthlyReport.pageBillAmount': 'Liquidación de esta página',
  'agent.monthlyReport.totalProfit': 'Ganancia y pérdida mensual total',
  'agent.monthlyReport.totalBetflow': 'Flujo de apuesta total',
  'agent.monthlyReport.totalBonus': 'Bono total',
  'agent.monthlyReport.totalTrans': 'Tarifa de transacción total',
  'agent.monthlyReport.totalFinalProfit': 'Ganancia neta total',
  'agent.monthlyReport.totalShareCom': 'Rebaja total',
  'agent.monthlyReport.totalBillAmount': 'Monto de facturación total',
  'agent.title.agentSubUserResult': 'Miembros ganan o pierden',

  'user.title.updateBirthday': 'Modificar cumpleaños',
  'user.title.oldBirthday': 'Cumpleaños antiguo',
  'user.title.newBirthday': 'Nuevo cumpleaños',
  'user.title.pleaseEnterNewBirthday': 'Por favor ingrese la información del nuevo cumpleaños',
  'member.title.markCount': 'Número de personas marcadas',
  'user.frmTitel.userModel': 'muestra del jugador',
  'user.frmTitel.userPeriod': 'Período',
  'user.frmTitel.daily': 'Diario',
  'user.frmTitel.weekly': 'Semanal',
  'user.frmTitel.monthly': 'Mensual',
  'user.frmTitel.with': 'de',
  'user.frmTitel.regisiter': 'Usuario registrado',
  'user.frmTitel.regisiterAndDeposit': 'Usuarios registrados y depositantes',
  'user.frmTitel.keepCnd': 'Comportamiento de retención: después',
  'user.frmTitel.inCnd': 'Interior',
  'user.frmTitel.beted': 'Apuesta en',
  'user.frmTitel.online': 'En línea',
  'user.frmTitel.countKeepNum': 'Contar como usuario retenido',
  'user.frmTitel.platform': 'Canal',
  'common.sendMail.writeEmail': 'Escribir correo electrónico',
  'common.sixLottery.deleteReply': 'Eliminar respuesta',
  'common.betResult.lost': 'perdido',
  'common.betResult.fair': 'Justo',
  'common.betResult.win': 'Ganar',
  'common.btn.reset': 'Restablecer',
  'common.btn.search': 'Buscar',
  'user.title.firstDeposit': 'Primer depósito',
  'user.title.realNameAuth': 'Autenticación de nombre real',
  'user.title.mobilePhoneAuth': 'Autenticación de número de teléfono móvil',
  'user.title.emailAuth': 'Autenticación de correo electrónico',
  'user.title.userVIPLevel': 'Nivel de membresía',
  'user.title.startTime': 'Hora de inicio',
  'user.title.endTime': 'Hora de fin',
  'agent.title.domainPublic': 'Tipo de nombre de dominio',
  'agent.title.domainPublicMsg': 'Por favor seleccione el tipo de nombre de dominio',
  'agent.title.domainPublic.public': 'Nombre de dominio público',
  'agent.title.domainPublic.private': 'Nombre de dominio exclusivo',
  'agent.title.preventBlock': 'Bloqueo anti-WeChat',
  'agent.title.agentAccountNotEmpty': 'La cuenta de agente correspondiente al nombre de dominio exclusivo no puede estar vacía',
  'user.title.loginIPAddress': 'Atribución de IP de inicio de sesión',
  'user.title.userRelationTime': 'Tiempo de asociación del usuario actual',
  'user.title.loginIP': 'IP de inicio de sesión',
  'bonus.newInviteBonus.msg1': "Cada depósito de invitado",
  'bonus.newInviteBonus.msg2': "Como invitador",
  'bonus.newInviteBonus.msg3': "Bono de promoción VIP del invitado",
  'bonus.newInviteBonus.msg4': "Veces el bono del invitador",
  'bonus.newInviteBonus.msg5': "Retiro de salario del invitador",
  'bonus.newInviteBonus.msg6': "Retiro de bono de promoción del invitador",
  'bonus.newInviteBonus.msg7': "Yuan y superior",
  'bonus.newInviteBonus.msg8': "Veces del agua",
  'bonus.newInviteBonus.msg9': "Condiciones de agua",
  'promote.reward.title.regDate': 'Tiempo de registro de invitación',
  'promote.reward.title.finishDate': 'Tiempo completado de invitación',
  'promote.reward.title.keyword': 'Palabra clave',
  'promote.reward.title.keyword.msg': 'invitar/cuenta de invitación',
  'promote.reward.table.promoteAccount': 'Persona invitante',
  'promote.reward.table.targetAccount': 'Cuenta de invitación',
  'promote.reward.table.targetRegDate': 'Tiempo de registro de invitación',
  'promote.reward.table.amount': 'Monto de recompensa',
  'promote.reward.table.status': 'Estado',
  'promote.reward.table.finishDate': 'Hora de finalización',
  'promote.reward.table.moneyDate': 'Hora de recepción',
  'promote.reward.table.pageUnfinishedAmount': 'Monto no finalizado en esta página',
  'promote.reward.table.pageFinishedAmount': 'Monto completado en esta página',
  'promote.reward.table.totalUnfinishedAmount': 'Monto total sin finalizar',
  'promote.reward.table.totalFinishedAmount': 'Monto total completado',
  'promote.invitation.title.queryDate': 'Fecha de consulta',
  'promote.invitation.table.countDate': 'Fecha de estadística',
  'promote.invitation.table.activeCount': 'Usuarios activos del día',
  'promote.invitation.table.participateCount': 'Usuarios que participan en la actividad',
  'promote.invitation.table.participateRate': 'Tasa de participación en la actividad',
  'promote.invitation.table.regCount': 'Número de nuevos registros fuera de línea',
  'promote.invitation.table.firstDeposit': 'Número de primer depósito fuera de línea',
  'promote.invitation.table.firstDepositRate': 'Tasa de primer depósito de nuevo registro',
  'promote.invitation.table.pageParticipateRate': 'Tasa de participación en la actividad en esta página',
  'promote.invitation.table.pageRegCount': 'Número de nuevos registros en esta página',
  'promote.invitation.table.pageFirstDepositCount': 'Número de primer depósito fuera de línea en esta página',
  'promote.invitation.table.pageFirstDepositRate': 'La tasa de primer depósito de nuevos registros en esta página',
  'promote.invitation.table.totalParticipateRate': 'Tasa total de participación en eventos',
  'promote.invitation.table.totalRegCount': 'Recuento total de nuevos registros fuera de línea',
  'promote.invitation.table.totalFirstDeopsitCount': 'Recuento total de FirstDeopsit',
  'promote.invitation.table.totalFirstDepositRate': 'Tasa total de primer depósito de nuevo registro',
  'promote.upgrade.title.queryDate': 'Hora de actualización',
  'promote.upgrade.title.keyword.msg': 'Cuenta de miembro',
  'promote.upgrade.table.userAccount': 'Cuenta de miembro',
  'promote.upgrade.table.amount': 'Monto de recompensa',
  'promote.upgrade.table.betflow': 'progreso de flujo',
  'promote.upgrade.table.createTime': 'Hora de recepción',
  'promote.upgrade.table.pageAmount': 'Monto de recompensa en esta página',
  'promote.upgrade.table.totalAmount': 'Monto total de recompensa',
  'menu.promoteUpgradeReport': 'Informe de recompensa de actualización',
  'menu.historySearch': 'Búsqueda de historial',
  'menu.backupSetting': 'configuración de copia de seguridad de datos históricos',
  'menu.queryHistoryBonus': 'Historial de colección de descuentos',
  'menu.queryHistoryPayOrder': 'Historial de recarga',
  'menu.queryHistoryBalanceLog': 'Registro de historial de cambio de cuenta',
  'historySearch.tranLog.frm.userName': 'Cuenta de miembro',
  'historySearch.tranLog.frm.userName.msg': 'Por favor ingrese una cuenta de miembro',
  'historySearch.tranLog.frm.tranDate': 'Hora comercial',
  'historySearch.tranLog.frm.type': 'Tipo de transacción',
  'historySearch.setting.table.name': 'Nombre del elemento de copia de seguridad',
  'historySearch.setting.table.day': 'Días de copia de seguridad',
  'historySearch.setting.table.status': 'Estado',
  'historySearch.setting.table.remark': 'Descripción del elemento de copia de seguridad',
  'bonus.checkinIntegral.msg1': 'Configuración de recompensa de nivel VIP',
  'bonus.checkinIntegral.msg2': 'Nivel VIP para',

  'menu.queryLoginMember': 'Estadísticas del lado del cliente',

  'member.queryLoginMember.registeredUserTotal': 'Personas registradas totales',
  'member.queryLoginMember.taodyUp': 'Hoy nuevo',
  'member.queryLoginMember.logedUserToday': 'Número total de registros hoy',
  'member.queryLoginMember.daysUp': 'Días desde',
  'member.queryLoginMember.logedTimeToday': 'Inicia sesión hoy',
  'member.queryLoginMember.logedSuccRateToday': 'Tasa de éxito de inicio de sesión hoy',
  'member.queryLoginMember.thePie': 'El gráfico circular',
  'member.queryLoginMember.columnar': 'Un histograma',
  'member.queryLoginMember.logedTerminalStatistics': 'Descripción general del puerto de inicio de sesión',
  'sys.welcomeLogin.msg': 'Bienvenido a iniciar sesión en el fondo de gestión inteligente de la tecnología GameStone',
  'bonus.title.createTime': 'Fecha de oferta',
  'bonus.log.remark': 'Información de observación',
  'promote.reward.table.operateDetail': 'Operador/hora de operación',
  'promote.reward.table.operate': 'Operación',
  'promote.reward.table.showDetail': 'Ver progreso',
  'promote.log.showDetail.account': 'Progreso de finalización de {account}',
  'promote.log.showDetail.checkIn': 'Registro: {finish}/{target}',
  'promote.log.showDetail.deposit': 'Depósito acumulado: {finish}/{target}',
  'promote.log.showDetail.betflow': 'Apuesta acumulada: {finish}/{target}',
  'promote.log.showDetail.balanceFee': 'Interés Yu Bao: {finish}/{target}',
  'promote.log.showRefuseReason': 'Motivo del rechazo',
  'promote.reward.table.changeRefuse': 'Establecer como fallido',
  'promote.reward.table.changeNormal': 'Establecer como normal',
  'promote.log.changeRewardStatus': 'Modificar estado de recompensa',
  'promote.log.confirmChangeRewardStatus': '¿Está seguro de que desea modificar el estado de recompensa de {target} miembros? ',
  'promote.reward.table.status.refuse': 'Rechazar',
  'constants.bonusType_25': 'Descuento de ganancia y pérdida',
  'constants.newBonusType_25': 'Descuento de ganancia y pérdida',
  'constants.bonusMainType_25': 'Descuento de ganancia y pérdida',
  'constants.newBonusMainType_25': 'Descuento de ganancia y pérdida',
  'sys.profitType': 'Tipo de ganancia y pérdida',
  'sys.profitType.win': 'ganar',
  'sys.profitType.lost': 'Pérdida',
  'sys.profitType.all': 'todo',
  'bonus.winLost.cnd.title': 'Establecer condiciones preferenciales',
  'bonus.winLost.cnd.add': 'Añadir condición',
  'bonus.winLost.cnd.profitAmount': 'Ganancia/Pérdida (valor absoluto) alcanzada',
  'bonus.winLost.cnd.profitAmount.msg': 'Por favor ingrese el valor absoluto de ganancia y pérdida',
  'bonus.winLost.cnd.giftAmount': 'Monto de bono',
  'bonus.winLost.cnd.giftAmount.msg': 'Por favor ingrese el monto del bono',
  'bonus.winLost.frm.levelLimit': 'Nivel de participación',
  'bonus.winLost.frm.levelLimit.msg': 'Por favor seleccione el nivel de participación',
  'sys.includeAndMoreThan': 'y superior',
  'user.title.minBalance': 'Por favor ingrese el saldo mínimo',
  'user.title.maxBalance': 'Por favor ingrese el saldo máximo',
  'user.title.totalMainBalance': 'Saldo de cuenta principal total',
  'common.bonus.winLostBonus': 'Descuento de ganancia y pérdida de {type}, {date}',
  'sys.winLost.giveType.independent': 'Distribución independiente de cada plataforma de juego',
  'sys.winLost.giveType.unify': 'Participar en la distribución unificada de la plataforma de juego',
  'sys.winLost.giveType.msg': 'Por favor seleccione el método de distribución',
  'sys.winLost.giveType': 'Método de distribución',
  'constants.riskLevelType_-8': 'Limitado a recibir salario en modo de actualización',
  'front.bonus.upgradeReward.riskMsg.title': 'Restricción de control de riesgo',
  'front.bonus.upgradeReward.riskMsg.upgradeAmount': 'El control de riesgo limita la distribución de recompensas de actualización en modo de actualización',
  'front.bonus.upgradeReward.riskMsg.weekRemark': 'El control de riesgo limita la distribución del salario semanal del modo de actualización',
  'front.bonus.upgradeReward.riskMsg.monthRemark': 'El control de riesgo limita la distribución del salario mensual del modo de actualización',
  'menu.leaderboard': 'Tabla de clasificación',
  'menu.gameleaderboard': 'Clasificación de plataforma de juego de terceros',
  'menu.proxyleaderboard': 'Clasificación de agente de canal',
  'menu.userleaderboard': 'Clasificación de miembros',
  'console.leaderboard': 'Rango',
  'console.firstAmountCount': 'Primer depósito',
  'console.activeUserCount': 'Número activo',
  'console.userName': 'Nombre del miembro',
  'console.depositAmount': 'Depósito (yuan)',
  'console.depositAmountVN': 'Depósito (VND)',
  'console.withdrawAmount': 'Retiro (yuan)',
  'console.withdrawAmountVN': 'Retiro (VND)',
  'console.betflow': 'Apuesta (yuan)',
  'console.betflowVN': 'Apuesta (VND)',
  'console.betflow2': 'Apuesta',
  'console.resultAmount': 'Ganar o perder (yuan)',
  'console.resultAmountVN': 'Ganar o perder (VND)',

  'console.totalBetflow': 'Apuesta válida de la plataforma',
  'smsAllocation.mobilePhone.status': 'Estado del número',
  'smsAllocation.mobilePhone.status_1': 'Número vacío',
  'smsAllocation.mobilePhone.status_2': 'Fuera de servicio',
  'smsAllocation.mobilePhone.status_0': 'Normal',
  'smsAllocation.mobilePhone.sendStatus': 'Estado de envío',
  'smsAllocation.mobilePhone.sendStatus.select': 'Seleccione el estado de envío',
  'smsAllocation.mobilePhone.sendStatus.done': 'Enviado',
  'smsAllocation.mobilePhone.sendStatus.not': 'no enviado',
  'smsAllocation.mobilePhone.importInfo': 'Información de observación',
  'smsAllocation.mobilePhone.sendPhoneText': 'Enviar SMS',
  'smsAllocation.mobilePhone.searchKeyword': 'Número de teléfono móvil/nombre de usuario/información de observación',
  'phoneAllocation.importData': 'Importar',
  'phoneAllocation.selectSend': 'Envío selectivo',
  'phoneAllocation.allSend': 'Enviar todo',
  "user.title.updPwdTime": "Cambiar fecha de contraseña",
  "common.queryFrm.dayCnt": "No he cambiado la contraseña en los últimos días",
  "sys.riskUpdPwd": "Etiqueta de cambio de contraseña",
  "sys.riskUpdPwd.need": "SÍ",
  "sys.riskUpdPwd.notneed": "NO",
  'user.pay.type': 'Método de pago',
  'user.title.payTypeList': 'Método de pago exclusivo',
  'user.title.confirmDelete': 'Confirmar eliminación',
  'user.title.deletePayTypeMsg': '¿Está seguro de que desea eliminar este método de pago? ',
  'common.title.payChannel': 'Método de pago',
  'user.title.payType': 'Canal de pago',
  'user.title.payName': 'Nombre de pago',
  'user.title.addUserPayType': 'Añadir método de pago',
  'lable.addUserPayType.payType': 'Método de pago',
  'lable.addUserPayType.payType.msg': 'Por favor elija un método de pago',
  'user.title.addPayTypeSuccess': 'Se agregó el método de pago exitosamente',
  'sys.version.announcement.add': 'Añadir anuncio',
  'sys.version.announcement.title': 'Título',
  'sys.version.announcement.title.msg': 'Por favor ingrese un título',
  'sys.version.announcement.content': 'Contenido',
  'sys.version.announcement.content.msg': 'Por favor ingrese contenido',
  'sys.version.announcement.status': '¿Está en línea?',
  'sys.version.announcement.status_0': 'Próximamente',
  'sys.version.announcement.status_1': 'En línea',
  'sys.version.announcement.changeStatus': 'Lanzar en línea',
  'sys.version.confirmPublic': '¿Está confirmando el lanzamiento en línea? ',
  'sys.withdraw.pickType.label': 'Período de validez de recepción',
  'sys.withdraw.pickType.rule': 'Por favor seleccione el período de validez',
  'sys.withdraw.pickType.radio.value1': 'efectivo a largo plazo',
  'sys.withdraw.pickType.radio.value2': 'El registro de miembros es válido dentro de algunos días',
  'sys.withdraw.pickExpireDays.rule': 'Por favor ingrese días válidos',
  'sys.withdraw.pickExpireDays.day': 'días',
  'sys.withdraw.completeWithdrawDays.valid': 'Por favor rellene el tiempo para completar el primer retiro',
  'sys.withdraw.pickExpireDays.valid': 'Por favor rellene la fecha de vigencia de la recopilación',
  'sys.withdraw.rule': 'Por favor seleccione el orden de retiro',
  'sys.withdraw.withdrawType.label': 'Orden de retiro',
  "sys.withdraw.withdrawType.radio.value1": 'primera mención',
  'sys.withdraw.completeWithdrawType.label': 'Tiempo de finalización del primer retiro',
  'sys.completeWithdrawType.rule': 'Por favor seleccione la hora para completar el primer retiro',
  'sys.completeWithdrawType.prefix': 'Regístrate',
  'sys.giftAmount.label': 'monto del bono',
  'sys.giftAmount.rule': 'Por favor ingrese una cantidad de crédito',
  'sys.maxWithdrawAmount.label': 'Cantidad máxima de retiro',
  'sys.maxWithdrawAmount.rule': 'Por favor ingrese la cantidad máxima de retiro',
  'sys.deposit.applyType.label': 'tipo de envío',
  'sys.deposit.applyType.rule': 'Por favor seleccione un tipo de entrega',
  'sys.deposit.applyType.radio.value1': 'entrega automática',
  'sys.deposit.applyType.radio.value2': 'Recoger manualmente',
  'sys.deposit.pickType.label': 'Período de validez de recepción',
  'sys.deposit.pickType.rule': 'Por favor seleccione el período de validez',
  'sys.deposit.pickType.radio.value1': 'efectivo a largo plazo',
  'sys.deposit.pickType.radio.value2': 'El registro de miembros es válido dentro de algunos días',
  'sys.deposit.pickExpireDays.rule': 'Por favor ingrese días válidos',
  'sys.deposit.pickExpireDays.day': 'días',
  'sys.withdraw.applyType.label': 'tipo de envío',
  'sys.withdraw.applyType.rule': 'Por favor seleccione un tipo de entrega',
  'sys.withdraw.applyType.radio.value1': 'entrega automática',
  'sys.withdraw.applyType.radio.value2': 'Recoger manualmente',
  'front.bonus.firstWithdrawBonus': 'Bono de primer retiro para principiantes',
  'front.bonus.firstRegisterBonus': 'Bono de registro para principiantes',
  'front.bonus.firstDepositBonus': 'Bono de primer depósito para principiantes',
  'front.bonus.signInNewBonus': 'Bono de entrada de sesión para principiantes',
  'front.bonus.lostNewBonus': 'Bono de resurrección para principiantes',

  'report.radio.today.data': 'Datos en tiempo real',
  'report.radio.history.data': 'Datos históricos',

  'constants.ropeType_1': 'Cuerda roja',
  'constants.ropeType_2': 'Cuerda verde',
  'constants.ropeType_3': 'Cuerda amarilla',
  'constants.ropeType_4': 'Cuerda blanca',
  'constants.ropeType_5': 'Cuerda negra',
  'constants.ropeType_6': 'Cuerda colorida',
  'sys.ropeType.pleaseEnterAccumulatedBet': 'Por favor ingrese apuesta acumulada',
  'sys.ropeType.pleaseSelectSyntheticRope': 'Por favor seleccione el tipo deseado de cuerda sintética',
  'sys.ropeType.pleaseSelectQuantity': 'Por favor seleccione la cantidad requerida de cuerda sintética',
  'sys.ropeType.ropeType': 'tipo de cuerda',
  'sys.ropeType.pleaseSelectRopeType': 'Por favor seleccione un tipo de cuerda',
  'sys.ropeType.convertibleCash': 'convertible a efectivo',
  'sys.ropeType.pleaseEnterCashExchange': 'Por favor ingrese el efectivo que puede canjear',
  'sys.ropeType.accumulatedBetting': 'Apuesta acumulada',
  'sys.ropeType.syntheticRopeRequiredType': 'Tipo de cuerda sintética requerida',
  'sys.ropeType.amountNeededSynthesizeRope': 'Cantidad necesaria para sintetizar cuerda',
  'sys.ropeType.prizeCreateTime': 'Hora de generación de premios',
  'sys.ropeType.prizeUpdateTime': 'Hora de reclamación de premio',
  'sys.ropeType.convertIntoCash': 'Convertir a efectivo',
  'sys.ropeType.totalAmountReceived': 'Monto total recibido',
  'sys.ropeType.totalDegree': 'Grado total',
  'pay.label.payeeName': 'Nombre del beneficiario',
  'pay.label.payeeName1': 'Por favor ingrese el nombre del beneficiario',
  'pay.label.payeeName2': 'Ingrese hasta 25 caracteres',
  'pay.label.payeeNumber': 'Número de cuenta del beneficiario',
  'pay.label.payeeNumber1': 'Por favor ingrese el número de cuenta del beneficiario',

  'sys.title.userAccount.registrationTime': 'Hora de registro de miembro',
  'user.title.totalResult': 'Siempre ganar o perder',
  'bet.label.totalResult': 'Siempre ganar o perder (yuan)',
  'bet.label.totalResultVN': 'Siempre ganar o perder (VND)',
  'bet.label.pageResult': 'Ganar o perder en esta página (yuan)',
  'bet.label.pageResultVN': 'Ganar o perder en esta página (VND)',

  'onlineuser.export.excel': 'informe de usuario en línea.xlsx',
  'menu.onlineUserHistory': 'Usuarios en línea (cada 10 minutos)',
  'onlineUserHistory.title.countHourDesc': 'por hora\tdiez minutos',
  'onlineUserHistory.title.userCount10': '00:00～10:00',
  'onlineUserHistory.title.userCount20': '10:00～20:00',
  'onlineUserHistory.title.userCount30': '20:00～30:00',
  'onlineUserHistory.title.userCount40': '30:00～40:00',
  'onlineUserHistory.title.userCount50': '40:00～50:00',
  'onlineUserHistory.title.userCount60': '50:00～60:00',

  'menu.questList': 'Lista de Encuestas',
  'menu.questRecord': 'Registros de Encuestas',
  'sys.title.questionTitle': 'Nombre de la encuesta',
  'sys.title.userLevel': 'Nivel de miembro',
  'sys.title.userAwardTime': 'Fecha de cambio de puntos',
  'sys.title.userAwardPointBefore': 'Puntos antes del cambio',
  'sys.title.userAwardPointAfter': 'Puntos después del cambio',
  'menu.userAwardRecord': 'Registro de puntos del miembro',
  'sys.title.userAwardPoint': 'Cantidad de cambio de puntos',
  'sys.title.answerTime': 'Hora de envío',
  'sys.form.surveyLog.keyword': 'Cuenta del miembro',

  'agent.title.attributes.check': 'Seleccione atributos del agente',
  'agent.title.attributes': 'Atributos del agente',
  'agent.title.attributes.external': 'Agente externo',
  'agent.title.attributes.internal': 'Agente interno',
  'agent.title.account.manager.check': 'Proporcione el número de cuenta del gerente de cuenta',
  'agent.title.account.manager': 'Gerente de cuenta',

  'pay.title.memberPaymentStatus': 'Estado de pago confirmado por miembro',
  'pay.title.memberPaymentStatus0': 'Sin abrir',
  'pay.title.memberPaymentStatus1': 'Pendiente de confirmación',
  'pay.title.memberPaymentStatus2': 'No recibido',
  'pay.title.memberPaymentStatus3': 'Ya llegó',
  'user.title.bindTime': 'Hora de vinculación',
  'push.title.msgId': 'ID del mensaje',
  'menu.QueryMemberDevice': 'Información del dispositivo del miembro',
  'device.title.os': 'Dispositivo del miembro',
  'device.title.registrationId': 'ID de Aurora',
  'user.title.isTop': 'Es destacado',
  'user.title.top': 'Destacado',
  'user.title.topCancel': 'Sin destacar',

  'sys.vip.dayLimitWithdraw': 'Limitar cantidad de retiros en el día',
  'sys.vip.dayLimitWithdrawAmount': 'Limitar monto de retiro en el día',

  'sys.msg153': 'Si se cumplen las condiciones, los miembros pueden reclamar manualmente las recompensas en la página del evento, y vencerán después de la fecha de expiración.',
  'sys.msg154': 'Tipos de depósito estadístico',
  'sys.msg155': 'Depósito único',
  'sys.msg156': 'Depósitos acumulados',
  'bonus.titie.publicRewardSettings': 'Configuración de recompensas',
  'sys.withdrawalChannel': 'Canales de retiro',
  'sys.msg157': 'El monto máximo de retiro debe ser mayor que el monto mínimo de retiro',
  'sys.msg158': 'Retiro mínimo (incluido)',
  'sys.msg159': 'Ingrese el monto de retiro mínimo',
  'sys.msg160': 'Retiro máximo (excluido)',
  'sys.msg161': 'Ingrese el monto de retiro máximo',
  'sys.msg162': 'Cantidad de retiro: {minAmount}~{maxAmount}',
  'sys.msg163': 'Retiro único',
  'sys.msg164': 'Retiros acumulados',
  'sys.selectWithdrawChannel': 'Seleccione un canal de retiro',
  'sys.limitReceiveCount': 'Limitar cantidad de veces que puede recibirlo',
  // im 国际化
  'menu.im': 'Gestión de IM',
  'menu.immgmt': 'Gestión de autoridad IM',
  'menu.imMgmt': 'Gestión de autoridad IM',
  'menu.queryMsg': 'Consulta de mensajes IM',
  'user.friendRoom': 'Ver sala',
  'user.friendAllRoom': 'Lista de salas',
  'user.friendInfo': 'Información del amigo',
  'user.title.messagelist': 'Lista de mensajes',
  'menu.querymsg': 'Consulta de mensajes IM',
  'im.user.binding': 'Usuario vinculado a IM',
  'im.user.title.binding': 'Usuario vinculado a IM',
  'im.user.title.role': 'Rol de IM',
  'im.user.title.loginName': 'Nombre de usuario de IM',
  'im.user.title.systemName': 'Nombre del sistema IM',
  'im.user.unbinding': 'Usuario desvinculado de IM',
  'im.sys.title.confirmUnbinding': 'Confirmar desvinculación del usuario',
  'im.sys.unbindingAccount': 'Cuenta a desvincular: {userName}',
  'im.sys.login': 'Inicio de sesión de IM',
  'im.sys.login.error': 'Sin cuenta de IM vinculada',
  'pay.withdraw.rejectionNotification': 'Notificación de rechazo de retiro',


  'sys.user.virtualCurrencyAddress': 'Dirección de moneda virtual',
  'sys.user.virtualCurrencyAddress2': 'Lista de direcciones de moneda virtual',
  'user.title.delVirtualCurrencyAddress': 'Eliminar dirección de moneda virtual',
  'user.title.askDelVirtualCurrencyAddress': '¿Confirma la eliminación de la dirección de moneda virtual?',
  'user.title.updateVirtualCurrencyAddress': 'Modificar información de dirección de moneda virtual',
  'user.title.synchronizeDeposit': 'Sincronizar datos de depósito',
  'user.title.synchronizeWithdrawal': 'Sincronizar datos de retiro',
  'user.title.dataInDepositReport': 'Los datos en [Reporte de depósito] son',
  'user.title.dataInWithdrawReport': 'Los datos en [Reporte de retiro] son',
  'user.title.dataInMemberDetails': 'Los datos en [Detalles del miembro] son',
  'user.title.sureSynchronizedDeposit': '¿Está seguro de que los datos del reporte de depósito se sincronizaron con los datos de detalles del miembro?',
  'user.title.sureSynchronizedWithdrawal': '¿Está seguro de que los datos del reporte de retiro se sincronizaron con los datos de detalles del miembro?',
  'user.title.noSynchronizationRequired': 'El monto es igual, no es necesario sincronizar',
  'pay.withdraw.msg9': '{0}Solicitar retiro',
  'pay.withdraw.msg10': 'YBF Solicitar retiro',
  'agent.title.completeInformation': 'Ingrese información completa',

  'common.use.log.count': 'Cantidad total de inicios de sesión en los últimos seis meses',

  'agent.title.setPixelParam': 'Establecer parámetros de píxel',
  'agent.title.pixelId': 'ID de píxel',
  'agent.title.pixelAccessToken': 'Token de acceso de píxel',
  'member.title.pixelPush': 'Envío de píxel',
  'member.title.selectPixelPush': 'Seleccione píxeles para enviar',
  'member.title.pixelPushThat': 'Envíe esa información del usuario al píxel',

  'common.export.limit.exception': 'Los datos exportados han superado la configuración del sistema de 10,000. ¡Agregue condiciones de filtro e intente de nuevo!',
  'pay.title.financialTime': 'Hora financiera',

  'agent.title.detail.activeUserNoDistinct': 'La misma referencia activa en múltiples días cuenta como una persona',
  'agent.title.detail.depositUserNoDistinct': 'La misma referencia depositando en múltiples días cuenta como una persona',

  'pay.title.orderDescription': 'Descripción del pedido',
  'finance.title.orderDescription1': 'Ingrese descripción del pedido',

  'admin.bonus.singleDayDeposit': 'Depósito único el mismo día',
  'admin.bonus.accumulatedDeposits': 'Depósitos acumulados en el día',
  'admin.pay.selectDepositType': 'Seleccione tipo de depósito',
  'admin.bonus.sevendayDepositDay': 'día',
  'admin.bonus.sevendayDepositGear': 'engranaje',
  'admin.bonus.sevendayDepositDayText': 'Día {day}',
  'admin.bonus.sevendayDepositGearText': 'Engranaje {gear}',

  'sys.allTransactionTypes': 'Todos los tipos de transacción',
  'admin.front.picture.domainName': 'Nombre de dominio correspondiente',

  'sys.push.msg': 'Mensaje de envío',
  'sys.push.immediate': 'Envío instantáneo',
  'sys.push.notify': 'Aviso de Umeng',
  'sys.push.type': 'Tipo de envío',
  'sys.confirm.enable': '¿Confirma para habilitarlo?',
  'sys.confirm.disable': '¿Confirma para cerrarlo?',
  'sys.push.phoneStatus': 'Estado de envío móvil',
  'sys.push.mailStatus': 'Estado de envío de correo',
  'sys.push.smsStatus': 'Estado de envío de SMS',
  'push.msg.config.type1': 'Recarga',
  'push.msg.config.type2': 'Retiro',
  'push.msg.config.type3': 'Ajuste manual',
  'push.msg.config.type4': 'Bonificación por actualización VIP',
  'push.msg.config.type5': 'Salario semanal',
  'push.msg.config.type6': 'Salario semanal',
  'push.msg.config.type7': 'Envío instantáneo',
  'push.msg.config.type700': 'Iniciar sesión',
  'push.msg.config.type701': 'Reiniciar sesión',
  'push.msg.config.timing': 'Envío programado',

  'agent.title.setAdjustParam': 'Establecer parámetros de ajuste',
  'agent.title.applicationID': 'ID de aplicación',
  'agent.title.registrationID': 'ID de registro',
  'agent.title.loginID': 'ID de inicio de sesión',
  'agent.title.firstSubmitRecharge': 'Enviar recarga por primera vez',
  'agent.title.firstAddBankCard': 'Agregar tarjeta bancaria por primera vez',
  'admin.bonus.dayBonusUpperLimit': 'Descuento máximo para el día',
  'admin.bonus.relatedBonus': 'Promociones relacionadas',
  'sys.selectPromotionsBonus': 'Seleccione las promociones a asociar',

  'agent.setAgentUsdtRate': 'Establecer tasa de retiro',
  'agent.fillFixedExchangeRate': 'Ingrese la tasa de cambio fija',
  'admin.bonus.client': 'Clientes autorizados para recibir',
  'admin.bonus.calculationRules': 'Reglas de cálculo',
  'admin.bonus.calculationRules1': 'Cálculo de ofertas (reglas antiguas)',
  'admin.bonus.calculationRules2': 'No cuenta descuentos (regla nueva)',
  'admin.bonus.calculationRulesInfo': '[Cálculo de descuentos]: Cantidad de apuesta realizada - Cantidad ganada de una apuesta = Cantidad de pérdida [No calcular descuentos]: Cantidad de pérdida - Total de descuentos recibidos = Cantidad de pérdida real',
  'menu.matrixRoomMgmt': 'Gestión inicial de salas',
  'user.title.addRoom': 'Crear una sala de chat',
  'user.button.addRoom': 'Crear una sala de chat',
  'user.button.room.select.func': 'Seleccione el tipo de sala',
  'user.title.room.name': 'Nombre de la sala de chat',
  'user.title.room.name.input': 'Ingrese el nombre de la sala de chat',
  'user.title.room.title': 'Notas de la sala de chat',
  'user.title.room.title.input': 'Ingrese observaciones de la sala de chat',
  'user.title.room.title.max': 'Excede la longitud del comentario de la sala de chat',
  'user.title.room.service': 'Servicio al cliente',
  'user.title.room.service.input': 'Seleccione el servicio al cliente',
  'user.title.room.func': 'Tipo de sala de chat',
  'user.title.room.order': 'Orden',
  'user.title.room.order.input': 'Ingrese la orden de la sala de chat',
  'user.title.updateRoom': 'Actualizar una sala de chat',
  'common.title.account.freeze': 'Congelar cuenta',
  'common.title.account.unfreeze': 'Descongelar cuenta',
  'common.title.status.running': 'Normal',
  'common.title.status.freeze': 'Congelado',
  'sys.account.freeze': 'Cuenta a congelar: {matrixAccount}',
  'sys.account.unfreeze': 'Cuenta a descongelar: {matrixAccount}',
  'user.button.room.message.list': 'Lista de mensajes',
  'menu.matrixRoomContentMgmt': 'Gestión de mensajes de sala de chat',
  'user.button.addRoomContent': 'Agregar mensaje',
  'common.radio.room.list': 'Lista de salas de chat',
  'user.title.room.content': 'Contenido del mensaje',
  'user.title.room.content.status': 'Estado del mensaje',
  'user.title.room.content.input': 'Ingrese el contenido del mensaje',
  'common.radio.room.list.input': 'Seleccione una lista de salas de chat',
  'menu.ImNotifiMsgMgmt': 'Consulta de mensajes de notificación de miembro',
  'user.title.room.id': 'ID de la sala de chat',
  'member.title.account.name': 'Cuenta del miembro',
  'member.title.nickname': 'Apodo del miembro',
  'common.title.room.deploy': 'Liberar',
  'common.title.room.withdraw': 'Retirar',
  'admin.title.addTelemarketingList': 'Agregar a lista de telemarketing',
  'admin.title.selectedMembers': 'Miembros seleccionados',
  'admin.title.addMethod': 'Método de adición',
  'admin.title.remove': 'Eliminar',
  'admin.title.memberActivateCount': 'Importar lista de miembros para activar usuarios',
  'user.title.activatedDepositorsCount': 'Cantidad de depositantes activados',
  'user.title.activatedBetCount': 'Cantidad de apostadores activados',
  'user.title.lastCallTime': 'Hora de última llamada',
  'user.title.depositTimeActivation': 'Tiempo de depósito al activar',
  'user.title.betTimeActivation': 'Tiempo de apuesta al activar',
  'user.title.dialStatus': 'Estado de marcado',
  'user.title.notConnected': 'No conectado',
  'user.title.connected': 'Conectado',
  'user.title.numberCalls': 'Número de llamadas',
  'user.title.callPerson': 'Persona que llama',
  'user.title.dialTime': 'Hora de marcado',
  'user.title.hangUpTime': 'Hora de cuelgue',
  'user.title.callDuration': 'Duración de la llamada',
  'agent.title.room.info': 'Información del grupo de IM',
  'pay.withdraw.payMayaName': 'Nombre de PayMaya',
  'pay.withdraw.payMayaAccount': 'Número de cuenta de PayMaya',
  'pay.withdraw.grabPayName': 'Nombre de GrabPay',
  'pay.withdraw.grabPayAccount': 'Número de cuenta de GrabPay',
  'user.title.payMayaPhone': 'Número de teléfono móvil de PayMaya',
  'user.title.payMayaRealName': 'Nombre real de PayMaya',
  'user.title.delPayMaya': 'Eliminar su cuenta de PayMaya',
  'user.title.askDelPayMaya': 'Confirme la eliminación de su cuenta de PayMaya',
  'user.title.confirmUnbindingAllPayMaya': 'Nota: Después de esta operación, todas las cuentas de PayMaya pertenecientes al usuario serán desvinculadas',
  'user.title.grabPayPhone': 'Número de teléfono móvil de GrabPay',
  'user.title.grabPayRealName': 'Nombre real de GrabPay',
  'user.title.delGrabPay': 'Eliminar su cuenta de GrabPay',
  'user.title.askDelGrabPay': 'Confirme la eliminación de su cuenta de GrabPay',
  'user.title.confirmUnbindingAllGrabPay': 'Nota: Después de esta operación, todas las cuentas de GrabPay pertenecientes al usuario serán desvinculadas',
  'user.title.enterPayMayaPhone': 'Ingrese el número de teléfono móvil de PayMaya',
  'user.title.enterGrabPayPhone': 'Ingrese su número de teléfono móvil de GrabPay',
  'user.title.enterPayMayaRealName': 'Ingrese el nombre real de PayMaya',
  'user.title.enterGrabPayRealName': 'Ingrese el nombre real de GrabPay',
  'user.title.email': 'Correo electrónico',
  'user.title.importAndExport': 'Cargar y exportar datos',
  'user.title.importAndExportType': 'Exportar datos',
  'user.title.pleaseEnterImportAndExportType': 'Por favor, verifique primero la exportación de datos',
  'pay.withdraw.weChatName': 'Nombre de WeChat',
  'pay.withdraw.weChatAccount': 'Número de cuenta de WeChat',
  'user.title.weChatRealName': 'Nombre real de WeChat',
  'user.title.delWeChat': 'Eliminar cuenta de WeChat',
  'user.title.askDelWeChat': 'Confirme la eliminación de la cuenta de WeChat',
  'user.title.confirmUnbindingAllWeChat': 'Nota: Después de esta operación, todas las cuentas de WeChat pertenecientes a este usuario serán desvinculadas',
  'user.title.enterWeChatAccount': 'Ingrese la cuenta de WeChat',
  'user.title.enterWeChatRealName': 'Ingrese el nombre real de WeChat',
  'user.title.modifyChannelInformation': 'Modificar información de cuenta de {channelName}',

  'menu.source': 'Fuente de píxel',
  'pixel.event': 'Evento de envío',
  'pixel.all.event': 'Todos los eventos',
  'pixel.rePush': 'Reenviarlo píxel',
  'pixel.rePush.select': 'Seleccione la fuente de píxel que desea enviar',
  'pixel.up.name': 'Modificar configuración',
  'pixel.statistics.name': 'Nombre/ID de píxel',
  'pixel.statistics.completeRegistration': 'Registro completado',
  'pixel.statistics.purchase': 'Compra',
  'pixel.statistics.initiateCheckout': 'Iniciar compra',
  'pixel.statistics.addPaymentInfo': 'Agregar información de pago',
  'pixel.xls': 'Reporte estadístico de píxel.xls',
  'pixel.push.xls': 'Reporte de envío de píxel.xls',
  'pixel.add': 'Agregar fuente de píxel',
  'pixel.up': 'Editar fuente de píxel',
  'pixel.select': 'Seleccione fuente de píxel',
  'pixel.select.agent': 'Seleccione agente',
  'pixel.source.name': 'Nombre de píxel',
  'pixel.source.info': 'ID/Clave de píxel',
  'pixel.id': 'ID de píxel',
  'pixel.detail': 'Detalles de envío de píxel',
  'pixel.push.note': 'Puede haber muchos miembros para enviar, espere pacientemente a que el sistema se complete',
  'pixel.push.detail.title': 'Detalles del evento',
  'pixel.push.detail.time': 'Hora y estado de envío',

  'pixel.block.name': 'Nombre de lote de envío',
  'pixel.block.userCount': 'Cantidad de usuarios',
  'pixel.block.shouldCount': 'Total esperado de eventos de envío',
  'pixel.block.practicalCount': 'Total real de eventos de envío',
  'pixel.block.regCount': 'Eventos de registro: Enviados / No enviados',
  'pixel.block.bakCount': 'Eventos de vinculación de primera tarjeta bancaria: Enviados / No enviados',
  'pixel.block.orderCount': 'Eventos de pedido: Enviados / No enviados',
  'pixel.block.depositCount': 'Eventos de compra: Enviados / No enviados',
  'pixel.block.time': 'Hora de envío',

  'user.title.OneKeyRecycle': 'Reciclaje de un clic',

  'sys.rewardGoldenEgg': 'Recompensa - Huevo de oro',
  'sys.rewardRedEnvelope': 'Recompensa - Sobre rojo',
  'sys.setPrizeDay': 'Por favor establezca el premio para el día {dayCount}',

  "sign.receive,type1": "Recompensa en efectivo",
  "sign.receive,type2": "Recompensa - Huevo de oro",
  "sign.receive,type3": "Recompensa - Sobre rojo",
  'device.install.src.title': 'Fuente de instalación',
  'device.id.title': 'ID del dispositivo',
  'device.serial.title': 'Dispositivo',
  'user.title.withdrawalsProhibited': 'Retiros prohibidos',
  'user.title.sign-inDays': 'Días de inicio de sesión',
  'pay.title.payerName': 'Nombre del pagador',
  'user.title.paymentCode': 'Código de pago',
  'user.title.uploadPaymentCode': 'Cargue el código de pago',

  'member.select.filterRepeat.account.title': 'Eliminar miembros duplicados',
  'member.select.filterRepeat.ip.title': 'Eliminar datos de IP duplicados',
  'constants.regSourceTypeJk4_0': 'Oficial',
  'user.title.pointCreateTime': 'Hora de emisión de puntos',
  'user.title.pointAmount': 'Cantidad de punto variable',
  'user.title.pointAmountAfter': 'Monto después del cambio',
  'user.title.pointAmountType': 'Tipo de punto',
  'bonus.pointType.1': 'Puntos de descuento al iniciar sesión',
  'bonus.pointType.2': 'Canje de puntos',
  'bonus.pointType.3': 'Puntos de bonificación de depósito en tiempo real',
  'bonus.pointType.4': 'Puntos de descuento de tareas',
  'bonus.pointType.5': 'Puntos de bonificación de depósito',
  'bonus.pointType.6': 'Ajustar puntos manualmente',
  'bonus.pointType.7': 'Desconocido',
  'bonus.pointType.8': 'Ajustar puntos manualmente',

  'analyze.quick3.deviceSource': 'Fuente de emisión',
  'analyze.quick3.lotNo': 'Número de emisión',
  'analyze.quick3.playName': 'Forma de juego | Número de apuesta',
  'analyze.quick3.status': 'Estado del boleto de apuesta',
  'analyze.quick3.status0': 'Pendiente de sorteo',
  'analyze.quick3.status1': 'Aún no sorteado',
  'analyze.quick3.status2': 'Lotería sorteada',
  'analyze.quick3.status3': 'Usuario cancela la orden',
  'analyze.quick3.status4': 'Cancelación de orden sistemática',
  'analyze.quick3.result': 'Ganancia y pérdida',
  'analyze.quick3.playId1': 'Suma',
  'analyze.quick3.playId2': 'Dos iguales',
  'analyze.quick3.playId3': 'Juntos',
  'analyze.quick3.deviceSource1': 'PC',
  'analyze.quick3.deviceSource2': 'H5',
  'analyze.quick3.deviceSource3': 'Android',
  'analyze.quick3.deviceSource4': 'IOS',
  'analyze.quick3.totalBets': 'Cantidad total de apuestas',
  'analyze.quick3.totalBetAmount': 'Monto total de apuesta',
  'analyze.quick3.unawardedAmount': 'Monto sin otorgar',
  'analyze.quick3.cancellationAmount': 'Monto de cancelación',
  'analyze.quick3.totalUsers': 'Total de usuarios',
  'menu.betManagement': 'Gestión de apuestas',
  'menu.gamePlayRanking': 'Ranking de juego',
  'menu.playOdds': 'Probabilidades del juego',
  'menu.gameConfiguration': 'Configuración del juego',
  'menu.winningNumbers': 'Números ganadores',
  'menu.quick3': 'Rápido Tres',
  'analyze.quick3.nowOdds': 'Probabilidades actuales',
  'analyze.quick3.reset': 'Restaurar última configuración',
  'finance.export.gamePlayRanking': 'Ranking de juegos Rápido Tres.xls',
  'analyze.quick3.gameType': 'Tipo de juego',
  'analyze.quick3.maximumAmountSingleBet': 'Monto máximo de apuesta única',
  'analyze.quick3.userMaximumBet': 'Apuesta máxima del usuario en período actual',
  'analyze.quick3.currentPeriodMaximumBet': 'Apuesta máxima del juego en período actual',
  'analyze.quick3.gameplayEnableDisable': 'Habilitar/Deshabilitar juego',
  'analyze.quick3.gameplayAbbreviation': 'Abreviatura del juego',
  'analyze.quick3.gameplay': 'Introducción del juego',
  'analyze.quick3.bettingExamples': 'Ejemplos de apuestas',
  'analyze.quick3.sampleCode': 'Código de ejemplo',
  'analyze.quick3.lotteryName': 'Nombre de la lotería',
  'analyze.quick3.deadlineIssue': 'Fecha límite de esta emisión',
  'analyze.quick3.fullyRandom': 'Totalmente aleatorio',
  'analyze.quick3.profitability': 'Rentabilidad',
  'analyze.quick3.betDetails': 'Detalles de la apuesta',
  'analyze.quick3.bettingNumbers': 'Números apostados',
  'analyze.quick3.numberBets': 'Cantidad de apuestas',
  'analyze.quick3.totalBetAmount2': 'Monto total de apuestas',
  'analyze.quick3.singleBetAmount': 'Monto de apuesta única',
  'analyze.quick3.prizes': 'Premios a ganar',

  'live.title.36': 'Recibir sobres rojos en la sala de transmisión en vivo',
  'live.title.42': 'Bonificación por completar misión de transmisión en vivo',
  'live.title.71': 'Rueda de la sala de transmisión en vivo, premio de lotería en efectivo',
  'live.title.80': 'Monto de canje de regalo para el ancla, ingreso total del ancla {changeMoney}',
  'live.title.107': 'Comprar una apuesta',
  'live.title.142': 'Enviar [{0}]*{1}',
  'live.title.168': 'Enviar sobres rojos en la sala de transmisión en vivo',
  'live.title.208': 'Liquidación de premio de competencia',
  'live.title.209': 'Reembolso de competencia',
  'live.title.210': 'Dios de los jugadores ha subido',
  'live.title.211': 'Dios de los jugadores ha bajado',

  'user.title.connectedState': 'Estado conectado',
  'user.title.totalCalls': 'Cantidad total de llamadas',

  'quick3.table.title': 'Número de sala/nombre de sala/apodo del anfitrión',
  'analyze.card.depositBetInfo': 'Contar el primer miembro y los miembros con comportamiento de apuesta válida en el día, luego sumarlos',

  'quick3.quick3Bets': 'Apuestas de Rápido 3',
  'quick3.orderCancellation': 'Cancelación y devolución de orden de Rápido 3',
  'quick3.quick3Payout': 'Pago de Rápido 3',

  'bonus.checkin.xls': 'Registro de bonificación de inicio de sesión.xls',
  'bonus.integral.xls': 'Registro de canje de puntos.xls',
  'job.progress.xls': 'Progreso de tareas del usuario.xls',
  'job.progress.acceptTime': 'Hora de aceptación de la tarea',
  'job.progress.completeTime': 'Hora de finalización de la tarea',
  'job.progress.receiveTime': 'Hora de recepción de la tarea',
  'job.progress.title': 'Título',
  'job.progress.userAccount': 'ID de usuario/nombre de usuario/apodo',
  'job.progress.status': 'Estado de la tarea',
  'job.progress.status0': 'Tarea recibida',
  'job.progress.status1': 'Tarea completada',
  'job.progress.status2': 'Colección de tareas no completada',
  'job.progress.status3': 'Bonificación ya recolectada',
  'job.progress.jobType': 'Tipo de tarea',
  'job.progress.jobType0': 'Tarea para principiantes',
  'job.progress.jobType1': 'Tarea diaria',

  'menu.MerberLoginLock': 'Lista de usuarios bloqueados',
  'user.title.loginLockTime': 'Hora de bloqueo de inicio de sesión',
  'user.title.notUnlocked': 'No desbloqueado',
  'user.title.unlocked': 'Desbloqueado',
  'user.title.lockedState': 'Estado de bloqueo',
  'user.title.loginPasswordChange': 'Cambio de contraseña de inicio de sesión',
  'user.title.loginPassword': 'Contraseña de inicio de sesión',
  'user.title.generatePasswordDirectly': 'Generar contraseña directamente',
  'user.title.re-enter': 'Ingrese nuevamente',
  'user.title.pleaseEnterAgain': 'Ingrese nuevamente',
  'user.title.confirmUnlock': '¿Confirma desbloquear?',
  'user.title.activatedBetStatus': 'Estado de apuesta activado',
  'user.title.activatedDepositStatus': 'Estado de depósito activado',
  'user.title.selectActivatedBetStatus': 'Seleccione estado de apuesta activado',
  'user.title.selectActivatedDepositStatus': 'Seleccione estado de depósito activado',

  'analyze.title.applicationScenario': 'Escenario de aplicación',
  'analyze.title.sendContent': 'Contenido a enviar',
  'analyze.title.causeOfFailure': 'Razón del fallo',
  'analyze.title.verificationCodeFilledIn': 'Código de verificación completado',
  'analyze.title.backfillStatus': 'Estado de relleno invertido',
  'analyze.title.registerToSend': 'Registrarse para enviar',
  'analyze.title.loginToSend': 'Iniciar sesión para enviar',
  'menu.smsDeliveryRate': 'Lista de tasa de entrega de SMS',

  'front.onebuy.amount.sub': 'Compra de un yuan',
  'front.onebuy.amount.change': 'Cambio de recompensa de un yuan',
  'front.onebuy.amount.return': 'Devolución de orden de un yuan',
  'front.onebuy.amount.rebuy': 'Recompra de producto de un yuan',
  'admin.onebuy.excelExport.odrder': 'Datos de pedido',
  'admin.onebuy.excelExport.commodity': 'Datos de producto',
  'admin.onebuy.excelExport.plan': 'Datos de plan',
  'admin.onebuy.excelExport.platformStatistic': 'Resumen de datos',
  'admin.onebuy.excelExport.platformDetailStatistic': 'Detalles de datos',

  'constants.transferType_18': 'Compra rápida de un yuan',
  'constants.transferType_19': 'Compra de producto de un yuan',
  'constants.transferType_20': 'Canje de un yuan de un yuan para bonificación de compra',
  'constants.transferType_21': 'Devolución de compra rápida de un yuan',
  'constants.onebuyType_1': 'Cupón de un yuan',
  'user.title.onebuyBalance': 'Saldo de un yuan',
  'user.title.onebuyBalanceTooltip': 'Saldo de un yuan = Fondo retirable + Monto de depósito',
  'analyze.title.SMSLog': 'Registro de SMS',
  'analyze.title.loginSMSStatistics': 'Estadísticas de SMS de inicio de sesión',
  'analyze.title.registrationSMSStatistics': 'Estadísticas de SMS de registro',
  'analyze.title.numberApplications': 'Cantidad de aplicaciones',
  'analyze.title.numberSuccessfulBackfills': 'Cantidad de rellenos exitosos',
  'analyze.title.backfillSuccessRate': 'Cantidad de rellenos exitosos',
  'analyze.title.backfillFailureCount': 'Cantidad de rellenos fallidos',
  'analyze.title.backfillFailureRate': 'Tasa de fallo de relleno invertido',

  'common.bonus.vipRewardType1': 'Recompensas por actualización',
  'common.bonus.vipRewardType2': 'Recompensas consecutivas',
  'common.bonus.vipRewardType3': 'Recompensas de cumpleaños',
  'common.bonus.vipRewardType4': 'Fondos de rescate de tragamonedas',
  'common.bonus.vipRewardType5': 'Fondos de rescate de casino en vivo',
  'common.bonus.vipRewardType6': 'Fondos de rescate deportivos',
  'common.bonus.vipRewardType7': 'Fondos de rescate de lotería',
  'common.bonus.vipRewardType8': 'Fondos de rescate de pesca',
  'common.bonus.vipRewardType9': 'Fondos de rescate de juegos de cartas',
  'common.bonus.vipRewardType10': 'Fichas gratis H5',
  'common.bonus.vipRewardType11': 'Salario semanal',
  'common.bonus.vipRewardType12': 'Salario mensual',
  'common.bonus.vipRewardType13': 'Fichas gratis PC',
  'common.bonus.vipRewardType14': 'Recompensas de rueda de la suerte',
  'common.bonus.vipRewardType15': 'Punto',
  'common.bonus.vipRewardType16': 'Fichas gratis APP',
  'common.bonus.vipRewardType17': 'Fichas gratis PWA',
  'common.bonus.vipLevelBonusName': '{vipLevel}{bonusName}',
  'common.bonus.profitLoss': 'Recompensa de ganancia y pérdida',
  'common.title.expirationDay': 'Expiración/Día',
  'common.title.flowIssued': 'Flujo emitido',
  'common.title.sufficientDeposit': 'Depósito suficiente',
  'common.title.grant': 'Otorgar',
  'common.title.usersSendComments': 'Los usuarios envían comentarios',
  'front.vip.level': 'Beneficios de nivel {0}',
  'front.vip.up': 'Bonificación de promoción {0}',
  'front.vip.upMsg1': 'No hay bonificación de promoción disponible para reclamar.',
  'front.vip.upMsg2': 'La bonificación de promoción del nivel actual ya ha sido reclamada',
  'front.vip.birthday': 'Bonificación de cumpleaños {0}',
  'front.vip.birthdayMsg1': 'Actualmente no hay bonificación de cumpleaños para reclamar',
  'front.vip.birthdayMsg2': 'Ingrese su fecha de nacimiento',
  'front.vip.birthdayMsg3': 'Reclamación fallida, el período de reclamación de bonificación de cumpleaños ha expirado.',
  'front.vip.birthdayMsg4': 'La bonificación de cumpleaños de este año al nivel actual ya ha sido reclamada.',
  'front.vio.depositMsg1': 'Ya ha reclamado esta bonificación, por favor deposite nuevamente.',
  'front.vio.depositMsg2': 'Por favor deposite primero, luego reclame la bonificación.',
  'front.vio.depositMsg3': 'No hay bonificación de depósito de nivel VIP disponible para reclamar en este momento.',
  'front.vio.depositMsg4': 'No hay bonificaciones disponibles para reclamar.',
  'sys.oneBuyCouponTimes': 'Cupón de un yuan',
  'sys.enterOneBuyCouponTimes': 'Ingrese la cantidad de cupones de recompensa de compra de un yuan',

  'common.userPoint.noEnough': 'El miembro no tiene suficientes puntos',
  'user.title.addPointSuccess': 'Modificación de puntos exitosa. ',
  'user.title.addPointError': 'Operación de modificación de puntos fallida. ',
  'user.title.addPoint': 'Modificar puntos del miembro',
  'user.title.increasePoint': 'Agregar puntos',
  'user.title.decreasepoint': 'Deducir puntos',
  'sys.enterPreferentialPoint': 'Ingrese la cantidad de puntos',
  'sys.PreferentialPoint.msg': 'Cantidad de puntos',

  'menu.yygCoupon': 'Cupón',
  'push.msg.config.typeOnebuy': 'Un yuan',
  'sys.msgDepositPage': 'Depósito mínimo: {minDeposit}',
  'admin.bonus.depositPageBonus': 'Bonificación de depósito en página de recarga, {date}',

  'sys.title.verificationRequestTime': 'Hora de solicitud de verificación',
  'sys.title.numberVerificationFailures': 'Cantidad de fallos de verificación',
  'sys.title.timeIncorrectPasswordInput': 'Hora de entrada de contraseña incorrecta',
  'sys.title.numberIncorrectPasswords': 'Cantidad de contraseñas incorrectas',
  'sys.title.loginRequestTime': 'Hora de solicitud de inicio de sesión',
  'sys.title.numberLoginRequests': 'Cantidad de solicitudes de inicio de sesión',
  'sys.title.restrictionMethod': 'Método de restricción',
  'sys.title.IPBlacklist': 'Lista negra de IP',
  'sys.title.deviceBlacklist': 'Lista negra de dispositivo',
  'sys.title.loginRestriction': 'Restricción de inicio de sesión',
  'admin.onebuy.type.return': 'Reembolso',
  'admin.onebuy.name.return': 'Reembolso de compra de un yuan',

  'sys.title.blindBoxConfiguration': 'Configuración de caja ciega',
  'sys.title.dailyOpeningTimes': 'Horarios de apertura diaria de caja ciega',
  'sys.title.dayTime': 'Hora de apertura diaria',
  'sys.title.dailyBlindBoxDrawLimit': 'Límite de sorteo de caja ciega diaria',
  'sys.title.rebateRatio': 'Ratio de reembolso',
  'sys.title.weight': 'Peso',
  'sys.title.orAbove': 'O superior',
  'sys.title.depositsAndBet': 'Depósitos y apuestas',
  'sys.title.maximumIssuance': 'Emisión máxima',


  'sys.title.setCashWheel': 'Establecer rueda de efectivo',
  'sys.title.timePeriod': 'Período de tiempo',
  'sys.title.activityRewardAmount': 'Monto de recompensa de actividad',
  'sys.title.directCashWithdrawalNotPossible': 'No es posible retiro directo en efectivo',
  'sys.title.initialAmountFirstLotteryDraw': 'Monto de inicialización de primer sorteo de lotería',
  'sys.title.numberDraws': 'Cantidad de sorteos',
  'sys.title.falseWithdrawalInformation': 'Información de retiro falsa',
  'sys.title.realWithdrawalInformation': 'Información de retiro real',
  'sys.title.uploadAwardImage': 'Cargar imagen de premio',
  'sys.title.addAwards': 'Agregar premios',
  'sys.title.conditionSettings': 'Configuración de condición',
  'sys.title.validNumberInvitations': 'Cantidad válida de invitaciones',
  'sys.title.giveawayDraw': 'Sorteo de regalo',
  'sys.title.taskDescription': 'Descripción de la tarea',
  'sys.title.depositBonus': 'Bonificación de depósito',
  'sys.title.numberDeposits': 'Cantidad de depósitos',
  'sys.title.amountCannotLessThan': 'Cada monto no puede ser menor que',
  'sys.title.downloadAPPLoginReward': 'Recompensa de inicio de sesión de descarga de APP',
  'sys.title.downloadAPPLogDraw': 'Descargue APP e inicie sesión para sorteo de regalo',
  'sys.title.withdrawalRestrictions': 'Restricciones de retiro',
  'sys.title.amountMustDepositRequirement': 'El retiro completo del monto de bonificación debe cumplir con el depósito',
  'sys.title.ifNotMetReduce': 'Reducir si no se cumple',
  'sys.title.activityRules': 'Descripción de reglas de actividad',
  'sys.title.lotteryRecords': 'Registro de lotería',
  'sys.title.firstFewDraws': 'Cantidad de sorteos',
  'sys.title.lotteryResults': 'Resultados de la lotería',
  'sys.title.amountAfterChange': 'Monto después del cambio',
  'sys.title.completed': 'Completado',
  'sys.title.numberAssistsRecorded': 'Cantidad de registro de asistencias',
  'sys.title.assistTime': 'Hora de asistencia',
  'sys.title.numberLotteryDraws': 'Cantidad de sorteos de asistencia',
  'sys.title.withdrawalRecord': 'Registro de retiro',
  'sys.title.withdrawalTime': 'Hora de retiro',
  'sys.title.withdrawalAmount': 'Monto de retiro',
  'sys.title.withdrawalRatio': 'Ratio de retiro',
  'sys.title.meetDepositRequirements': 'Si se cumplen los requisitos de depósito',
  'sys.title.timeSettings': 'Configuración de hora',
  'sys.title.addFalseWithdrawalInformation': 'Agregar información de retiro falsa',
  'common.bonus.systemGive': 'Regalo del sistema',
  'common.bonus.deposit': 'Completar recarga',
  'common.bonus.appLogin': 'Recompensas de inicio de sesión de APP',
  'common.bonus.invite': 'Invitar {count} amigos',
  'sys.rolemanagement.rolename': 'Nombre de rol',
  'sys.rolemanagement.rolenote': 'Nota de rol',
  'sys.rolemanagement.issuper': 'Superusuario',
  'sys.rolemanagement.rolewarnning': 'Por favor seleccione al menos un elemento de menú',
  'sys.rolemanagement.menus.tree': 'Menú de permisos',
  'sys.rolemanagement.editTitle': 'Modificar rol',
  'userDomain.title.status': 'Estado',
  'userDomain.status.enabled': 'Habilitado',
  'userDomain.status.disabled': 'Deshabilitado',
  'sys.row.title': 'Número de fila',
  'sys.user.name': 'Cuenta de usuario',
  'sys.user.use': 'Persona que usa',
  'sys.user.selectRole': 'Seleccionar rol',
  'sys.user.selectRolePlaceholder': 'Seleccione rol',
  'sys.user.status': 'Estado',
  'sys.user.selectStatusPlaceholder': 'Seleccione estado',
  'sys.user.enabled': 'Habilitado',
  'sys.user.disabled': 'Deshabilitado',
  'sys.role.delete1': 'Para evitar errores, por favor deshabilite antes de eliminar',
  'sys.role.delete2': 'Hay {count} cuentas de usuario usando este permiso de rol',
  'sys.role.delete3': '¿Está seguro de que desea eliminar este rol?',
  'game.gameTypeMgmt.column.title.index': 'Secuencia',
  'game.gameTypeMgmt.column.title.gameGroupName': 'Tipo de juego',
  'game.gameTypeMgmt.column.title.gameDefaultSort': 'Ordenamiento de juego',
  'game.gameTypeMgmt.column.title.gameGroupPcImg': 'Imagen sin seleccionar de PC',
  'game.gameTypeMgmt.column.title.gameGroupH5Img': 'Imagen sin seleccionar de H5',
  'game.gameTypeMgmt.column.title.gameGroupAppImg': 'Imagen sin seleccionar de aplicación',
  'game.gameTypeMgmt.column.title.gameGroupPcImgEnlarge': 'Imagen seleccionada de PC',
  'game.gameTypeMgmt.column.title.gameGroupH5ImgEnlarge': 'Imagen seleccionada de H5',
  'game.gameTypeMgmt.column.title.gameGroupAppImgEnlarge': 'Imagen seleccionada de aplicación',
  'game.gameTypeMgmt.column.title.gameStatus': 'Habilitar',
  'game.gameTypeMgmt.column.title.operator': 'Operador',
  'game.gameTypeMgmt.column.title.operateTime': 'Hora del operador',
  'game.gameTypeMgmt.column.title.operateAction': 'Acción',
  'game.gamePlatformMgmt.column.title.index': 'Índice',
  'game.gamePlatformMgmt.column.title.gamePlatformName': 'Nombre de plataforma de juego',
  'game.gamePlatformMgmt.column.title.gameFullName': 'Nombre completo del juego',
  'game.gamePlatformMgmt.column.title.gameShowName': 'Nombre mostrado del juego',
  'game.gamePlatformMgmt.column.title.gamePlatformCode': 'Código de plataforma de juego',
  'game.gamePlatformMgmt.column.title.gameType': 'Tipo de juego',
  'game.gamePlatformMgmt.column.title.percent': 'Porcentaje',
  'game.gamePlatformMgmt.column.title.status': 'Estado',
  'game.gamePlatformMgmt.column.title.desc': 'Descripción',
  'game.gamePlatformMgmt.column.title.gameCount': 'Cantidad de juegos',
  'game.gamePlatformMgmt.column.title.action': 'Operar',
  'game.gamePlatformMgmt.editconfig': 'Configuración de juego',
  'game.gameListMgmt.column.title.index': 'Índice',
  'game.gameListMgmt.column.title.gamePlatformName': 'Nombre de plataforma',
  'game.gameListMgmt.column.title.gameName': 'Nombre del juego',
  'game.gameListMgmt.column.title.rpt.recommendRate': 'RPT oficial',
  'game.gameListMgmt.column.title.rpt.showRate': 'Intervalo de visualización de RPT',
  'game.gameListMgmt.column.title.rpt.boostRate': 'Valor estimado potenciado',
  'game.gameListMgmt.column.title.winPlayerRange': 'Rango de jugador ganador',
  'game.gameListMgmt.column.title.player30MinRange': 'Rango de jugador de 30 minutos',
  'game.gameListMgmt.column.title.maxPrizeRange': 'Rango de premio máximo',
  'game.gameListMgmt.placeholder.minPlayerCount': 'Cantidad mínima de jugadores',
  'game.gameListMgmt.placeholder.maxPlayerCount': 'Cantidad máxima de jugadores',
  'game.gameListMgmt.placeholder.minAmount': 'Monto mínimo',
  'game.gameListMgmt.placeholder.maxAmount': 'Monto máximo',
  'game.gameListMgmt.validation.positiveIntegerOnly': 'Ingrese un número entero positivo',
  'game.gameListMgmt.validation.maxValueExceeded': 'El valor no puede exceder 2,147,483,647',
  'game.gameListMgmt.validation.maxPrizePairIncomplete': 'Los valores mín y máx deben completarse juntos',
  'game.gameListMgmt.column.title.gameFullName': 'Plataforma de juego',
  'game.gameListMgmt.column.title.gameCode': 'código de juego',
  'game.gameListMgmt.column.title.gameType': 'tipo de juego',
  'game.gameListMgmt.column.title.currency': 'moneda',
  'game.gameListMgmt.column.title.gamePcImg': 'imagen PC',
  'game.gameListMgmt.column.title.gameH5Img': 'imagen H5',
  'game.gameListMgmt.column.title.gameAppImg': 'imagen App',
  'game.disable': '¿estás seguro de que quieres desactivar?',
  'game.enable': '¿estás seguro de que quieres activar?',
  'common.tradeId' : 'ID de transacción',
  'common.enterTradeId' : 'Ingresa el ID de transacción',
  'activity.activityMgmt.column.title.index': 'código de promoción',
  'activity.activityMgmt.column.name': 'nombre de promoción',
  'activity.activityMgmt.column.multiType': 'categoría de promoción',
  'activity.activityMgmt.column.templateType': 'plantilla de promoción',
  'activity.activityMgmt.column.lang': 'idioma',
  'activity.activityMgmt.column.status': 'estado de promoción',
  'activity.activityMgmt.column.showTime': 'tiempo efectivo de promoción',
  'activity.activityMgmt.column.enableTime': 'tiempo efectivo de promoción',
  'activity.activityMgmt.column.sort': 'ordenar',
  'activity.activityMgmt.column.action': 'acción',
  'clientInfo.displayIcon': 'icono de visualización',
  'clientInfo.contactUs': 'contáctanos',

  'sys.resetGoogleAuthPassword': 'Restablecer código de verificación de Google',
  'sys.confirmGoogleAuthPassword': '¿confirmar restablecer código de verificación de Google?',
  'sys.googleAuth': 'código de verificación de Google',
  'sys.googleAuth.val': 'ingresa el código de verificación de Google',

  'game.show.type': 'método de visualización',
  'game.show.type.input': 'selecciona el método de visualización',

  // Website configuration translations
  'webConfig.depositTurnoverMultiplier': 'multiplicador de volumen de depósito',
  'webConfig.saveSuccess': 'guardado exitoso',
  'webConfig.updateSuccess': 'actualización exitosa',
  'webConfig.disableSuccess': 'desactivación exitosa',
  'webConfig.enableSuccess': 'activación exitosa',
  'webConfig.deleteSuccess': 'eliminación exitosa',

  // Payment withdrawal configuration translations
  'payWithdraw.autoApproval': 'si el control de riesgo aprueba automáticamente los retiros',
  'payWithdraw.withdrawPassword': 'si el retiro requiere autenticación de contraseña de retiro',
  'payWithdraw.bankCard': 'tarjeta bancaria',
  'payWithdraw.config.title': 'configuración de depósito y retiro',
  'payWithdraw.save': 'guardar',
  'payWithdraw.basicConfig': 'configuración básica de retiro',
  'payWithdraw.accountBindConfig': 'configuración de vinculación de cuenta de retiro',
  'payWithdraw.disabled': 'desactivado',
  'payWithdraw.enabled': 'activado',
  'payWithdraw.bindableAccountCount': 'cantidad de cuentas vinculables',
  'payWithdraw.bindableAccountCountInvalid': 'la cantidad de cuentas vinculables debe ser mayor o igual a 1',
  'payWithdraw.updateSuccess': 'actualización exitosa',
  'payWithdraw.formValidationFailed': 'validación del formulario fallida',
  'payWithdraw.vipRange': 'nivel VIP',
  'payWithdraw.addRange': 'agregar rango',
  'payWithdraw.deleteRange': 'eliminar',
  'payWithdraw.vipRangeTips': 'configura cantidades de cuentas vinculables por rango VIP (inicio y fin inclusive)',
  'payWithdraw.vipRangeOverlap': 'los rangos VIP no pueden superponerse',
  'payWithdraw.vipRangeInvalid': 'el inicio del rango VIP no puede ser mayor que el final',
  'payWithdraw.vipRangeContinuous': 'el nuevo rango debe comenzar inmediatamente después del rango anterior',
  'payWithdraw.vipRangeMaxReached': 'ya cubierto hasta VIP31, no se pueden agregar más rangos',

  // Withdrawal verification configuration internationalization
  'payWithdraw.withdraw_verification_mobile': 'si el retiro requiere verificación de teléfono móvil',
  'payWithdraw.withdraw_verification_real_name': 'si el retiro requiere verificación de nombre real',
  'payWithdraw.withdraw_verification_card_valid': 'si el retiro requiere fecha de vencimiento de tarjeta bancaria',
  'payWithdraw.withdraw_verification_email': 'si el retiro requiere verificación de correo electrónico',
  'payWithdraw.withdraw_verification_withdraw_pwd': 'si el retiro requiere verificación de contraseña de retiro',
  'payWithdraw.withdraw_verification_login_pwd': 'verificar contraseña de inicio de sesión al vincular cuenta de retiro',
  'payWithdraw.withdraw_maya_auth': 'autorización de retiro Maya',

  // Account binding configuration internationalization
  'payWithdraw.bind_USDT': 'USDT',
  'payWithdraw.bind_bank': 'tarjeta bancaria',
  'payWithdraw.bind_cashapp': 'CashApp',
  'payWithdraw.bind_chime': 'Chime',
  'payWithdraw.bind_zelle': 'Zelle',
  'payWithdraw.bind_paypal': 'PayPal',
  'payWithdraw.bind_ach': 'ACH',
  'payWithdraw.bind_Grabpay': 'Grabpay',
  'payWithdraw.bind_Gcash': 'Gcash',
  'payWithdraw.bind_Paymaya': 'Paymaya',

  // Notice component internationalization
  'notice.soundSettings': 'configuración de sonido',
  'notice.withdrawSoundPrompt': 'aviso de sonido de retiro',
  'notice.kycSoundPrompt': 'aviso de sonido de KYC',
  'notice.close': 'cerrar',

  // Member Detail Modal
  'memberDetail.modal.title': 'detalles del miembro - {memberAccount}',

  // Product Category
  'product.category.cash': 'efectivo',
  'product.category.props': 'props',
  'product.category.product': 'producto físico',
  'product.category.unknown': 'tipo desconocido',

  // ==================== Deposit/Withdraw/Promo Leaderboard ====================
  // Menu
  'menu.userRanking': 'clasificación de miembros',
  'menu.depositLeaderboard': 'tabla de depósitos',
  'menu.withdrawLeaderboard': 'tabla de retiros',
  'menu.promoLeaderboard': 'tabla de promociones',

  // Leaderboard page titles
  'leaderboard.depositTitle': 'tabla de depósitos',
  'leaderboard.withdrawTitle': 'tabla de retiros',
  'leaderboard.promoTitle': 'tabla de promociones',

  // Table columns
  'leaderboard.rank': 'posición',
  'leaderboard.userAccount': 'cuenta de miembro',
  'leaderboard.nickname': 'apodo',
  'leaderboard.realName': 'nombre real',
  'leaderboard.mobile': 'móvil',
  'leaderboard.vipLevel': 'nivel VIP',
  'leaderboard.currency': 'moneda',

  // Deposit leaderboard fields
  'leaderboard.depositAmount': 'depósito total',
  'leaderboard.depositCount': 'cantidad de depósitos',
  'leaderboard.avgDeposit': 'depósito promedio',
  'leaderboard.maxDeposit': 'depósito máximo',
  'leaderboard.lastDepositTime': 'último depósito',

  // Withdrawal leaderboard fields
  'leaderboard.withdrawAmount': 'retiro total',
  'leaderboard.withdrawCount': 'cantidad de retiros',
  'leaderboard.avgWithdraw': 'retiro promedio',
  'leaderboard.maxWithdraw': 'retiro máximo',
  'leaderboard.lastWithdrawTime': 'último retiro',

  // Promotion leaderboard fields
  'leaderboard.promoClaimCount': 'cantidad de promociones reclamadas',
  'leaderboard.promoAmount': 'cantidad de promoción',
  'leaderboard.promoPoints': 'puntos de promoción',
  'leaderboard.lastPromoTime': 'última promoción',
  'leaderboard.clickToSort': 'haz clic para ordenar por este campo',

  // Time period
  'leaderboard.periodLabel': 'período',
  'leaderboard.today': 'hoy',
  'leaderboard.todayRealtime': 'hoy en tiempo real',
  'leaderboard.yesterday': 'ayer',
  'leaderboard.lastWeek': 'semana pasada',
  'leaderboard.lastMonth': 'mes pasado',
  'leaderboard.hourly': 'hoy en tiempo real',
  'leaderboard.periodDaily': 'tabla de ayer',
  'leaderboard.periodWeekly': 'tabla de semana pasada',
  'leaderboard.periodMonthly': 'tabla de mes pasado',
  'leaderboard.periodHourly': 'tabla de hoy en tiempo real',

  // Statistics field
  'leaderboard.sortField': 'campo de estadísticas',
  'leaderboard.selectSortField': 'selecciona campo de estadísticas',

  // Placeholders
  'leaderboard.userAccountPlaceholder': 'ingresa cuenta de miembro',
  'leaderboard.nicknamePlaceholder': 'ingresa apodo',
  'leaderboard.realNamePlaceholder': 'ingresa nombre real',
  'leaderboard.mobilePlaceholder': 'ingresa número de móvil',

  // ==================== Win/Loss/Bet Leaderboard ====================
  // Form fields
  'leaderboard.periodType': 'tipo de período',
  'leaderboard.periodTypeRequired': 'selecciona tipo de período',
  'leaderboard.selectPeriodType': 'selecciona tipo de período',
  'leaderboard.currencyRequired': 'selecciona moneda',
  'leaderboard.selectCurrency': 'selecciona moneda',
  'leaderboard.enterUserAccount': 'ingresa cuenta de miembro',
  'leaderboard.selectVipLevel': 'selecciona nivel VIP',

  // Win/Loss/Bet leaderboard fields
  'leaderboard.netProfit': 'ganancia neta',
  'leaderboard.netLoss': 'pérdida neta',
  'leaderboard.validBet': 'apuesta válida',
  'leaderboard.profitRate': 'tasa de ganancia',
  'leaderboard.lossRate': 'tasa de pérdida',
  'leaderboard.betCount': 'cantidad de apuestas',
  'leaderboard.lastBetTime': 'última apuesta',

  // Leaderboard export and hints
  'leaderboard.naturalTimeCycleHint': 'tabla calculada por ciclo de tiempo natural (no por tiempo móvil)',
  'leaderboard.exportSubmitSuccess': 'tarea de exportación enviada, revisa "descarga de archivo" más tarde',
  'leaderboard.exportFailed': 'exportación fallida, intenta más tarde',

  // Hourly leaderboard
  'leaderboard.statsDate': 'fecha de estadísticas',
  'leaderboard.statsHour': 'hasta la hora',
  'leaderboard.selectStatsDate': 'selecciona fecha de estadísticas',
  'leaderboard.selectStatsHour': 'selecciona hasta la hora',
  'leaderboard.statsDateRequired': 'selecciona fecha de estadísticas',
  'leaderboard.statsHourRequired': 'selecciona hasta la hora',
  'leaderboard.hourlyHint': 'muestra datos de ranking acumulativo desde las 00:00 hasta la hora seleccionada',
  'leaderboard.hourlyDataUpdatedAt': 'datos actualizados hasta las {hour}',

  // Game Ranking
  'gameRanking.title': 'clasificación de juegos',
  'gameRanking.gameName': 'nombre del juego',
  'gameRanking.gameNamePlaceholder': 'ingresa nombre del juego',
  'gameRanking.gameId': 'ID de juego',
  'gameRanking.gameIdPlaceholder': 'ingresa ID de juego',
  'gameRanking.gameVendor': 'proveedor de juego',
  'gameRanking.gameVendorPlaceholder': 'ingresa proveedor de juego',
  'gameRanking.gameShowName': 'nombre de visualización',
  'gameRanking.rank': 'posición',
  'gameRanking.betUserCount': 'usuarios que apostaron',
  'gameRanking.betCount': 'cantidad de apuestas',
  'gameRanking.betAmount': 'cantidad apostada',
  'gameRanking.winUserCount': 'cantidad de ganadores',
  'gameRanking.playerWinAmount': 'ganancia del jugador',
  'gameRanking.playerLossAmount': 'pérdida del jugador',
  'gameRanking.platformNetAmount': 'ganancia de plataforma',
  'gameRanking.avgBetAmount': 'cantidad apostada promedio',
  'gameRanking.avgBetCount': 'cantidad de apuestas promedio',
  'gameRanking.avgPlatformNet': 'ganancia de plataforma promedio',
  'gameRanking.dataHint': 'rango de datos: hoy en tiempo real (acumulativo por hora)/ayer/último lunes a domingo/último mes 1ero al último día (período de tiempo natural)',
};
